import { LEAGUE_GROUPS } from "../lib/leagueGroups";
import React, { useState, useEffect, useRef, useMemo } from "react";
import { SharedTeamApplier } from "./SharePage";
import { legacyPath } from "../lib/prettyUrls";
import { hydrateTimePrefs } from "../lib/timePrefs";
import { useInboxBadge } from "../lib/appShell";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { Radio, Wand2, LogIn, LogOut, User, Instagram, ChevronDown, Briefcase, Crown, Settings, Smartphone, Tablet, Monitor, RotateCw, Home, Globe, List, Users, BarChart3, Newspaper, MessageSquare, Video, Map, Mail, Music2, Twitter, Eye, EyeOff, Shield, Search, Share2, Youtube, Palette, LayoutDashboard, ListOrdered, Calendar, DollarSign, ClipboardList, PieChart, ArrowLeftRight, Shuffle, LayoutGrid, Medal, UserCog, Trophy, BookOpen, Sparkles, TrendingUp, Star, Award, Atom, Grid3x3, HelpCircle, Lock, X, Plus, Maximize2, Minimize2, ChevronsUpDown, ChevronsDownUp, ChevronsLeftRight, ChevronsRightLeft, ScrollText, Pin, Hammer, Puzzle, Move, Scissors, Bug , Gavel, Scale, UserCircle, MonitorDown, RefreshCw, CalendarClock, CalendarRange, CalendarDays } from "lucide-react";
import { addBrowserApp } from "./InstallPrompt";
import { useAuth } from "../lib/AuthContext";
import { getSettings, assetUrl, siteLogoUrl, trackPageView, getTeams, getAccount, updateAccount, getNavConfig, saveNavLayout, savePwhlTabOrder, saveForcedKeybinds, getLeaguesDirectory, getLeagueTeams, getPlayers, getCountries, saveContentScales, api } from "../lib/api";
import { CardSizeBtn, LeagueSortChips } from "./schedule/CardSize";
import { useNavBoard, useNavToggleLayout, isPageKey } from "./NavToggleBoard";
import { ChangelogBody } from "../pages/Changelog";
import { useGameDelay } from "../lib/useGameDelay";
import { publishAccess } from "../lib/accessStore";
import { usePinMode, setPinMode } from "../lib/pinMode";
import { useHasSegs } from "../lib/segRegistry";
import { DELAY_STEPS, DELAY_LABEL } from "./admin/NotificationsAdmin";
const NAV_DISPLAY = new Set(["disp_theme", "disp_wide", "disp_full", "disp_page", "disp_nav", "disp_device", "disp_profiles", "navhide", "navextend", "borders", "arrange", "arrange_reset"]);
import { applySurf, useFavourite, toggleMultiVal, isFavPage } from "../lib/useFavourite";
import { useNotifPick } from "../lib/useNotifPick";
import { StudioPopupHost, openStudioPopup } from "./StudioPopupHost";
import { Bell, HardDrive, Target, SlidersHorizontal, PoundSterling, Disc3, Clock, Columns3, FileText, ArrowUpDown, Waves, ZoomIn, ZoomOut, PanelTop, Bookmark, MonitorCog, Wrench, FoldHorizontal, UnfoldHorizontal, Clapperboard, LayoutTemplate, MoveHorizontal, RectangleHorizontal, Sun, Moon, Gamepad2, ListChecks, Dices, Layers, Rss } from "lucide-react";
import { setTheme, useTheme, IS_PREVIEW, LIGHT_LOGO } from "../lib/theme";
import { LeaguesAccessButton, ScheduleDeepLinks } from "./LeaguesModal";
import { MyAccountModal, AccountNavButton, openAccountModal, closeAccountModal } from "./MyAccountModal";
import { useInboxCounts } from "../lib/useInboxCounts";
import { arrangeSections, useNavStructure } from "../lib/navStructure";
import { AccountNavPanel, OWNER_TOOLS_COLOR, ACCOUNT_COLOR } from "./AccountNav";
import { OwnerToolModal, openOwnerTool } from "./OwnerToolModal";
import { useDeviceView } from "../lib/DeviceViewContext";
import { MobileNavProvider, useMobileNav } from "../lib/MobileNavContext";
import { SortByTeamProvider, useSortByTeam, TEAM_GROUP } from "../lib/SortByTeamContext";
import { useNavExtended, setNavExtended } from "../lib/navExtended";
import { useAdminMode } from "../lib/AdminModeContext";
import { useBusinessMode } from "../lib/BusinessModeContext";
import { useCreatorMode } from "../lib/CreatorModeContext";
import { useFavourites } from "../lib/FavouritesContext";
import { useTour } from "../lib/TourContext";
import { useLeague } from "../context/LeagueContext";
import { usePagePrefs } from "../lib/PagePrefs";
import { NcaaSurfBlock, NCAA_BLUE } from "./NcaaSurfBlock";
import { useShiftHold } from "../lib/useShiftHold";
import { MobileBottomNav } from "./MobileBottomNav";
import CookieNotice from "./CookieNotice";
import LegalGate from "./LegalGate";
import { PwhlTeamButtons } from "./PwhlTeamButtons";
import GameCentreNavBar from "./GameCentreNavBar";
import { GameNavProvider, useGameNav } from "../context/GameNavContext";
import GlobalSearch from "./GlobalSearch";
import RoadmapAlerts from "./RoadmapAlerts";
import RoadmapPageOverlay from "./RoadmapPageOverlay";
import { useRoadmapView, setRoadmapView } from "../lib/useRoadmapView";
import { useChangelogView, setChangelogView, useChangelogSeen, markAreaSeen } from "../lib/useChangelogView";
import { getRoadmap, getAuditAreaCounts, getAuditLogs } from "../lib/api";
import { termsPending } from "./account/UserSetup";
import { roadmapCountsByPage } from "../lib/roadmapPages";
import { toast } from "sonner";
import { INT_COL } from "../lib/storiesReal";
import { useFavLeague } from "../lib/useFavLeague";
import { orderTeams, orderedTeamIdsForSeason, TEAM_INFO } from "../lib/teamMap";
import { TeamBadge } from "./TeamBadge";
import NcaaTeamStrip from "./NcaaTeamStrip";
import { Flag } from "./Flag";
import { NCAA_CONFERENCES, NCAA_COLLEGES } from "../lib/ncaaData";
import { TAB_PATHS, PATH_TABS, TEAM_SCOPED, tabFromLocation } from "../lib/teamsRoutes";
import { pwhlConfOf } from "../lib/pwhlConferences";

// Wide Rosterly brand logo (used when logo_mode === "brand_logo").
const ROSTERLY_BRAND_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_55cdd8b1-1e82-41a5-9c9d-99f91ee0f93d/artifacts/ok5qhrl0_ChatGPT%20Image%20Sep%2022%2C%202026%2C%2012_56_07%20PM.png";
function BrandImg(props) { const t = useTheme(); return <img src={t === "light" ? LIGHT_LOGO : ROSTERLY_BRAND_LOGO} {...props} />; }

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    {
        label: "PWHL",
        to: "/standings",
        children: [
            { to: "/team-pages", label: "Overview" },
            { to: "/standings", label: "Standings" },
            { to: "/schedule", label: "Schedule" },
            { to: "/team-leaderboards", label: "Leaderboards" },
            { to: "/contracts", label: "Contracts" },
            { to: "/team-draft", label: "Draft" },
            { to: "/team-demographics", label: "Demographics" },
            { to: "/team-movements", label: "History" },
            { to: "/injuries", label: "Injuries" },
            { to: "/discipline", label: "Discipline" },
            { to: "/staff-moves", label: "Staff Moves" },
            { to: "/team-trades", label: "Trades" },
            { to: "/rosters", label: "Active Roster" },
            { to: "/active-lineup", label: "Active Lineup" },
            { to: "/team-records", label: "Records" },
            { to: "/staff", label: "Staff" },
            { to: "/team-news", label: "News" },
            { to: "/team-videos", label: "Videos" },
        ],
    },
    { to: "/packs", label: "Pucks", iconOnly: true },
    {
        label: "Media",
        to: "/news",
        children: [
            { to: "/news", label: "News" },
            { to: "/videos", label: "Videos" },
        ],
    },
    { to: "/socials", label: "Socials" },
];

// Consolidated "Socials" dropdown — one nav button with a 3rd-level subnav.
// Children are computed dynamically from Admin → Social links (grouped by
// platform, greyed out when no link is set).
const SOCIALS_NAV = {
    label: "Socials",
    socials: true,
    children: [
        { label: "News", to: "/socials/news" },
        { label: "Instagram", to: "/socials" },
        { label: "YouTube", to: "/socials/videos" },
        { label: "Contact Us", to: "/contact" },
    ],
};

// Brand glyphs (lucide has no official X / Discord / TikTok marks).
const XIcon = ({ className }) => (<svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true"><path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.9l-5.4-7.06L4.5 22H1.24l8.02-9.17L1 2h7.05l4.88 6.45L18.244 2zm-1.21 18h1.9L7.05 4h-2.04l12.02 16z" /></svg>);
const DiscordIcon = ({ className }) => (<svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true"><path d="M20.317 4.369A19.79 19.79 0 0016.558 3c-.2.36-.43.85-.59 1.23a18.27 18.27 0 00-5.94 0C9.87 3.85 9.63 3.36 9.43 3a19.74 19.74 0 00-3.76 1.37C2.5 8.06 1.7 11.64 2.05 15.18a19.9 19.9 0 006.06 3.06c.49-.67.93-1.38 1.3-2.13-.71-.27-1.39-.6-2.03-.99.17-.13.34-.26.5-.4a14.2 14.2 0 0012.24 0c.16.14.33.27.5.4-.64.39-1.32.72-2.03.99.37.75.81 1.46 1.3 2.13a19.87 19.87 0 006.06-3.06c.42-4.1-.72-7.65-3.62-10.81zM9.35 13.79c-1.18 0-2.15-1.09-2.15-2.42 0-1.34.95-2.42 2.15-2.42 1.2 0 2.17 1.09 2.15 2.42 0 1.33-.95 2.42-2.15 2.42zm5.3 0c-1.18 0-2.15-1.09-2.15-2.42 0-1.34.95-2.42 2.15-2.42 1.2 0 2.17 1.09 2.15 2.42 0 1.33-.95 2.42-2.15 2.42z" /></svg>);
const TikTokIcon = ({ className }) => (<svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true"><path d="M12.53 2h3.02c.16 1.02.55 1.94 1.16 2.72.72.92 1.75 1.55 2.99 1.79v3.06a7.3 7.3 0 01-4.13-1.35v6.03c0 3.2-2.34 5.75-5.44 5.75-3.09 0-5.44-2.55-5.44-5.75 0-3.13 2.26-5.66 5.28-5.75.16 0 .32.01.48.02v3.1a2.63 2.63 0 00-.48-.05 2.66 2.66 0 00-2.6 2.68c0 1.5 1.15 2.68 2.6 2.68 1.46 0 2.6-1.18 2.6-2.68V2z" /></svg>);

// Icon per top-level nav label (icon-above-label PC nav design).
export const NAV_ICONS = {
    Home,
    PWHL: List,
    Teams: Users,
    Insights: BarChart3,
    Leagues: Globe,
    Media: Newspaper,
    News: Newspaper,
    Video: Video,
    Videos: Video,
    Roadmap: Map,
    Chat: MessageSquare,
    Socials: MessageSquare,
};
// Icon per PWHL sub-tab (Nav Bar 2) — keyed by the ?tab= value.
export const PWHL_TAB_ICONS = {
    overview: LayoutDashboard,
    standings: ListOrdered,
    schedule: Calendar,
    leaderboards: BarChart3,
    contracts: DollarSign,
    draft: ClipboardList,
    demographics: PieChart,
    transfers: ArrowLeftRight,
    trades: Shuffle,
    players: Users,
    roster: LayoutGrid,
    records: Medal,
    staff: UserCog,
    news: Newspaper,
    videos: Video,
};
const pwhlTabKey = (to = "") => {
    const path = "/" + (to.split("?")[0].split("/")[1] || "");
    if (PATH_TABS[path]) return PATH_TABS[path];
    const q = to.split("?")[1] || "";
    return new URLSearchParams(q).get("tab") || "standings";
};

// Icon per Insights route (Nav Bar 2 for the Insights section) — keyed by path.
export const INSIGHTS_TAB_ICONS = {
    "/records": Trophy,
    "/milestones": Trophy,
    "/stories": BookOpen,
    "/insights": Sparkles,
    "/trends": TrendingUp,
    "/rankings": Star,
    "/awards": Award,
    "/chemistry": Atom,
    "/positions": Grid3x3,
};

// The unified PWHL "Nav Bar 2" — Overview is a big standalone button; the rest
// are grouped into SECTIONS (Media / Season / Players / Insights). Each section's
// tabs render as small chips stacked into columns of at most 2. The bar scrolls
// horizontally rather than wrapping. Insights groups its stat tabs (no standalone
// "/insights" tab).
export const PWHL_OVERVIEW_TAB = { id: "overview", l: "PWHL", to: "/overview" };

// Opening PWHL jumps straight to the user's favourite tab (most-recently
// shift-clicked), else their Season-group favourite, else the Schedule page
// (default when no favourite tab exists). League Overview is not a landing.
// Favourite group's favourite tab for a league (set via Fav Tabs / shift+click).
// Landing = favourite GROUP's favourite TAB (falls back to the stored landing, then defaults).
const favLanding = (lg, dflt) => {
    try {
        const g = JSON.parse(localStorage.getItem("rosterly_group_fav") || "{}");
        const grp = g[`${lg}:__landing_group__`];
        return (grp && g[`${lg}:${grp}`]) || g[`${lg}:__landing__`] || g[`${lg}:season`] || dflt;
    } catch { return dflt; }
};
export function landingForLeague(lg) {
    // No favourite group/tab pinned → open on today's games across ALL leagues.
    return favLanding(lg, "/all/schedule");
}
export function pwhlLandingRoute() {
    return favLanding("pwhl", "/schedule");
}
// Append a one-shot ?lg= hint so a brand-new browser tab (middle-click or
// ctrl/cmd-click on a nav link) inherits the CURRENT league rather than a stale
// global default. LeagueContext reads and then strips this param on load.
function withLeagueParam(to, isNhl) {
    if (!to) return to;
    return to + (to.includes("?") ? "&" : "?") + "lg=" + (isNhl ? "nhl" : "pwhl");
}
// Switching leagues should keep you on the SAME page type (bypass the other
// league's favourite ONCE): map the current tab to the equivalent route in the
// target league. Group-tile clicks are untouched, so they still open favourites.
const PWHL_EQUIV_ROUTES = { standings: "/standings", schedule: "/schedule", leaderboards: "/team-leaderboards", players: "/rosters", roster: "/active-lineup", roadmap: "/roadmap", bugs: "/bug-reports", fanwall: "/fan-wall", inbox: "/messages", tasks: "/tasks", changelog: "/changelog", ins_chemistry: "/chemistry", demographics: "/team-demographics", legal: "/legal" };
// NHL pages aren't in the shared PWHL tab map, so tabFromLocation returns null
// on /nhl/*. Map them explicitly so switching FROM an NHL page keeps the same
// tab (bypassing the favourite ONCE) instead of defaulting to the landing page.
const NHL_PATH_TABS = { "/nhl/schedule": "schedule", "/nhl/standings": "standings", "/nhl/leaderboards": "leaderboards", "/nhl/rosters": "players", "/nhl/lineups": "roster", "/nhl/chemistry": "ins_chemistry", "/nhl/demographics": "demographics" };
// PWHL dedicated routes (not part of the /teams hub) that still need to map to a
// tab id for league-jumping, e.g. Chemistry.
const PWHL_PATH_TABS = { "/chemistry": "ins_chemistry", "/demographics": "demographics" };
const topPos = (ord, id, fallback) => { const i = (ord || []).indexOf(id); return i === -1 ? 1000 + fallback : i; };
export function leagueEquivalentRoute(targetLeague, pathname, search) {
    // Site rule: switching league opens the SAME page when the target league has it (e.g. /stories, /account).
    const routes = Object.values(targetLeague === "nhl" ? NHL_TAB_ROUTES : targetLeague === "international" ? NAT_TAB_ROUTES : targetLeague === "ncaa" ? NCAA_TAB_ROUTES : PWHL_EQUIV_ROUTES);
    if (routes.includes(pathname)) return `${pathname}${search || ""}`;
    if (targetLeague === "pwhl" && pathname === "/stories") return `/stories${search || ""}`;
    const nhlBase = "/" + (pathname.split("/").slice(1, 3).join("/"));
    const natTab = nhlBase.startsWith("/nat/") ? Object.keys(NAT_TAB_ROUTES).find((k) => NAT_TAB_ROUTES[k] === nhlBase) : nhlBase.startsWith("/ncaa/") ? Object.keys(NCAA_TAB_ROUTES).find((k) => NCAA_TAB_ROUTES[k] === nhlBase) : null;
    const tab = natTab || (nhlBase.startsWith("/nhl/") ? NHL_PATH_TABS[nhlBase] : PWHL_PATH_TABS[nhlBase]) || tabFromLocation(pathname, search);
    if (targetLeague === "nhl") return NHL_TAB_ROUTES[tab] || "/nhl/schedule";
    if (targetLeague === "international") return NAT_TAB_ROUTES[tab] || "/nat/schedule";
    if (targetLeague === "ncaa") return NCAA_TAB_ROUTES[tab] || "/ncaa/schedule";
    return PWHL_EQUIV_ROUTES[tab] || pwhlLandingRoute();
}
// Tabs that have no NCAA equivalent — rendered struck-through / disabled when NCAA is active.
const NCAA_UNAVAILABLE_TABS = new Set(["draft"]);
const ROSTERLY_WORDMARK = "https://customer-assets.emergentagent.com/job_d8fed49e-380f-4217-a8e9-486f1782ff60/artifacts/0qqhxw08_%7B76CE4EA0-7D80-4C78-9FAD-3B71E8B66535%7D.png";
// Preset keybinds (number key → path). Number keys do nothing unless preset here or set by the user.
const DEFAULT_KEYBINDS = { "1": "/", "2": "/overview", "3": "/roadmap" };
export const PWHL_SECTIONS = [    { key: "community", title: "Rosterly", color: "#F59E0B", Icon: Users, isLogo: true, tabs: [
        { id: "roadmap", l: "Roadmap", to: "/roadmap", Icon: Map },
        { id: "bugs", l: "Bug Reports", to: "/bug-reports", Icon: Bug },
        // Fan Wall temporarily hidden for everyone (page + posts kept). Restore this line to bring it back.
        // { id: "fanwall", l: "Fan Wall", to: "/fan-wall", Icon: Grid3x3 },
        { id: "inbox", l: "Inbox", to: "/messages", Icon: Mail },
        { id: "tasks", l: "Tasks", to: "/tasks", Icon: ClipboardList, admin: true },
        { id: "legal", l: "Legal", to: "/legal", Icon: Scale },
    ] },
    { key: "season", title: "Season", color: "#9D4CDD", Icon: Trophy, tabs: [
        { id: "standings", l: "Standings", to: "/standings", Icon: ListOrdered },
        { id: "schedule", l: "Schedule", to: "/schedule", Icon: Calendar },
        { id: "leaderboards", l: "Leaderboards", to: "/team-leaderboards", Icon: BarChart3 },
        { id: "players", l: "Rosters", to: "/rosters", Icon: Users },
        { id: "roster", l: "Lineups", to: "/active-lineup", Icon: ClipboardList },
        { id: "ins_chemistry", l: "Chemistry", to: "/chemistry", Icon: Atom },
    ] },
    { key: "history", title: "Archives", color: "#E0833B", Icon: ArrowLeftRight, tabs: [
        { id: "contracts", l: "Contracts", to: "/contracts", Icon: ScrollText },
        { id: "transfers", l: "History", to: "/team-movements", Icon: ArrowLeftRight },
        { id: "trades", l: "Trades", to: "/team-trades", Icon: Shuffle },
        { id: "draft", l: "Draft", to: "/team-draft", Icon: UserCog },
        { id: "staff", l: "Staff", to: "/staff", Icon: Briefcase },
    ] },
    { key: "intel", title: "Intel", color: "#EC4899", Icon: Atom, tabs: [
        { id: "ins_awards", l: "Awards", to: "/awards", Icon: Award },
        { id: "demographics", l: "Demographics", to: "/team-demographics", Icon: PieChart },
        { id: "ins_milestones", l: "Milestones", to: "/milestones", Icon: Pin },
        { id: "ins_records", l: "Records", to: "/records", Icon: Medal },
        { id: "ins_rankings", l: "Rankings", to: "/rankings", Icon: TrendingUp },
    ] },
    { key: "social", title: "Social", color: "#2DD4BF", Icon: Newspaper, tabs: [
        { id: "ins_stories", l: "Stories", to: "/stories", Icon: BookOpen },
        { id: "news", l: "News", to: "/team-news", Icon: Newspaper },
        { id: "videos", l: "Videos", to: "/team-videos", Icon: Video },
        { id: "chat", l: "Chat", to: "/socials", Icon: MessageSquare },
        { id: "sources", l: "Sources", to: "/nhl/sources", Icon: Rss, owner: true },
    ] },
    { key: "games", title: "Games", color: "#F472B6", Icon: Gamepad2, tabs: [
        { id: "pucks", l: "Pucks", to: "/packs", Icon: Disc3 },
        { id: "fantasy_pick6", l: "Pick 6", to: "/fantasy/pick6", Icon: ListChecks },
        { id: "fantasy_random6", l: "Random 6", to: "/fantasy/random6", Icon: Dices },
        { id: "games_predict", l: "Predict", to: "/schedule?predict=1", Icon: Target },
        { id: "games_leagues", l: "Leagues", to: "/schedule?leagues=1", Icon: Trophy },
    ] },
];
export const PWHL_TABS = PWHL_SECTIONS.flatMap((s) => s.tabs);
// NHL nav mirrors the SAME group tiles/tabs as the PWHL so the layout is
// identical. The Season group links to /nhl routes; the Community group is
// shared (league-agnostic). Every other group/tab has no NHL route and the nav
// renders it greyed-out ("coming soon for NHL").
const NHL_SEASON_TABS = [
    { id: "standings", l: "Standings", to: "/nhl/standings", Icon: ListOrdered },
    { id: "schedule", l: "Schedule", to: "/nhl/schedule", Icon: Calendar },
    { id: "leaderboards", l: "Leaderboards", to: "/nhl/leaderboards", Icon: BarChart3 },
    { id: "players", l: "Rosters", to: "/nhl/rosters", Icon: Users },
    { id: "roster", l: "Lineups", to: "/nhl/lineups", Icon: ClipboardList },
    { id: "ins_chemistry", l: "Chemistry", to: "/nhl/chemistry", Icon: Atom },
];
const BOARD_OF_TAB = { roadmap: "roadmap", bugs: "bugs", inbox: "inbox" };
// International (IIHF): only these tabs are live — everything else greys out (same nav as NHL/PWHL).
export const NAT_TAB_ROUTES = { ins_stories: "/stories", schedule: "/nat/schedule", games_predict: "/nat/schedule?predict=1", games_leagues: "/nat/schedule?leagues=1", standings: "/nat/standings", leaderboards: "/nat/leaderboards", roadmap: "/roadmap", bugs: "/bug-reports", fanwall: "/fan-wall", inbox: "/messages", tasks: "/tasks", changelog: "/changelog", own_accounts: "/owner?tab=accounts", legal: "/legal" };
// NCAA: its own Schedule + Standings; every site-wide tab (Display, Account, Owner…) works as everywhere else.
export const NCAA_TAB_ROUTES = { ...Object.fromEntries(Object.entries(NAT_TAB_ROUTES).filter(([k, v]) => !v.startsWith("/nat/") && k !== "ins_stories")), schedule: "/ncaa/schedule", standings: "/ncaa/standings", leaderboards: "/ncaa/leaderboards", ins_chemistry: "/ncaa/chemistry", games_leagues: "/ncaa/schedule?leagues=1" };

export const NHL_SECTIONS = PWHL_SECTIONS.map((sec) =>
    sec.key === "season" ? { ...sec, tabs: NHL_SEASON_TABS }
        : sec.key === "intel" ? { ...sec, tabs: sec.tabs.map((t) => (t.id === "demographics" ? { ...t, to: "/nhl/demographics" } : t)) }
        : sec
);
// Under NHL, only these tab ids map to a live route; every other tab greys out
// ("coming soon for NHL"). Shared across the desktop nav AND the mobile bento so
// mobile shows the SAME tabs as desktop.
export const NAT_SECTIONS = PWHL_SECTIONS;
export const NHL_TAB_ROUTES = { sources: "/nhl/sources", schedule: "/nhl/schedule", games_predict: "/nhl/schedule?predict=1", games_leagues: "/nhl/schedule?leagues=1", standings: "/nhl/standings", leaderboards: "/nhl/leaderboards", players: "/nhl/rosters", roster: "/nhl/lineups", ins_chemistry: "/nhl/chemistry", demographics: "/nhl/demographics", roadmap: "/roadmap", bugs: "/bug-reports", fanwall: "/fan-wall", inbox: "/messages", tasks: "/tasks", changelog: "/changelog", own_accounts: "/owner?tab=accounts", legal: "/legal" };
// Standalone routes that belong to the PWHL section (so its Nav Bar 2 shows there).
export const PWHL_OWNED_PATHS = new Set(["/overview", "/records", "/milestones", "/stories", "/insights", "/trends", "/rankings", "/awards", "/chemistry", "/positions"]);
const iconForTo = (to = "") => {
    const path = to.split("?")[0];
    const seg = "/" + (path.split("/")[1] || "");
    if (to.includes("/teams?tab=") || PATH_TABS[seg]) return PWHL_TAB_ICONS[pwhlTabKey(to)] || Globe;
    return INSIGHTS_TAB_ICONS[path] || Globe;
};
// Flat label lookup for favourited pages (used in the nav + shortcuts).
const PWHL_TAB_LABELS = [PWHL_OVERVIEW_TAB, ...PWHL_TABS].reduce((m, t) => { m[t.to] = t.l; return m; }, {});

// Shared nav building blocks so the WHOLE nav (PWHL sections + right-side
// sections) share one visual language.
function NavTitleChip({ color, Icon, title, testid }) {
    return (
        <div className="row-span-3 self-stretch shrink-0 w-[84px] flex flex-col items-center justify-center gap-1.5 px-2 rounded-lg border select-none"
            style={{ borderColor: `${color}66`, background: `${color}14`, color }} data-testid={testid}>
            <Icon className="h-6 w-6" strokeWidth={2} />
            <span className="text-[11px] font-black uppercase tracking-[0.1em] leading-none text-center">{title}</span>
        </div>
    );
}
// A right-side group's TOP title bar (icon + title), matching the PWHL section titles.
function NavTopTitle({ color, Icon, title, testid }) {
    return (
        <div className="flex items-center justify-center gap-1.5 px-2 py-1 rounded-md border select-none"
            style={{ borderColor: `${color}66`, background: `${color}14`, color }} data-testid={testid}>
            <Icon className="h-4 w-4" strokeWidth={2} />
            <span className="text-[10px] font-black uppercase tracking-[0.1em] leading-none">{title}</span>
        </div>
    );
}
function NavChip({ Icon, label, color = "#9D4CDD", active = false, onClick, to, testid, title, extra = {} }) {
    const cls = `group flex items-center gap-1.5 px-2.5 py-1 rounded-md transition-colors border ${active ? "text-white" : "border-white/10 text-[#94A3B8] hover:text-white hover:border-white/25"}`;
    const style = active ? { background: `${color}26`, borderColor: `${color}59` } : undefined;
    const inner = (<><Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} style={active ? { color } : undefined} /><span className="text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">{label}</span></>);
    return to
        ? <Link to={to} data-testid={testid} title={title || label} className={cls} style={style} {...extra}>{inner}</Link>
        : <button type="button" onClick={onClick} data-testid={testid} title={title || label} className={cls} style={style} {...extra}>{inner}</button>;
}
// Old-style circular symbol button (Search / Star / Tour / Pucks).
function NavIconBtn({ Icon, color = "#9D4CDD", active = false, onClick, to, testid, title }) {
    const cls = `inline-flex items-center justify-center h-9 w-9 rounded-full border transition-all ${active ? "" : "border-white/10 hover:border-white/30 hover:brightness-125"}`;
    const style = active ? { background: `${color}26`, borderColor: `${color}59` } : undefined;
    const inner = <Icon className="h-5 w-5" strokeWidth={2} style={{ color }} />;
    return to
        ? <Link to={to} data-testid={testid} title={title} className={cls} style={style}>{inner}</Link>
        : <button type="button" onClick={onClick} data-testid={testid} title={title} className={cls} style={style}>{inner}</button>;
}
// A connected section box: slim solid-colour title strip on the LEFT + body of
// items, all inside ONE bordered box. Shared by PWHL sections + Access + Owner.
function SectionBox({ color, Icon, title, testid, children, bodyClass = "p-1", bodyStyle }) {
    return (
        <div className="flex items-stretch rounded-lg border overflow-hidden shrink-0 self-stretch" style={{ borderColor: `${color}55` }} data-testid={testid}>
            <div className="flex flex-col items-center justify-center gap-0.5 px-1 shrink-0 w-[42px] text-center" style={{ background: color, color: "#0A0B10" }}>
                <Icon className="h-3.5 w-3.5" strokeWidth={2.5} />
                <span className="text-[7px] font-black uppercase tracking-wide leading-[1.1]">{title}</span>
            </div>
            <div className={bodyClass} style={{ background: `${color}0F`, ...(bodyStyle || {}) }}>{children}</div>
        </div>
    );
}
// A tall bordered button (Roadmap / Tour / Pucks).
function NavTallBtn({ Icon, label, color = "#9D4CDD", active = false, onClick, to, testid, title }) {
    const cls = "shrink-0 w-[80px] h-[84px] flex flex-col items-center justify-center gap-1.5 px-2 rounded-lg border transition-colors hover:brightness-125";
    const style = active ? { background: `${color}26`, borderColor: `${color}59`, color: "#fff" } : { borderColor: `${color}66`, color };
    const inner = <><Icon className="h-6 w-6" strokeWidth={2} /><span className="text-[11px] font-black uppercase tracking-[0.1em] leading-none">{label}</span></>;
    return to
        ? <Link to={to} data-testid={testid} title={title || label} className={cls} style={style}>{inner}</Link>
        : <button type="button" onClick={onClick} data-testid={testid} title={title || label} className={cls} style={style}>{inner}</button>;
}
// A right-side nav section: title chip + a 3-row grid of chips (matches PWHL groups).
function NavSection({ color, Icon, title, testid, children }) {
    return (
        <div className="grid grid-flow-col gap-1 shrink-0" style={{ gridTemplateRows: "repeat(3, minmax(0, 1fr))" }} data-testid={testid}>
            <NavTitleChip color={color} Icon={Icon} title={title} testid={`${testid}-title`} />
            {children}
        </div>
    );
}

// A privileged "view + page" nav control: a View toggle + a page-link button,
// both styled to MATCH the league sub-tab chips (horizontal icon + label).
function NavViewBox({ id, color, Icon, label, onView, viewActive, viewExtra = {}, onPage, pageActive }) {
    const chip = "group flex items-center gap-1.5 px-2.5 py-1 rounded-md border transition-colors hover:brightness-110";
    const on = { background: `${color}D9`, borderColor: color, color: "#fff" };
    const off = { borderColor: `${color}66`, background: `${color}14`, color };
    return (
        <div className="flex items-center gap-1 shrink-0" data-testid={`nav-${id}-box`}>
            <button type="button" onClick={onView} data-testid={`nav-${id}-view`} data-active={viewActive ? "true" : "false"} title={`${label} view`}
                onMouseDown={viewExtra.onMouseDown} onMouseUp={viewExtra.onMouseUp} onMouseOut={viewExtra.onMouseOut}
                className={chip} style={viewActive ? on : off}>
                <Eye className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />
                <span className="text-[9px] font-bold uppercase tracking-wider leading-none">View</span>
            </button>
            <button type="button" onClick={onPage} data-testid={`nav-${id}-pages`} title={label}
                className={chip} style={pageActive ? on : off}>
                <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />
                <span className="text-[9px] font-bold uppercase tracking-wider leading-none">{label}</span>
            </button>
        </div>
    );
}

// The PWHL sections bar (Overview button + Media/Season/Players/Insights groups),
// now rendered inline in the MAIN top nav (no separate 2nd strip). `colorStyle`
// lets a user override the section colours: "default" | "grey" | "custom" (hex).
function PwhlSectionsBar({ colorStyle = "rosterly", customColor = "", customText = "", onChangeLeague, onPickLeague, league = "pwhl", eyeMode = "closed", isOwner = false, access = {}, favTeamId = null, leagueBarOpen = false, onToggleLeagueBar, viewModes = {}, onToggleView, sideControls = null, navsHidden = false, onToggleNavsHidden, borderMode = "basic", onToggleBorders, displayBtns = null }) {
    const navExtendedVal = useNavExtended();
    const location = useLocation();
    const { user, logout } = useAuth();
    // Predict is available to ANY logged-in user (not just owners) on the schedule
    // + standings pages.
    const canPredictHere = !!user && ["/schedule", "/nhl/schedule", "/nat/schedule", "/all/schedule", "/standings"].includes(location.pathname);
    const navigate = useNavigate();
    const [hoverKey, setHoverKey] = useState(null);
    // Search opens INSIDE the second-bar box (the same box the group tabs use)
    // rather than replacing the whole nav.
    const [searchOpen, setSearchOpen] = useState(false);
    // Bumped on an explicit CLICK of the Search tile so the input focuses only
    // when the user chooses to search — hovering just reveals the box (no auto-select).
    const [searchFocusToken, setSearchFocusToken] = useState(0);
    const [searchHasText, setSearchHasText] = useState(false);
    // Player-pick mode (Leaderboards Game Logs) auto-opens the search box so the
    // owner/visitor can immediately type a player name.
    const { pick } = useGameNav();
    const hasSegs = useHasSegs();  // no toggles on this page → no Fav Toggles button
    useEffect(() => { if (pick?.active) setSearchOpen(true); }, [pick?.active]);
    // GLOBAL "Team Surf" — the big PWHL button owns a persistent team selection
    // that recolours the nav and drives sorting on every tab.
    const { surfTeam, setSurfTeam, surfLocked, setSurfLocked, onTeamSelect, nhlSurfTeam, setNhlSurfTeam, nhlSurfGroup, setNhlSurfGroup, pwhlSurfGroup, setPwhlSurfGroup, pwhlSurfMulti, nhlSurfMulti, clearSurfMulti, surfMode, setSurfMode } = useSortByTeam();
    const { getPref, setPref, clearPref } = usePagePrefs();
    const sbAll = useSortByTeam();
    // Shift+click on a multi-team page: add/remove the team AND save the set as this page's pin.
    const shiftMulti = (lg, id) => {
        const cur = lg === "nhl" ? (nhlSurfMulti.length ? nhlSurfMulti : nhlSurfTeam ? [nhlSurfTeam] : []) : (pwhlSurfMulti.length ? pwhlSurfMulti : surfTeam ? [surfTeam] : []);
        const val = toggleMultiVal(cur.length > 1 ? `multi:${cur.join(",")}` : cur[0] || null, id);
        const route = legacyPath();
        if (val) setPref("page_team", route, val); else clearPref("page_team", route);
        applySurf(sbAll, lg, val);
    };
    // Spoilers-Free team picker: when Spoilers-Free is ON on the NHL schedule, the
    // team-picker logos become the SELECTOR. All teams start greyed (in Spoilers-
    // Free); clicking a team "puts it on" (removes it from Spoilers-Free so its
    // live/same-day scores show). Stored as a comma list of EXCLUDED abbrs.
    const spoilerPickMode = location.pathname === "/nhl/schedule" && getPref("page_toggle", "nhl_sched_spoilers") === "on";
    const spoilerTeamsSet = new Set(String(getPref("page_toggle", "nhl_spoiler_teams") || "").split(",").map((s) => s.trim().toUpperCase()).filter(Boolean));
    const toggleSpoilerTeam = (abbr) => {
        const A = String(abbr).toUpperCase();
        const next = new Set(spoilerTeamsSet);
        if (next.has(A)) next.delete(A); else next.add(A);
        setPref("page_toggle", "nhl_spoiler_teams", Array.from(next).join(",") || null);
    };
    // Bulk Spoilers-Free select: All teams / a Conference / a Division. Clicking a
    // group turns ALL its teams ON (highlighted); clicking again when all are ON
    // turns the whole group back OFF.
    const NHL_CONF_DIVS = { Eastern: ["Atlantic", "Metropolitan"], Western: ["Central", "Pacific"] };
    const setSpoilerMany = (abbrs, on) => {
        const next = new Set(spoilerTeamsSet);
        abbrs.forEach((a) => { const A = String(a).toUpperCase(); if (on) next.add(A); else next.delete(A); });
        setPref("page_toggle", "nhl_spoiler_teams", Array.from(next).join(",") || null);
    };
    const allSelected = (abbrs) => abbrs.length > 0 && abbrs.every((a) => spoilerTeamsSet.has(String(a).toUpperCase()));
    const toggleSpoilerGroup = (abbrs) => setSpoilerMany(abbrs, !allSelected(abbrs));
    // NOTIFICATIONS pick mode (any page, signed in): the team board ticks teams = alerts ON.
    const notif = useNotifPick();
    // Notification-pick mode is SESSION-ONLY (never persisted) so taps on the team board
    // can never silently turn alerts on later (e.g. while picking Spoilers-Free teams).
    const notifyMode = notif.enabled && getPref("page_toggle", "notify_pick") === "on";
    const pickModeNhl = notifyMode || spoilerPickMode;
    const pmHas = (abbr) => (notifyMode ? notif.isOn("nhl", abbr) : spoilerTeamsSet.has(String(abbr).toUpperCase()));
    const pmToggle = (abbr) => {
        if (!notifyMode) return toggleSpoilerTeam(abbr);
        const on = !notif.isOn("nhl", abbr);
        notif.toggle("nhl", abbr);
        toast(`${abbr} alerts ${on ? "ON" : "OFF"}`);
    };
    const pmAll = (abbrs) => (notifyMode ? notif.allOn("nhl", abbrs) : allSelected(abbrs));
    const pmGroup = (abbrs) => (notifyMode ? notif.setMany("nhl", abbrs, !notif.allOn("nhl", abbrs)) : toggleSpoilerGroup(abbrs));
    // Shift+click a team/scope = pin it as this league's default (account-synced,
    // applied on open by PrefsDefaulter). Normal click = live session pick.
    // Shift+click = override the favourite for THIS PAGE only ("all" = All Teams here).
    const pwhlPin = getPref("page_team", location.pathname);
    const nhlPin = pwhlPin;
    // Shift+RIGHT-click = pin a team for THIS PAGE only (overrides the league default here).
    const pinPageTeam = (val, label) => {
        const route = legacyPath();
        val = val || "all";
        const cur = getPref("page_team", route);
        if (cur === val) { clearPref("page_team", route); toast(`Unpinned ${label} for this page`); }
        else { setPref("page_team", route, val); toast(`Pinned ${label} for this page only`); }
    };
    // Cached copy paints the team switchboard on the very first frame (no nav jump while teams load).
    const { data: surfTeams = [] } = useQuery({ queryKey: ["teams"], queryFn: () => getTeams().then((d) => { try { localStorage.setItem("rosterly_teams_cache", JSON.stringify(d)); } catch { /* ignore */ } return d; }), staleTime: 5 * 60 * 1000,
        placeholderData: () => { try { return JSON.parse(localStorage.getItem("rosterly_teams_cache") || "null") || Object.keys(TEAM_INFO).map((id) => ({ id, name: TEAM_INFO[id].name })); } catch { return undefined; } } });
    // Inbox badge = pending league invites (all users) + unread owner messages.
    const inboxCounts = useInboxCounts();
    const inboxCount = inboxCounts.total;
    useInboxBadge(user ? inboxCount : 0);
    const [teamHover, setTeamHover] = useState(false);
    // NEW favourites system: each group can have a favourite tab (set via Shift+click
    // on one of its tabs). Clicking the group tile then opens that favourite tab.
    // Stored per-group by path; if a tab later moves to a different group the stale
    // entry is ignored (falls back to the group's first tab) — i.e. auto-reset.
    // Persisted SERVER-SIDE (tied to the user account) so favourites survive
    // preview forks / domain changes; localStorage is just an offline cache.
    const isAuthed = !!user;
    // NHL is public — everyone can switch leagues to reach it.
    const canSwitch = true;
    const qc = useQueryClient();
    // Per-page Public/Strict access-zone split (owner-configurable, saved globally).
    const { data: siteSettings } = useQuery({ queryKey: ["settings"], queryFn: getSettings, staleTime: 5 * 60 * 1000 });
    // Every league's schedule shares the NHL schedule's access setup — identical buttons, levels and order.
    const accessPageKey = ["/schedule", "/nat/schedule", "/all/schedule"].includes(location.pathname) ? "/nhl/schedule" : location.pathname;
    // NAT pages inherit the NHL page's access setup (same buttons, same public/owner levels) unless set on NAT itself.
    const accessMirrorKey = accessPageKey.startsWith("/nat/") ? accessPageKey.replace("/nat/", "/nhl/") : null;
    // Spoilers (NHL schedule) + Notifications (every page) are always public.
    const accessPublicKeys = Array.from(new Set([...(((siteSettings?.access_zones || {})[accessPageKey]) || []), ...((accessMirrorKey && (siteSettings?.access_zones || {})[accessMirrorKey]) || []), ...(accessPageKey === "/nhl/schedule" ? ["spoiler"] : []), ...(accessPageKey === "/leaderboards" ? ["lb_trends", "lb_milestones", "lb_gamelogs", "lb_compare"] : []), "notify"]));
    const [groupFav, setGroupFav] = useState(() => {
        try { return JSON.parse(localStorage.getItem("rosterly_group_fav") || "{}"); } catch { return {}; }
    });
    const { data: serverFav } = useQuery({
        queryKey: ["group-fav", user?.id || null],
        queryFn: () => api.get("/me/group-fav").then((r) => r.data),
        enabled: isAuthed,
        staleTime: 60 * 1000,
    });
    useEffect(() => {
        // Only ADOPT the server value when it actually has entries — never let an
        // empty/failed server response wipe locally-set favourites (that caused the
        // "resets on every refresh" regression). Server entries win on conflict.
        if (serverFav && typeof serverFav === "object" && !Array.isArray(serverFav) && Object.keys(serverFav).length) {
            setGroupFav((prev) => {
                const merged = { ...prev, ...serverFav };
                try { localStorage.setItem("rosterly_group_fav", JSON.stringify(merged)); } catch { /* noop */ }
                return merged;
            });
        }
    }, [serverFav]);
    const saveFavMut = useMutation({
        mutationFn: (map) => api.put("/me/group-fav", map).then((r) => r.data),
        onSettled: () => { if (isAuthed) qc.invalidateQueries({ queryKey: ["group-fav", user?.id || null] }); },
    });
    const { shift: shiftHeld } = useShiftHold();
    const favKey = (k) => `${league}:${k}`;
    const pickFav = (groupKey, to, label) => {
        setGroupFav((prev) => {
            // Also record the most-recent favourite as the PWHL landing tab so
            // opening PWHL jumps straight here.
            // Landing only follows this tab when it belongs to the favourite (landing) GROUP.
            const lg = prev[favKey("__landing_group__")];
            const next = { ...prev, [favKey(groupKey)]: to, ...(!lg || lg === groupKey ? { [favKey("__landing__")]: to } : {}) };
            try { localStorage.setItem("rosterly_group_fav", JSON.stringify(next)); } catch { /* noop */ }
            // Persist to the account so favourite tabs survive a cache/cookie clear.
            if (isAuthed) saveFavMut.mutate(next);
            return next;
        });
        toast.success(`${label} pinned as this group's default`);
    };
    const pinLanding = (to, label, groupKey) => {
        setGroupFav((prev) => {
            const next = { ...prev, [favKey("__landing__")]: to, ...(groupKey ? { [favKey("__landing_group__")]: groupKey } : {}) };
            try { localStorage.setItem("rosterly_group_fav", JSON.stringify(next)); } catch { /* noop */ }
            if (isAuthed) saveFavMut.mutate(next);
            return next;
        });
        toast.success(`${label} is now your landing group`);
    };
    // Access-based section titles (owner-only PWHL clickability + these four
    // access groups) reveal their pages as tab buttons in the second bar.
    const accessSections = useMemo(() => {
        const out = [];
        if (access.admin) out.push({ key: "acc-admin", title: "Admin", color: "#9D4CDD", Icon: Shield, access: true, tabs: ADMIN_NAV.children.map((c, i) => ({ id: `admin-${i}`, l: c.label, to: c.to })) });
        if (access.business) out.push({ key: "acc-business", title: "Business", color: "#22C55E", Icon: Briefcase, access: true, tabs: (BUSINESS_NAV.children.length ? BUSINESS_NAV.children.map((c, i) => ({ id: `business-${i}`, l: c.label, to: c.to })) : [{ id: "business-0", l: "Business", to: "/business" }]) });
        if (access.owner) out.push({ key: "acc-owner", title: "Owner", color: "#F6C453", Icon: Crown, access: true, tabs: OWNER_NAV.children.map((c, i) => ({ id: `owner-${i}`, l: c.label, to: c.to })) });
        return out;
    }, [access.admin, access.business, access.creator, access.owner]);
    const isNcaa = league === "ncaa";
    const isNonPwhl = league !== "pwhl";
    const isNhl = league === "nhl";
    const isIntl = league === "international";
    const isAlt = isIntl || isNcaa;
    const ALT_ROUTES = isNcaa ? NCAA_TAB_ROUTES : NAT_TAB_ROUTES;
    const ALT_HOME = isNcaa ? "/ncaa/schedule" : "/nat/schedule";
    const { getFavourite, setFavourite } = useFavourite();
    const [favPickMode, setFavPickMode] = useState(false);
    const { favLeague, toggleFavLeague } = useFavLeague();
    const [tabFavPick, setTabFavPick] = useState(false);
    const navStruct = useNavStructure();
    const [navArrange, setNavArrangeRaw] = useState(() => { try { return sessionStorage.getItem("rosterly_nav_arrange") === "1"; } catch { return false; } });
    const setNavArrange = (v) => setNavArrangeRaw((cur) => { const n = typeof v === "function" ? v(cur) : v; try { sessionStorage.setItem("rosterly_nav_arrange", n ? "1" : "0"); } catch { /* noop */ } return n; });
    const { allButtons, toggleAllButtons: toggleAdminTools } = useAdminMode();
    // Account tile = account nav mode; Owner Tools tile = owner buttons in the access box. One mode at a time.
    const [accountOn, setAccountOnRaw] = useState(() => { try { return sessionStorage.getItem("rosterly_nav_account") === "1"; } catch { return false; } });
    const setAccountOn = (v) => { setAccountOnRaw(v); try { sessionStorage.setItem("rosterly_nav_account", v ? "1" : "0"); } catch { /* noop */ } };
    const [ownerToolsOn, setOwnerToolsOnRaw] = useState(false); // Owner Tools now live inside Account
    const setOwnerToolsOn = (v) => { setOwnerToolsOnRaw(v); try { localStorage.setItem("rosterly_nav_owner_tools", v ? "1" : "0"); } catch { /* noop */ } };
    const [displayOn, setDisplayOnRaw] = useState(() => { try { return localStorage.getItem("rosterly_nav_display") === "1"; } catch { return false; } });
    const setDisplayOn = (v) => { setDisplayOnRaw(v); try { localStorage.setItem("rosterly_nav_display", v ? "1" : "0"); } catch { /* noop */ } };
    // Page toggles always show unless Display / Account (or Owner Tools) is layered over them.
    const pageOn = !displayOn && !accountOn && !ownerToolsOn;
    const setPageOn = () => {};
    // Non-group tiles (Account, Page, Display, Admin Tools, Owner Tools): one on at a time.
    const offPanels = () => { if (accountOn) closeAccountModal(); setAccountOn(false); setPageOn(false); setDisplayOn(false); setOwnerToolsOn(false); };
    const pageHasBtns = useRef(false);
    const LEFT_ACCESS = ["view:admin", "view:business", "view:owner", "changelog"];
    // Which Account / Owner Tools section is open, so its button lights up.
    const [openPanel, setOpenPanel] = useState({ acc: null, own: null });
    useEffect(() => {
        const acc = (e) => setOpenPanel((p) => ({ ...p, acc: e.detail }));
        const own = (e) => setOpenPanel((p) => ({ ...p, own: e.detail }));
        window.addEventListener("account-panel-state", acc);
        window.addEventListener("owner-tool-state", own);
        return () => { window.removeEventListener("account-panel-state", acc); window.removeEventListener("owner-tool-state", own); };
    }, []);
    const pageOnRef = useRef(pageOn);
    pageOnRef.current = pageOn;
    // Selected Page opens by itself whenever you go to a page.
    const lastPath = useRef(location.pathname);
    useEffect(() => {
        if (lastPath.current === location.pathname) return undefined;
        lastPath.current = location.pathname;
        // Going to any other tab closes the account page + its buttons.
        closeAccountModal(); setAccountOn(false); setDisplayOn(false);
        // Wait for the new page to register its toggles; an empty Selected Page never opens.
        const t = setTimeout(() => { if (pageHasBtns.current) { offPanels(); setPageOn(true); } else if (pageOnRef.current) setPageOn(false); }, 700);
        return () => clearTimeout(t);
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
    // Display / Account are a layer: pressing any other nav tab or button closes them.
    useEffect(() => {
        if (!displayOn && !accountOn) return undefined;
        const h = (e) => {
            const t = e.target.closest?.("button, a, [role='button']");
            if (!t || !t.closest('[data-testid="desktop-header"]') || t.closest('[data-testid="access-zones"], [data-testid="nav-display-tile"], [data-testid="nav-account-toggle"]')) return;
            setDisplayOn(false); setAccountOn(false); closeAccountModal();
        };
        document.addEventListener("click", h, true);
        return () => document.removeEventListener("click", h, true);
    }, [displayOn, accountOn]); // eslint-disable-line react-hooks/exhaustive-deps
    const [navLayout, saveNavToggleLayout] = useNavToggleLayout(user);
    const favLg = isNhl ? "nhl" : isIntl ? "international" : "pwhl";
    const favVal = getFavourite(favLg);
    // Favourite mode: click = one favourite · shift+click = add/remove more favourite teams.
    const toggleFavPick = (val, label, e) => {
        if (e?.shiftKey && val && !val.includes(":")) {
            const next = toggleMultiVal(favVal && favVal.includes(":") && !favVal.startsWith("multi:") ? null : favVal, val);
            setFavourite(favLg, next);
            toast.success(next ? `Favourites: ${next.replace(/^multi:/, "").toUpperCase().split(",").join(", ")}` : "Favourite cleared");
            return;
        }
        const next = val && favVal !== val ? val : null;
        setFavourite(favLg, next);
        toast.success(next ? `${label} set as your favourite` : "Favourite cleared");
    };
    // A conference / division / All-teams favourite lights up every member team.
    const groupHasTeam = (g, id) => {
        if (!g) return false;
        if (g === "all") return true;
        const nt = nhlTeams.find((t) => t.abbr === id);
        const conf = nt ? nt.conference : pwhlConfOf(id);
        const div = nt ? nt.division : null;
        return g === `conf:${conf}` || (!!div && g === `div:${div}`);
    };
    const isFavStar = (id) => !!favVal && (favVal === id || (favVal.startsWith("multi:") && favVal.slice(6).split(",").includes(id)) || groupHasTeam(favVal, id));
    const accessLevels = { ...((accessMirrorKey && (siteSettings?.access_levels || {})[accessMirrorKey]) || {}), ...(((siteSettings?.access_levels || {})[accessPageKey]) || {}) };
    const [lgMenu, setLgMenu] = useState(null);   // League tile picker: International lives here; PWHL/NHL stay on the bars
    const [intlCountry, setIntlCountry] = useState(null);   // International: highlighted country (code)
    const [intlGroup, setIntlGroup] = useState(null);
    const { data: intlCountriesData } = useQuery({ queryKey: ["intl-teams"], queryFn: () => api.get("/intl/teams").then((r) => r.data), enabled: isIntl, staleTime: 60 * 60 * 1000 });
    const intlCountries = useMemo(() => (intlCountriesData?.teams || []).slice().sort((a, b) => String(a.group || "Z").localeCompare(String(b.group || "Z")) || a.name.localeCompare(b.name)), [intlCountriesData]);
    // Roadmap View (owner toggle): show "+N" badges on tabs with linked open items.
    const curTabRoute = useMemo(() => {
        const p = location.pathname;
        if (p.startsWith("/nhl/")) return "/" + p.split("/").slice(1, 3).join("/");
        return "/" + (p.split("/")[1] || "");
    }, [location.pathname]);
    const roadmapView = useRoadmapView();
    const { data: roadmapBadgeItems = [] } = useQuery({ queryKey: ["roadmap-all", access.admin], queryFn: () => getRoadmap(), enabled: roadmapView && !!access.admin && !IS_PREVIEW });
    const { data: boardOpen } = useQuery({ queryKey: ["roadmap-alerts", "open-counts"], queryFn: () => api.get("/admin/roadmap/open-counts").then((r) => r.data), enabled: !!access.admin && !IS_PREVIEW, staleTime: 30 * 1000 });
    const changelogView = useChangelogView();
    const [clScope, setClScope] = useState("general");
    const { data: changelogAreaData } = useQuery({ queryKey: ["audit-area-counts"], queryFn: () => getAuditAreaCounts(), enabled: changelogView && !!access.owner, refetchInterval: 20000 });
    const changelogCounts = changelogAreaData?.counts || {};
    const changelogSeen = useChangelogSeen();
    // Opening a page's changelog marks it read: record the current count for this
    // area so its badge clears until NEW changes arrive. Owner-only.
    useEffect(() => {
        if (changelogView && access.owner && clScope === "page" && curTabRoute && changelogAreaData) {
            markAreaSeen(curTabRoute, changelogCounts[curTabRoute] || 0);
        }
    }, [changelogView, access.owner, clScope, curTabRoute, changelogAreaData, changelogCounts]);
    const { data: changelogAreaLogs } = useQuery({
        queryKey: ["audit-area-logs", clScope, curTabRoute],
        queryFn: () => getAuditLogs(clScope === "general" ? { limit: 500 } : { area: curTabRoute, limit: 200 }),
        enabled: changelogView && !!access.owner && (clScope === "general" || !!curTabRoute),
        refetchInterval: 20000,
    });
    const roadmapCounts = useMemo(() => roadmapCountsByPage(roadmapBadgeItems), [roadmapBadgeItems]);
    // Under NHL, these tabs are live (mapped to NHL routes) plus the Community
    // group (shared, league-agnostic); everything else greys out.
    const { data: nhlTeams = [] } = useQuery({ queryKey: ["nhl-teams"], queryFn: () => api.get("/nhl/teams").then((r) => r.data), enabled: isNhl, staleTime: 60 * 60 * 1000 });
    // NHL_TAB_ROUTES now lives at module scope (exported) so the mobile bento reuses it.
    const leagueLabel = { ncaa: "NCAA", sdhl: "SDHL", nhl: "NHL", international: "WWHC" }[league] || "PWHL";
    const curTab = tabFromLocation(location.pathname, location.search);
    const isActive = (to) => {
        if (to.includes("?tab=")) {
            const base = to.split("?")[0];
            const t = new URLSearchParams(to.split("?")[1]).get("tab");
            return location.pathname === base && curTab === t;
        }
        const base = to.split("?")[0];
        const tabKey = PATH_TABS[base];
        if (tabKey && TEAM_SCOPED.has(tabKey)) return location.pathname === base || location.pathname.startsWith(base + "/");
        return location.pathname === base;
    };
    // The group tab highlighted/expanded by default reflects the CURRENT page's
    // section (e.g. a Teams page keeps "Teams" open) — not always "Season".
    // Hovering another group temporarily overrides it.
    const activeSectionKey = useMemo(() => {
        for (const sec of [...arrangeSections(isNhl ? NHL_SECTIONS : PWHL_SECTIONS, navStruct), ...accessSections]) {
            if ((sec.tabs || []).some((t) => isActive(isNhl ? (NHL_TAB_ROUTES[t.id] || t.to) : isAlt ? (ALT_ROUTES[t.id] || t.to) : t.to))) return sec.key;
        }
        return "season";
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, location.search, accessSections, navStruct]);
    const openKey = hoverKey || activeSectionKey;
    const resolve = (base) => {
        if (isNhl) return "#8A94A6";
        if (colorStyle === "grey") return "#8A94A6";
        if (colorStyle === "custom" && /^#[0-9a-f]{6}$/i.test(customColor)) return customColor;
        if (colorStyle === "rosterly") return "#6a3597";
        return base;
    };
    // Optional label/text colour override (Rosterly → white, Custom → chosen text hex).
    const labelColor = colorStyle === "rosterly" ? "#ffffff" : (colorStyle === "custom" && /^#[0-9a-f]{6}$/i.test(customText) ? customText : null);
    const ovActive = isActive(PWHL_OVERVIEW_TAB.to);
    const OvIcon = iconForTo(PWHL_OVERVIEW_TAB.to);
    const ovColor = resolve("#2DD4BF");
    // The big league button reflects the CURRENT context: on a team page it
    // shows that team's logo and opens its Overview (its hero); on league pages
    // it's the globe + League Overview. Driven by the URL, not by favourites.
    const _teamMatch = /^\/teams\/([^/?]+)/.exec(location.pathname);
    const _scopedTeam = (() => {
        const parts = location.pathname.split("/");
        const base = "/" + (parts[1] || "");
        const tk = PATH_TABS[base];
        return tk && TEAM_SCOPED.has(tk) && parts[2] ? parts[2] : null;
    })();
    const _teamQuery = new URLSearchParams(location.search).get("team");
    const ctxTeamId = league === "pwhl" ? (_teamQuery || _scopedTeam || (_teamMatch ? _teamMatch[1] : null)) : null;
    const bigTo = ctxTeamId ? `/team-pages/${ctxTeamId}` : PWHL_OVERVIEW_TAB.to;
    const bigActive = ovActive || (!!ctxTeamId && curTab === "overview");
    // Team Surf derived state — only active for PWHL; other leagues fade to purple.
    const isPwhl = league === "pwhl";
    const surfColorOf = (id) => { const t = surfTeams.find((x) => x.id === id); return t?.primary_color || TEAM_INFO[id]?.color || "#9D4CDD"; };
    const activeSurf = isPwhl && surfTeam ? surfTeam : null;
    const nhlColorOf = (abbr) => nhlTeams.find((t) => t.abbr === abbr)?.primary_color || "#8A94A6";
    const nhlActive = isNhl && nhlSurfTeam ? nhlSurfTeam : null;
    const nhlActiveMeta = nhlActive ? nhlTeams.find((t) => t.abbr === nhlActive) : null;
    const teamColor = isNcaa ? NCAA_BLUE : isIntl ? "#E11D48" : activeSurf ? surfColorOf(activeSurf) : (nhlActive ? nhlColorOf(nhlActive) : null);
    const surfName = activeSurf
        ? (TEAM_INFO[activeSurf]?.name || activeSurf).toUpperCase()
        : (nhlActive ? (nhlActiveMeta?.name || nhlActive).toUpperCase() : null);
    const surfIds0 = orderTeams(surfTeams).map((t) => t.id);
    // Group the PWHL board by conference (Eastern rows on top, Western below) when every team has one.
    const pwhlConfed = surfIds0.length > 0 && surfIds0.every((id) => pwhlConfOf(id));
    const surfIds = pwhlConfed ? [...surfIds0].sort((a, b) => (pwhlConfOf(a) === pwhlConfOf(b) ? 0 : pwhlConfOf(a) === "Eastern" ? -1 : 1)) : surfIds0;
    // Strip is hidden by default. It shows only while HOVERING the nav, or when
    // the big button has LOCKED it. Selecting a team does NOT keep it open — the
    // big button (recoloured + team logo) is the persistent indicator; the LOCK
    // is what keeps the strip pinned, and it works for every team.
    const showStrip = isPwhl && surfIds.length > 0 && (teamHover || surfLocked);
    // Click the big button = lock/unlock the team strip (keeps the current team).
    const onBigClick = () => {
        setSurfLocked(!surfLocked);
    };
    // Shift+click = multi-team pick on Standings / Schedule / Chemistry / NHL Leaders.
    // Only pages that can SHOW several teams use multi-pick; everywhere else shift+click pins (as before).
    const multiOk = /^\/(standings|schedule|chemistry|nhl\/standings|nhl\/schedule|nat\/schedule|nhl\/chemistry|nhl\/leaders)(\/|$)/.test(location.pathname);
    const onSurfPick = (id, e) => {
        if (favPickMode) { toggleFavPick(id, TEAM_INFO[id]?.abbr || id.toUpperCase(), e); return; }
        if (e && e.shiftKey && multiOk) { shiftMulti("pwhl", id); if (onTeamSelect) onTeamSelect(null); return; }
        if (e && e.shiftKey) pinPageTeam(id, TEAM_INFO[id]?.abbr || id.toUpperCase());
        const next = activeSurf === id ? null : id;
        setSurfTeam(next);
        // Bridge to any page-registered handler (e.g. Teams roster/lineup tabs keep
        // per-tab team memory + URL through onTeamSelect, not surfTeam alone).
        if (onTeamSelect) onTeamSelect(next);
    };
    // ---- Arrange (owner): drag group tiles / tabs to reorder, drop a tab on a group tile to move it there, double-click to rename ----
    const arrOn = navArrange && isOwner;
    const saveStruct = (next) => {
        qc.setQueryData(["nav-config"], (old) => ({ ...(old || {}), nav_structure: next }));
        api.put("/admin/nav-config/structure", { nav_structure: next }).catch(() => toast.error("Couldn't save the nav arrangement"));
    };
    const topKeysRef = useRef([]);   // every top-row tile in rendered order (groups + League / Search / Display / Account)
    const curSecs = () => [...arrangeSections(isNhl ? NHL_SECTIONS : PWHL_SECTIONS, navStruct), ...arrangeSections(accessTiles, navStruct)];
    const moveGroup = (from, target, after = false) => {
        if (from === target) return;
        const order = (topKeysRef.current.length ? topKeysRef.current : curSecs().map((g) => g.key)).filter((k) => k !== from);
        order.splice(Math.max(0, order.indexOf(target) + (after ? 1 : 0)), 0, from);
        saveStruct({ ...(navStruct || {}), top_order: order, group_order: order.filter((k) => !k.startsWith("__")) });
    };
    const moveTab = (id, toGroup, target = null, after = false) => {
        if (id === target) return;
        const lists = Object.fromEntries(curSecs().map((g) => [g.key, g.tabs.map((t) => t.id)]));
        Object.keys(lists).forEach((k) => { lists[k] = lists[k].filter((x) => x !== id); });
        const dest = lists[toGroup] || (lists[toGroup] = []);
        const at = target ? dest.indexOf(target) : -1;
        if (at === -1) dest.push(id); else dest.splice(at + (after ? 1 : 0), 0, id);
        const st = navStruct || {};
        saveStruct({ ...st, tabs: { ...(st.tabs || {}), [id]: { ...((st.tabs || {})[id] || {}), group: toGroup } }, tab_order: { ...(st.tab_order || {}), ...lists } });
    };
    const [renaming, setRenaming] = useState(null);   // { kind, id, cur, x, y }
    const commitRename = (val) => {
        const r = renaming; setRenaming(null);
        if (!r) return;
        const st = navStruct || {};
        const bag = { ...(st[r.kind] || {}) };
        bag[r.id] = { ...(bag[r.id] || {}), [r.kind === "groups" ? "title" : "l"]: (val || "").trim() || undefined };
        saveStruct({ ...st, [r.kind]: bag });
    };
    const dragData = (e) => { try { return JSON.parse(e.dataTransfer.getData("text/rosterly-nav") || "null"); } catch { return null; } };
    // Visual drag & drop — classes only (no React state while dragging, so nothing re-mounts mid-drag).
    const OVER = ["arr-over-before", "arr-over-after", "arr-over-into"];
    const clearOver = () => document.querySelectorAll(".arr-over-before, .arr-over-after, .arr-over-into").forEach((n) => n.classList.remove(...OVER));
    const isAfter = (e) => { const r = e.currentTarget.getBoundingClientRect(); return e.clientX > r.left + r.width / 2; };
    const arrProps = (kind, id, label, groupKey) => !arrOn ? {} : {
        draggable: true,
        "data-arr-kind": kind,
        onDragStart: (e) => {
            e.stopPropagation();
            e.dataTransfer.setData("text/rosterly-nav", JSON.stringify({ kind, id }));
            e.dataTransfer.effectAllowed = "move";
            const el = e.currentTarget;
            setTimeout(() => el.classList.add("arr-dragging"), 0);
            document.body.dataset.arrDrag = kind;
        },
        onDragEnd: (e) => { e.currentTarget.classList.remove("arr-dragging"); clearOver(); delete document.body.dataset.arrDrag; },
        onDragOver: (e) => {
            e.preventDefault(); e.stopPropagation();
            const dk = document.body.dataset.arrDrag;
            const cls = kind === "group" && dk === "tab" ? (id.startsWith("__") ? null : "arr-over-into") : (kind === dk ? (isAfter(e) ? "arr-over-after" : "arr-over-before") : null);
            if (cls && !e.currentTarget.classList.contains(cls)) { clearOver(); e.currentTarget.classList.add(cls); }
        },
        onDragLeave: (e) => { if (!e.currentTarget.contains(e.relatedTarget)) e.currentTarget.classList.remove(...OVER); },
        onDrop: (e) => {
            e.preventDefault(); e.stopPropagation(); clearOver();
            const d = dragData(e);
            if (!d) return;
            const after = isAfter(e);
            if (kind === "group") { if (d.kind === "group") moveGroup(d.id, id, after); else if (!id.startsWith("__")) moveTab(d.id, id); }
            else if (d.kind === "tab") moveTab(d.id, groupKey, id, after);
        },
        onDoubleClick: (e) => {
            e.preventDefault(); e.stopPropagation();
            if (id.startsWith("__")) return;
            const r = e.currentTarget.getBoundingClientRect();
            setRenaming({ kind: kind === "group" ? "groups" : "tabs", id, cur: label, x: r.left + r.width / 2, y: r.bottom + 8 });
        },
        onClickCapture: (e) => { e.preventDefault(); },
        title: id.startsWith("__") ? `${label} — drag to move` : `${label} — drag to move${kind === "group" ? " · drop a tab here to move it into this group" : ""} · double-click to rename`,
    };
    const TabChip = ({ t, color, unavailable, groupKey, tile = false }) => {
        // tile = icon on top of the name (like the group tiles, smaller)
        const shapeCls = tile ? "flex-col justify-center h-full px-2.5 gap-1 rounded-lg" : "items-center gap-1.5 px-2.5 py-1 rounded-md";
        const lblCls = "text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap";
        const icCls = tile ? "h-4 w-4 shrink-0" : "h-3.5 w-3.5 shrink-0";
        const Icon = t.Icon || iconForTo(t.to);
        const isAccessGroup = groupKey === "access" || groupKey === "owner-access";
        const nhlRoute = (isNhl && !isAccessGroup) ? NHL_TAB_ROUTES[t.id] : (isAlt && !isAccessGroup) ? ALT_ROUTES[t.id] : null;
        const linkTo = nhlRoute || t.to;
        const isUnavail = unavailable || ((isNhl || isAlt) && !isAccessGroup && !nhlRoute);
        const active = isActive(linkTo);
        const isFav = !!groupKey && groupFav[favKey(groupKey)] === linkTo;
        const favHeld = shiftHeld || tabFavPick;
        const pickMode = favHeld && !!groupKey && !isUnavail;
        const rmCount = roadmapView ? (roadmapCounts[linkTo.split("?")[0]] || 0) : 0;
        const openN = access.admin ? (boardOpen?.[BOARD_OF_TAB[t.id]] || 0) : 0;
        const clRoute = linkTo.split("?")[0];
        const clCount = changelogView ? Math.max(0, (changelogCounts[clRoute] || 0) - (changelogSeen[clRoute] || 0)) : 0;
        if (isUnavail) {
            return (
                <span data-testid={`nav-sub-${t.id}`} title={isNhl ? `${t.l} — coming soon for NHL` : `${t.l} — unavailable for ${leagueLabel}`}
                    className={`group flex items-center ${shapeCls} border border-white/10 text-[#4B5563] cursor-not-allowed select-none ${arrOn ? "arr-item" : ""}`} {...arrProps("tab", t.id, t.l, groupKey)}>
                    <Icon className={icCls} strokeWidth={2} />
                    <span data-nav-label className={lblCls}>{t.l}</span>
                </span>
            );
        }
        return (
            <Link to={linkTo} data-testid={`nav-sub-${t.id}`} title={pickMode ? `Shift+click to pin ${t.l} as this group's default` : t.l}
                onClick={(e) => {
                    // Shift+click pins this tab as the group's default — and must
                    // ALWAYS preventDefault so the browser never opens a new tab/window
                    // (check the event's own shiftKey, not just the debounced hold state).
                    if ((e.shiftKey || tabFavPick) && !!groupKey && !isUnavail) { e.preventDefault(); pickFav(groupKey, linkTo, t.l); return; }
                    // Ctrl/Cmd+click opens a new tab — stamp the current league so the
                    // fresh tab stays in THIS league (PWHL stays PWHL, NHL stays NHL).
                    if (e.ctrlKey || e.metaKey) { e.preventDefault(); window.open(withLeagueParam(linkTo, isNhl), "_blank", "noopener"); }
                }}
                onAuxClick={(e) => {
                    // Middle-click (button 1) also opens a new tab — carry the league too.
                    if (e.button === 1) { e.preventDefault(); window.open(withLeagueParam(linkTo, isNhl), "_blank", "noopener"); }
                }}
                style={{ "--sel-bg": `${color}26`, "--sel-bd": `${color}59`, ...(active && (!pickMode || isFav) ? { background: `${color}26`, borderColor: `${color}59` } : {}) }}
                className={`group relative flex items-center ${shapeCls} border transition-all ${arrOn ? "arr-item" : ""} ${active ? "text-white" : "border-white/10 text-[#94A3B8] hover:text-white hover:border-white/25"} ${favHeld && !isFav ? "opacity-50" : ""} ${favHeld && !isFav ? "hover:opacity-100 hover:text-white hover:![background-color:var(--sel-bg)] hover:![border-color:var(--sel-bd)]" : ""}`}
                {...arrProps("tab", t.id, t.l, groupKey)}>
                {isFav && <Star className="absolute -top-1.5 -right-1.5 h-3 w-3 text-[#F5B301] fill-[#F5B301]" strokeWidth={2} data-testid={`nav-fav-star-${t.id}`} />}
                {rmCount > 0 && <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#9D4CDD] text-white text-[9px] font-black flex items-center justify-center leading-none shadow" data-testid={`nav-roadmap-badge-${t.id}`}>+{rmCount}</span>}
                {!rmCount && openN > 0 && <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#EF4444] text-white text-[9px] font-black flex items-center justify-center leading-none shadow" title="Open items (not completed)" data-testid={`nav-open-badge-${t.id}`}>+{openN}</span>}
                {clCount > 0 && <span className="absolute -top-1.5 -left-1.5 min-w-[16px] h-4 px-1 rounded-full bg-[#22D3EE] text-black text-[9px] font-black flex items-center justify-center leading-none shadow" data-testid={`nav-changelog-badge-${t.id}`}>{clCount}</span>}
                <Icon className={icCls} strokeWidth={2} style={active ? { color } : (labelColor ? { color: labelColor } : undefined)} />
                <span data-nav-label className={lblCls} style={labelColor ? { color: labelColor } : undefined}>{t.l}</span>
            </Link>
        );
    };
    const TitleChip = ({ sec, color }) => {
        const cls = "row-span-4 self-stretch shrink-0 w-[50px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border";
        const viewKey = sec.access ? sec.key.replace("acc-", "") : null;
        const viewOn = viewKey ? !!viewModes[viewKey] : false;
        // Access sections invert their colours when their VIEW is toggled on (double-click).
        const style = viewOn
            ? { borderColor: color, background: color, color: "#0A0B10" }
            : { borderColor: `${color}66`, background: `${color}14`, color };
        const iconTextColor = viewOn ? "#0A0B10" : (labelColor || undefined);
        const inner = sec.isLogo ? (
            <BrandImg alt="Rosterly" className="h-6 w-auto max-w-[44px] object-contain" />
        ) : (<>
            <sec.Icon className="h-4 w-4" strokeWidth={2} style={iconTextColor ? { color: iconTextColor } : undefined} />
            <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center" style={iconTextColor ? { color: iconTextColor } : undefined}>{sec.title}</span>
        </>);
        // The Rosterly logo tile lands on Schedule even though it carries the Community tabs.
        if (sec.isLogo) {
            return <Link to={isNhl ? "/nhl/schedule" : "/schedule"} data-testid={`pwhl-group-title-${sec.key}`} title="Rosterly — Schedule" className={`${cls} transition-colors hover:brightness-125`} style={style}>{inner}</Link>;
        }
        // A section with a direct `to` and no tabs (e.g. Roadmap) is a plain link.
        if (sec.to && !(sec.tabs && sec.tabs.length)) {
            return <Link to={sec.to} data-testid={`pwhl-group-title-${sec.key}`} title={sec.title} className={`${cls} transition-colors hover:brightness-125`} style={style}>{inner}</Link>;
        }
        // Access section headers: right-click toggles that access VIEW mode.
        if (sec.access && onToggleView) {
            return (
                <div className={`${cls} select-none cursor-pointer transition-colors hover:brightness-125`} style={style}
                    data-testid={`pwhl-group-title-${sec.key}`} title={`${sec.title} — right-click to toggle ${sec.title} view`}
                    onContextMenu={(e) => { e.preventDefault(); onToggleView(viewKey); }}>
                    {inner}
                </div>
            );
        }
        return <div className={`${cls} select-none`} style={style} data-testid={`pwhl-group-title-${sec.key}`}>{inner}</div>;
    };
    // Collapsed group title tile. Hovering reveals its tabs in a full-width
    // SECOND nav bar below; a click jumps to the group's first tab (or its own
    // route for no-tab sections like Roadmap).
    const CollapsedTile = ({ sec, color }) => {
        const first = sec.tabs[0];
        const isAccessSec = sec.key === "access" || sec.key === "owner-access" || sec.access;
        const hasTabs = sec.isLogo || isAccessSec || (sec.tabs || []).some((t) => (isAlt ? ALT_ROUTES[t.id] : !isNhl || NHL_TAB_ROUTES[t.id]));
        const on = openKey === sec.key;
        const viewKey = sec.access ? sec.key.replace("acc-", "") : null;
        const viewOn = viewKey ? !!viewModes[viewKey] : false;
        // Group tile opens its favourite tab (Shift+click a tab to set it); a stale
        // favourite (tab moved groups) is ignored and falls back to the first tab.
        const favTo = groupFav[favKey(sec.key)];
        // Pinned tab wins in BOTH leagues (NHL favourites are stored as NHL routes).
        const validFav = favTo && (sec.tabs || []).some((t) => t.to === favTo || (isNhl && NHL_TAB_ROUTES[t.id] === favTo)) ? favTo : null;
        const nhlFirst = isNhl ? (sec.tabs || []).find((t) => NHL_TAB_ROUTES[t.id]) : isAlt ? (sec.tabs || []).find((t) => ALT_ROUTES[t.id]) : null;
        const landing = sec.isLogo ? (validFav || (isNhl ? "/nhl/schedule" : isAlt ? ALT_HOME : "/schedule")) : (sec.to || validFav || (isNhl ? (NHL_TAB_ROUTES[nhlFirst?.id] || "/nhl/schedule") : isAlt ? (ALT_ROUTES[nhlFirst?.id] || ALT_HOME) : (first?.to || "/schedule")));
        // Access tiles invert their colours when their VIEW is toggled on (double-click).
        const tileStyle = viewOn
            ? { borderColor: color, background: color, color: "#0A0B10" }
            : { borderColor: on ? color : `${color}66`, background: `${color}${on ? "26" : "14"}`, color };
        const lblColor = viewOn ? "#0A0B10" : (labelColor || undefined);
        const inner = sec.isLogo ? (
            <BrandImg alt="Rosterly" className="h-7 w-auto max-w-[56px] object-contain" />
        ) : (<>
            <sec.Icon className="h-4 w-4" strokeWidth={2} style={lblColor ? { color: lblColor } : undefined} />
            <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center" style={lblColor ? { color: lblColor } : undefined}>{sec.title}</span>
        </>);
        const tileCls = `h-full w-[64px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border transition-colors hover:brightness-125 ${shiftHeld && (sec.isLogo || !validFav) ? "opacity-50 hover:opacity-100" : ""}`;
        // A group with no available tabs for THIS league (e.g. NHL Archives/Intel/Social)
        // stays VISIBLE but is non-interactive: no hover dropdown, no click navigation.
        if (!hasTabs) {
            return (
                <div className={`shrink-0 ${arrOn ? "arr-item" : ""}`} data-testid={`pwhl-group-${sec.key}`} title={`${sec.title} — coming soon for ${leagueLabel}`} {...arrProps("group", sec.key, sec.title)}>
                    <div className="h-full w-[64px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border select-none cursor-not-allowed"
                        style={{ borderColor: `${color}2E`, background: `${color}0A`, color: `${color}66`, opacity: 0.5 }}>{inner}</div>
                </div>
            );
        }
        // The logo/group tiles must NEVER open a new tab on shift-click (shift is
        // reserved for pinning a tab favourite); ctrl/cmd/middle still open a new tab.
        const guardClick = (e) => {
            if (e.shiftKey || tabFavPick) { e.preventDefault(); pinLanding(landing, sec.title, sec.key); return; }
            if (e.ctrlKey || e.metaKey) { e.preventDefault(); window.open(withLeagueParam(landing, isNhl), "_blank", "noopener"); }
        };
        return (
            <div className={`shrink-0 ${sec.isLogo ? "relative group/logo" : ""} ${arrOn ? "arr-item" : ""}`} data-testid={`pwhl-group-${sec.key}`} {...arrProps("group", sec.key, sec.title)} onMouseEnter={() => { setHoverKey(hasTabs ? sec.key : null); setTeamHover(false); if (!searchHasText) setSearchOpen(false); }}>
                {sec.access && onToggleView ? (
                    <Link to={landing} data-testid={`pwhl-group-title-${sec.key}`}
                        title={`${sec.title} — right-click to toggle ${sec.title} view`}
                        onContextMenu={(e) => { e.preventDefault(); onToggleView(viewKey); }}
                        onClick={guardClick}
                        onAuxClick={(e) => { if (e.button === 1) { e.preventDefault(); window.open(withLeagueParam(landing, isNhl), "_blank", "noopener"); } }}
                        className={tileCls} style={tileStyle}>{inner}</Link>
                ) : (
                    <Link to={landing} data-testid={`pwhl-group-title-${sec.key}`} title={`${sec.title}${validFav ? ` — open favourite` : first ? ` — open ${first.l}` : ""}`}
                        onClick={guardClick}
                        onAuxClick={(e) => { if (e.button === 1) { e.preventDefault(); window.open(withLeagueParam(landing, isNhl), "_blank", "noopener"); } }}
                        className={tileCls} style={tileStyle}>{inner}</Link>
                )}
                {sec.isLogo && !!user && inboxCount > 0 && (
                    <Link to={inboxCounts.to} onClick={(e) => e.stopPropagation()} title={inboxCounts.tasks ? "Open Tasks" : inboxCounts.preds ? "Predictions still to make today" : "Open Inbox"} className="absolute -top-1.5 -right-1.5 z-10 min-w-[16px] h-4 px-1 rounded-full bg-[#EF4444] hover:bg-[#F87171] text-white text-[9px] font-black flex items-center justify-center leading-none shadow" data-testid="nav-inbox-badge">+{inboxCount}</Link>
                )}
            </div>
        );
    };
    // --- Nav helpers (shared by the alternate unified strip) ---
    const navAlt = false;   // alternate unified strip removed — the standard two-row nav is the only layout now
    const pwhlNonRoadmap = useMemo(() => PWHL_SECTIONS.map((s) => {
        return s;   // Studio + Template Studio are Stories-page access pop-ups now   // Bug Reports + Inbox are visible to everyone now (non-owners get a submit form)
    }), [access.creator, access.owner]);
    const roadmapSec = useMemo(() => PWHL_SECTIONS.find((s) => s.key === "roadmap"), []);   // legacy; community is a normal group now
    // The active league's data sections (NHL is entirely separate; International has no tabs — just the country flag sort surface).
    const leagueSections = arrangeSections(isNhl ? NHL_SECTIONS : pwhlNonRoadmap, navStruct)
        .map((s) => ({ ...s, tabs: (s.tabs || []).filter((t) => (!t.owner || isOwner) && (!t.admin || ["admin", "owner"].includes(user?.role))) }))
        .filter((s) => (s.tabs || []).length > 0);
    const ROW_H = 32; // px per row
    const stripStyle = { gridTemplateRows: `repeat(2, ${ROW_H}px)` };
    const rows4 = { gridTemplateRows: `repeat(4, ${ROW_H}px)` };
    const NHL_DIVISION_ORDER = ["Atlantic", "Metropolitan", "Central", "Pacific"];
    const tileH = ROW_H * 2 + 4; // two rows + one gap
    const teamBtn = (id, k) => {
        if (!id) return <div key={k} aria-hidden="true" />;
        const active = activeSurf === id || (isPwhl && pwhlSurfMulti.includes(id)) || (isPwhl && !!pwhlSurfGroup && pwhlConfOf(id) === pwhlSurfGroup) || (favPickMode && isFavStar(id));
        const col = surfColorOf(id);
        if (notifyMode) {
            const on = notif.isOn("pwhl", id);
            return (
                <button key={id} type="button" data-testid={`team-surf-${id}`} title={`${TEAM_INFO[id]?.name || id} — notifications ${on ? "ON. Click to turn off" : "off. Click to turn on"}`}
                    onClick={() => notif.toggle("pwhl", id)}
                    style={on ? { background: `${col}26`, borderColor: `${col}59` } : undefined}
                    className={`relative inline-flex items-center justify-center w-[42px] rounded-lg border transition-all ${on ? "" : "bg-black/25 border-white/15 opacity-30 grayscale hover:opacity-70"}`}>
                    <TeamBadge teamId={id} size="xs" asLink={false} />
                </button>
            );
        }
        return (
            <button key={id} type="button" data-testid={`team-surf-${id}`} title={`${TEAM_INFO[id]?.name || id} — click to sort · shift+click to add/remove more teams (pin on roster/lineup pages) · shift+right-click to pin for this page`}
                onClick={(e) => onSurfPick(id, e)}
                onContextMenu={(e) => { if (e.shiftKey) { e.preventDefault(); pinPageTeam(id, TEAM_INFO[id]?.abbr || id.toUpperCase()); } }}
                style={{ "--sel-bg": `${col}26`, "--sel-bd": `${col}59`, ...(active ? { background: `${col}26`, borderColor: `${col}59` } : {}) }}
                className={`relative inline-flex items-center justify-center w-[42px] rounded-lg border transition-all ${active ? "" : "bg-black/25 border-white/15 hover:brightness-125"} ${shiftHeld && !active && pwhlPin !== id ? "opacity-50" : ""} ${shiftHeld ? "hover:opacity-100 hover:![background-color:var(--sel-bg)] hover:![border-color:var(--sel-bd)]" : ""}`}>
                <TeamBadge teamId={id} size="xs" asLink={false} />
                {favPickMode && isFavStar(id) && <Star className="absolute -top-1 -right-1 h-3 w-3 text-[#F6C453] fill-[#F6C453]" data-testid={`team-fav-star-${id}`} />}
            </button>
        );
    };
    const sectionTitle = (sec, color) => {
        const viewKey = sec.access ? sec.key.replace("acc-", "") : null;
        const viewOn = viewKey ? !!viewModes[viewKey] : false;
        const style = viewOn
            ? { borderColor: color, background: color, color: "#0A0B10" }
            : { borderColor: `${color}66`, background: `${color}14`, color };
        const lbl = viewOn ? "#0A0B10" : (labelColor || undefined);
        const inner = sec.isLogo ? (
            <BrandImg alt="Rosterly" className="h-6 w-auto max-w-[40px] object-contain" />
        ) : (<>
            <sec.Icon className="h-4 w-4" strokeWidth={2} style={lbl ? { color: lbl } : undefined} />
            <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center" style={lbl ? { color: lbl } : undefined}>{sec.title}</span>
        </>);
        const cls = "row-span-2 self-stretch shrink-0 w-[46px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border transition-colors hover:brightness-125";
        const landing = sec.isLogo ? (isNhl ? "/nhl/schedule" : "/schedule") : (sec.to || sec.tabs?.[0]?.to || "/");
        if (sec.access && onToggleView) {
            return <Link to={landing} data-testid={`pwhl-group-title-${sec.key}`} title={`${sec.title} — right-click to toggle ${sec.title} view`} onContextMenu={(e) => { e.preventDefault(); onToggleView(viewKey); }} className={cls} style={style}>{inner}</Link>;
        }
        return <Link to={landing} data-testid={`pwhl-group-title-${sec.key}`} title={sec.title} className={cls} style={style}>{inner}</Link>;
    };
    const renderSection = (sec, color) => (
        <div key={sec.key} className="grid grid-flow-col gap-1 shrink-0" style={stripStyle} data-testid={`pwhl-group-${sec.key}`}>
            {sectionTitle(sec, color)}
            {(sec.tabs || []).map((t) => <TabChip key={t.id} t={t} groupKey={sec.key} color={color} unavailable={isNonPwhl && NCAA_UNAVAILABLE_TABS.has(t.id)} />)}
        </div>
    );
    // --- Nav toggle board (drag-and-drop layout, per-user; owner right-click access levels) ---
    const toggleBtns = (() => {
        const btns = [];
        if (location.pathname === "/stories" && (access.creator || access.owner)) {
            btns.push({ key: "studio", eligible: true, render: () => (
                <button type="button" data-testid="access-view-studio" title="Studio (pop-up)" onClick={() => openStudioPopup("studio")} className={AZ_BTN} style={azPill(false, "#EC4899")}>
                    <Clapperboard className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Studio</span>
                </button>) });
            btns.push({ key: "tstudio", eligible: true, render: () => (
                <button type="button" data-testid="access-view-tstudio" title="Template Studio (pop-up)" onClick={() => openStudioPopup("templates")} className={AZ_BTN} style={azPill(false, "#EC4899")}>
                    <LayoutTemplate className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Template Studio</span>
                </button>) });
        }
        btns.push({ key: "surf", eligible: true, render: () => (
            <button type="button" data-testid="access-view-surf" title={surfMode ? "Surf ON — the team you pick follows you to every page" : "Surf OFF — pages go back to your favourite team"}
                onClick={() => {
                    setSurfMode(!surfMode);
                    const els = [...document.querySelectorAll('[data-testid="team-surf-block"],[data-testid="nhl-team-surf-block"],[data-testid="intl-team-surf-block"]')].filter((e) => e.offsetParent);
                    els[0]?.scrollIntoView({ behavior: "smooth", block: "nearest" });
                    els.forEach((e) => { e.classList.remove("surf-flash"); void e.offsetWidth; e.classList.add("surf-flash"); setTimeout(() => e.classList.remove("surf-flash"), 1700); });
                }} className={AZ_BTN} style={azPill(surfMode, "#38BDF8")}>
                <SurfboardIcon className="h-3.5 w-3.5 shrink-0" /><span className="leading-none">Surf</span>
            </button>) });
        btns.push({ key: "favourite", eligible: true, render: () => (
            <button type="button" data-testid="access-view-favourite" title={favPickMode ? "Favourite ON — click a team on the board to make it your favourite (click again to clear)" : "Favourite — pick your favourite team from the team board (same as Shift+click)"}
                onClick={() => { setFavPickMode(!favPickMode); setTabFavPick(false); }} className={AZ_BTN} style={azPill(favPickMode, "#F6C453")}>
                <Star className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Favourite</span>
            </button>) });
        btns.push({ key: "tabfav", eligible: true, render: () => (
            <button type="button" data-testid="access-view-tabfav" title={tabFavPick ? "Fav Tabs ON — click a tab to pin it as its group's default; click a group tile to make it your landing group" : "Fav Tabs — pin a favourite tab per group (same as Shift+click a tab)"}
                onClick={() => { setTabFavPick(!tabFavPick); setFavPickMode(false); }} className={AZ_BTN} style={azPill(tabFavPick, "#F6C453")}>
                <Pin className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Fav Tabs</span>
            </button>) });
        btns.push({ key: "notify", eligible: true, render: () => (
            <button type="button" data-testid="access-view-notify" title="Notifications — tick teams in the team board to get their alerts (same as My Account)"
                onClick={() => { if (!notif.enabled) { toast("Sign in to get team notifications"); navigate("/login"); return; } setPref("page_toggle", "notify_pick", notifyMode ? null : "on"); }} className={AZ_BTN} style={azPill(notifyMode, "#F59E0B")}>
                <Bell className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Notifications</span>
            </button>) });
        accessSections.forEach((sec) => {
            const vk = sec.key.replace("acc-", "");
            // NHL schedule page: hide Creator view toggle only. The OWNER
            // toggle MUST stay (owner mode gates prediction overrides).
            if (accessPageKey === "/nhl/schedule" && vk === "creator") return;
            const on = !!viewModes[vk];
            btns.push({ key: `view:${vk}`, eligible: true, render: () => (
                <button type="button" data-testid={`access-view-${vk}`} title={`${sec.title} view — click to toggle · Shift+click = lock this page`}
                    onClick={(e) => { if (onToggleView) onToggleView(vk, e.shiftKey); else navigate(sec.tabs?.[0]?.to || "/"); }}
                    className={AZ_BTN} style={azPill(on, sec.color)}>
                    <sec.Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">{sec.title}</span>
                </button>) });
        });
        if (isOwner) {
            btns.push({ key: "changelog", eligible: true, render: () => (
                <button type="button" data-testid="access-view-changelogview" title="Changelog View — surface every recent edit on each page"
                    onClick={() => setChangelogView(!changelogView)} className={AZ_BTN} style={azPill(changelogView, "#22D3EE")}>
                    <ScrollText className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Changelog</span>
                </button>) });
            if (location.pathname === "/nhl/leaderboards") {
                const lbBldOn = getPref("page_toggle", "nhl_lb_builder") === "on";
                btns.push({ key: "builder", eligible: true, render: () => (
                    <button type="button" data-testid="access-view-builder" title="Builder — rename stat groups & drag columns between them"
                        onClick={() => setPref("page_toggle", "nhl_lb_builder", lbBldOn ? null : "on")} className={AZ_BTN} style={azPill(lbBldOn, "#F5B301")}>
                        <Hammer className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Builder</span>
                    </button>) });
            }
            if (location.pathname === "/contracts") {
                const cutOn = getPref("page_toggle", "contracts_cut") === "on";
                btns.push({ key: "cut", eligible: false, render: () => (
                    <button type="button" data-testid="access-view-cut" title={cutOn ? "Cut ON — click a player's season cell to cut them (confirm first). Click to finish." : "Cut — owner tool: cut a player from their team (inactive, recorded on History)"}
                        onClick={() => setPref("page_toggle", "contracts_cut", cutOn ? null : "on")} className={AZ_BTN} style={azPill(cutOn, "#F97316")}>
                        <Scissors className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Cut</span>
                    </button>) });
            }
        }
        if (["/leaderboards", "/team-leaderboards"].includes(location.pathname)) {
            const lbm = getPref("page_toggle", "lb_mode") || "basic";
            [["trends", "Trends", TrendingUp, "#38BDF8"], ["milestones", "Milestones", Star, "#F6C453"], ["gamelogs", "Game Logs", ScrollText, "#A78BFA"]].forEach(([k, label, Icon, color]) => {
                btns.push({ key: `lb_${k}`, eligible: true, render: () => (
                    <button type="button" data-testid={`access-view-lb-${k}`} title={`${label} mode`}
                        onClick={() => setPref("page_toggle", "lb_mode", lbm === k ? null : k)} className={AZ_BTN} style={azPill(lbm === k, color)}>
                        <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">{label}</span>
                    </button>) });
            });
            btns.push({ key: "lb_compare", eligible: true, render: () => (
                <button type="button" data-testid="access-view-lb-compare" title="Player vs Player comparison" onClick={() => navigate("/compare")} className={AZ_BTN} style={azPill(false, "#22C55E")}>
                    <Users className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Compare</span>
                </button>) });
        }
        // Every league's schedule gets the same buttons (View, Spoilers, Favourites, Day/Week/Month, Delay, Predict…).
        // All Leagues is a FEATURE on each league's own Schedule page (same URL, same tab) — its toggles save under all_sched.
        const allMode = getPref("page_toggle", "all_sched_on") === "on" && (getPref("page_toggle", "all_sched_show") || "").split(",").filter(Boolean).length >= 2 && ["/schedule", "/nhl/schedule", "/nat/schedule", "/ncaa/schedule"].includes(location.pathname);
        const schedPfxAll = allMode ? "all_sched" : { "/schedule": "sched", "/nhl/schedule": "nhl_sched", "/nat/schedule": "nat_sched", "/ncaa/schedule": "ncaa_sched", "/all/schedule": "all_sched" }[location.pathname];
        if (schedPfxAll) {
            const spoilOn = getPref("page_toggle", `${schedPfxAll}_spoilers`) === "on";
            btns.push({ key: "spoiler", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-spoiler" title="Spoilers — hide live/final scores on the schedule"
                    onClick={() => setPref("page_toggle", `${schedPfxAll}_spoilers`, spoilOn ? null : "on")} className={AZ_BTN} style={azPill(spoilOn, "#EF4444")}>
                    {spoilOn ? <EyeOff className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <Eye className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">Spoilers</span>
                </button>) });
        }
        // PWHL + NAT schedules get the SAME Compact toggle as NHL; all 3 get Day | Week | Month.
        const schedPfx = schedPfxAll;
        if (schedPfx) {
            btns.push({ key: "compact", eligible: isOwner, render: () => <CardSizeBtn pfx={schedPfx} getPref={getPref} setPref={setPref} Pop={DispPop} /> });
        }
        if (["sched", "nhl_sched", "nat_sched", "all_sched"].includes(schedPfx)) {
            const ffOn = getPref("page_toggle", `${schedPfx}_fav_first`) !== "off";
            btns.push({ key: "favfirst", eligible: true, render: () => (
                <button type="button" data-testid="access-view-fav-first" title="Favourites first — your favourite teams' games show at the top of each day"
                    onClick={() => setPref("page_toggle", `${schedPfx}_fav_first`, ffOn ? "off" : null)} className={AZ_BTN} style={azPill(ffOn, "#F6C453")}>
                    <Star className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Favourites</span>
                </button>) });
        }
        const rangePfx = location.pathname === "/stories" ? "stories" : schedPfx;
        if (rangePfx) {
            const rg = getPref("page_toggle", `${rangePfx}_range`) || "week";
            const RANGES = [["day", "Day", CalendarClock], ["week", "Week", CalendarRange], ["month", "Month", CalendarDays]];
            if (typeof window !== "undefined" && window.innerWidth < 1024) {
                RANGES.forEach(([k, l, RIcon]) => btns.push({ key: `range-${k}`, eligible: true, render: () => (
                    <button type="button" data-testid={`access-view-range-${k}`} title={`${l} view`}
                        onClick={() => setPref("page_toggle", `${rangePfx}_range`, k)} className={AZ_BTN} style={azPill(rg === k, "#8A94A6")}>
                        <RIcon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">{l}</span>
                    </button>) }));
            } else {
                // Desktop: one Day / Week / Month pop-up, like View and Display.
                const RCur = (RANGES.find(([k]) => k === rg) || RANGES[1]);
                btns.push({ key: "range-week", eligible: true, render: () => (
                    <DispPop k="range" label={RCur[1]} Icon={RCur[2]} active={false} color="#8A94A6">
                        <div className="text-[10px] font-black uppercase tracking-wider text-white/50 mb-1.5">Range</div>
                        <div className="flex gap-1" data-testid="access-view-range-pop">
                            {RANGES.map(([k, l]) => (
                                <button key={k} type="button" onClick={() => setPref("page_toggle", `${rangePfx}_range`, k)} data-testid={`access-view-range-${k}`}
                                    className={`h-7 px-2.5 rounded-md border text-[10px] font-bold uppercase transition-colors ${rg === k ? "border-white/60 bg-white/15 text-white" : "border-white/10 bg-white/5 text-white/70 hover:text-white"}`}>{l}</button>
                            ))}
                        </div>
                    </DispPop>
                ) });
            }
        }
        if (schedPfx) {
            // Leagues: tap a league to show / hide it (2+ shown = every shown league on one schedule), drag to order.
            // Mobile = the chips right in the bar; desktop = a pop-up.
            const lgRoute = { pwhl: "/schedule", nhl: "/nhl/schedule", international: "/nat/schedule", ncaa: "/ncaa/schedule" };
            const onShown = (list) => {
                if (list.length > 1) { setPref("page_toggle", "all_sched_on", "on"); }  // stay on this league's Schedule — All Leagues is a feature, not a page
                else { setPref("page_toggle", "all_sched_on", null); if (location.pathname !== lgRoute[list[0]]) navigate(lgRoute[list[0]] || "/schedule"); }
            };
            const chips = () => <LeagueSortChips getPref={getPref} setPref={setPref} league={league} onShown={onShown} single={schedPfx !== "all_sched"} />;
            btns.push({ key: "allleagues", eligible: true, render: () => (typeof window !== "undefined" && window.innerWidth < 1024 ? chips() : (
                <DispPop k="allleagues" label="Leagues" Icon={Layers} active={schedPfx === "all_sched"} color="#F6C453">
                    <div className="text-[10px] font-black uppercase tracking-wider text-white/50 mb-1.5">Tap to show · drag to order</div>
                    {chips()}
                </DispPop>
            )) });
        }
        if (schedPfx) {
            const bcOn = getPref("page_toggle", "broadcast_on") === "on";
            btns.push({ key: "broadcast", eligible: true, render: () => (
                <button type="button" onClick={() => setPref("page_toggle", "broadcast_on", bcOn ? null : "on")} data-testid="access-broadcast" aria-pressed={bcOn}
                    title="Broadcast — show where every game is on TV / streaming (all leagues)" className={AZ_BTN} style={azPill(bcOn, "#F97316")}>
                    <Radio className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Broadcast</span>
                </button>
            ) });
        }
        if (schedPfx) {
            // Styles — one setting for every league (saved once, applies everywhere): PWHL style | NHL style.
            const st = getPref("page_toggle", "league_style") === "pwhl" ? "pwhl" : "nhl";
            btns.push({ key: "styles", eligible: isOwner, render: () => (
                <DispPop k="styles" label="Styles" Icon={Palette} active={st === "pwhl"} color="#38BDF8">
                    <div className="flex gap-1" data-testid="access-styles-options">
                        {[["pwhl", "PWHL style"], ["nhl", "NHL style"]].map(([k, l]) => (
                            <button key={k} type="button" onClick={() => setPref("page_toggle", "league_style", k === "pwhl" ? "pwhl" : null)} data-testid={`access-style-${k}`}
                                className={`h-7 px-2.5 rounded-md border text-[10px] font-bold uppercase transition-colors ${st === k ? "border-white/60 bg-white/15 text-white" : "border-white/10 bg-white/5 text-white/70 hover:text-white"}`}>{l}</button>
                        ))}
                    </div>
                </DispPop>
            ) });
        }
        if (["/schedule", "/nhl/schedule", "/nat/schedule", "/all/schedule", "/nat/standings", "/standings"].includes(location.pathname)) {
            const pk = location.pathname === "/standings" ? "/standings:predict" : (allMode || location.pathname === "/all/schedule") ? "all_sched_predict" : location.pathname === "/nhl/schedule" ? "nhl_sched_predict" : location.pathname.startsWith("/nat/") ? "nat_sched_predict" : "sched_predict";
            const predOn = getPref("page_toggle", pk) === "on";
            btns.push({ key: "predict", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-predict" title="Predict — enter a score & result for each game; your picks rebuild the standings"
                    onClick={() => { if (!user) { toast("Sign in to make predictions"); navigate("/login"); return; } setPref("page_toggle", pk, predOn ? null : "on"); }} className={AZ_BTN} style={azPill(predOn, "#3B82F6")}>
                    <TrendingUp className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Predict</span>
                </button>) });
        }
        if (["/chemistry", "/nhl/chemistry"].includes(location.pathname)) {
            const findOn = getPref("page_toggle", "chem_find") === "on";
            btns.push({ key: "find", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-chem-find" title="Find Combinations — search by up to 3 players"
                    onClick={() => setPref("page_toggle", "chem_find", findOn ? null : "on")} className={AZ_BTN} style={azPill(findOn, "#9D4CDD")}>
                    <Search className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Find</span>
                </button>) });
        }
        if (location.pathname === "/nhl/standings") {
            const lvPref = getPref("page_toggle", "live_standings");
            const liveOn = lvPref !== false && lvPref !== "false" && lvPref !== "False";
            const predOn = getPref("page_toggle", "nhl_standings_predicted") === "on";
            btns.push({ key: "live", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-live" title="Live — red dot on teams playing now + auto-refresh while games are live"
                    onClick={() => setPref("page_toggle", "live_standings", liveOn ? false : null)} className={AZ_BTN} style={azPill(liveOn, "#EF4444")}>
                    <span className={`h-2 w-2 rounded-full ${liveOn ? "bg-[#0A0B10]" : "bg-[#EF4444] animate-pulse"}`} /><span className="leading-none">Live</span>
                </button>) });
            btns.push({ key: "predicted", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-predicted-standings" title="Predicted — project YOUR game picks across the season (NHL points)"
                    onClick={() => setPref("page_toggle", "nhl_standings_predicted", predOn ? null : "on")} className={AZ_BTN} style={azPill(predOn, "#3B82F6")}>
                    <TrendingUp className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Predicted</span>
                </button>) });
        }
        if (hasSegs && accessPageKey !== "/nhl/schedule") btns.push({ key: "favtoggles", eligible: true, render: () => <FavTogglesBtn /> });
        if (user && ["/schedule", "/nhl/schedule", "/nat/schedule", "/all/schedule", "/nhl/standings"].includes(location.pathname)) {
            btns.push({ key: "delay", eligible: true, render: () => <DelayPop /> });
        }
        if (location.pathname === "/rankings") {
            const repOn = getPref("page_toggle", "reports:/rankings") === "on";
            btns.push({ key: "reports", eligible: true, render: () => (
                <button type="button" data-testid="access-view-reports" title="Reports — each month's final rankings, saved for good"
                    onClick={() => setPref("page_toggle", "reports:/rankings", repOn ? null : "on")} className={AZ_BTN} style={azPill(repOn, "#38BDF8")}>
                    <FileText className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Reports</span>
                </button>) });
        }
        if (isOwner && ["/standings", "/nhl/standings"].includes(location.pathname)) {
            const colsOn = getPref("page_toggle", `cols_edit:${location.pathname}`) === "on";
            btns.push({ key: "builder", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-builder" title="Builder — drag the table's column headers to reorder"
                    onClick={() => setPref("page_toggle", `cols_edit:${location.pathname}`, colsOn ? null : "on")} className={AZ_BTN} style={azPill(colsOn, "#F5B301")}>
                    <Hammer className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Builder</span>
                </button>) });
        }
        if (["/standings", "/nhl/standings", "/leaderboards", "/team-leaderboards", "/nhl/leaderboards"].includes(location.pathname)) {
            const heatOn = getPref("page_toggle", `cond_format:${location.pathname}`) === "on";
            btns.push({ key: "format", eligible: isOwner, render: () => (
                <button type="button" data-testid="access-view-format" title="Format — conditional formatting: tint every stat column green (best) to red (worst)"
                    onClick={() => setPref("page_toggle", `cond_format:${location.pathname}`, heatOn ? null : "on")} className={AZ_BTN} style={azPill(heatOn, "#22C55E")}>
                    <Palette className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Format</span>
                </button>) });
        }
        if (user && ["/standings", "/nhl/standings", "/schedule", "/nhl/schedule", "/nat/schedule", "/all/schedule"].includes(location.pathname)) {
            btns.push({ key: "leagues", eligible: isOwner, render: () => (
                <LeaguesAccessButton className={AZ_BTN} style={azPill(false, "#F6C453")} title="Prediction Leagues" />
            ) });
        }
        {
            (displayBtns || []).forEach((b) => btns.push({ ...b, eligible: true }));
            btns.push({ key: "navhide", eligible: true, render: () => (
                <button type="button" data-testid="access-nav-hide" title={navsHidden ? "Show all nav bars" : "Hide all nav bars"}
                    onClick={() => onToggleNavsHidden && onToggleNavsHidden()} className={AZ_BTN} style={azPill(navsHidden, "#F59E0B")}>
                    {navsHidden ? <ChevronsUpDown className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <ChevronsDownUp className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">{navsHidden ? "Show Bars" : "Hide Bars"}</span>
                </button>) });
            btns.push({ key: "navextend", eligible: true, render: () => (
                <button type="button" data-testid="access-nav-extend" title={navExtendedVal ? "Nav toggles: Inline" : "Nav toggles: Dropdown"}
                    onClick={() => setNavExtended(!navExtendedVal)} className={AZ_BTN} style={azPill(!navExtendedVal, "#38BDF8")}>
                    {navExtendedVal ? <ChevronsLeftRight className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <ChevronsRightLeft className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">{navExtendedVal ? "Inline" : "Dropdown"}</span>
                </button>) });
            btns.push({ key: "borders", eligible: true, render: () => (
                <button type="button" data-testid="access-borders" title={`Borders: ${borderMode === "extended" ? "Extended (wide)" : "Basic (narrow)"} · Shift+click = lock this page`}
                    onClick={(e) => onToggleBorders && onToggleBorders(e.shiftKey)} className={AZ_BTN} style={azPill(borderMode === "extended", "#2DD4BF")}>
                    {borderMode === "extended" ? <UnfoldHorizontal className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <FoldHorizontal className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">{borderMode === "extended" ? "Extended" : "Borders"}</span>
                </button>) });
        }
        if (isOwner) btns.push({ key: "arrange", eligible: false, render: () => (
            <button type="button" data-testid="access-nav-arrange" title={navArrange ? "Arrange ON — drag toggles into columns / before or after the team board · right-click a toggle for Icon/Full · click to finish" : "Arrange — drag & drop your nav toggles"}
                onClick={() => setNavArrange(!navArrange)} className={AZ_BTN} style={azPill(navArrange, "#A3E635")}>
                <Move className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Arrange</span>
            </button>) });
        // ACCOUNT group — normal access buttons shown when the Account tile is on; each opens the account pop-up.
        if (user) [
            ["acc_account", "Account", UserCircle, "account"],
            ["acc_home", "Favourites", Star, "home"],
            ["acc_notifications", "Notifications", Bell, "notifications"],
            ["acc_objectives", "Objectives", Target, "objectives"],
            access.owner && ["acc_finances", "Finances", PoundSterling, "finances"],
            access.owner && ["acc_reports", "Full Reports", BarChart3, "reports"],
            (access.owner || access.admin) && ["acc_accounts", "Accounts & Users", Users, "accounts"],
            access.owner && ["acc_settings", "Settings", Settings, "settings"],
            access.owner && ["acc_storage", "Storage Centre", HardDrive, "storage"],
            access.owner && ["acc_leagues", "All Leagues", Trophy, "leagues"],
        ].filter(Boolean).forEach(([key, label, Ic, tab]) => btns.push({ key, label, eligible: true, render: () => (
            <button type="button" data-testid={`access-${key}`} title={label} onClick={() => openAccountModal(tab)} className={AZ_BTN} style={azPill(openPanel.acc === tab, ACCOUNT_COLOR)}>
                <Ic className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">{label}</span>
            </button>) }));
        if (user) btns.push({ key: "acc_signout", eligible: true, render: () => (
            <button type="button" data-testid="access-acc_signout" title="Sign Out" onClick={() => { if (window.confirm("Are you sure you want to sign out?")) { logout(); navigate("/"); } }} className={AZ_BTN} style={azPill(false, "#F87171")}>
                <LogOut className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Sign Out</span>
            </button>) });
        return btns;
    })();
    // Access box shows ONLY the group whose tile is on (Account / Display / Admin Tools / Owner Tools).
    const navGroupOf = (k) => (isPageKey(k) ? "page" : NAV_DISPLAY.has(k) ? "display" : k.startsWith("own_") ? "owner" : k.startsWith("acc_") ? "account" : "admin");
    const navForce = new Set(toggleBtns.map((b) => b.key).filter((k) => k === "reports" || (displayOn && navGroupOf(k) === "display") || (accountOn && (navGroupOf(k) === "owner" || navGroupOf(k) === "account")) || (pageOn && (navGroupOf(k) === "admin" || isPageKey(k)))));
    const navHide = new Set(toggleBtns.map((b) => b.key).filter((k) => k === "arrange" ? !displayOn && !allButtons && !ownerToolsOn : navGroupOf(k) === "owner" ? !accountOn : navGroupOf(k) === "account" ? !accountOn : navGroupOf(k) === "display" && !displayOn));
    const leftAccess = LEFT_ACCESS.map((k) => toggleBtns.find((b) => b.key === k)).filter(Boolean);
    const endOnly = (b) => !LEFT_ACCESS.includes(b.key) && (pageOn ? navGroupOf(b.key) === "admin" && b.key !== "arrange" : accountOn ? ["account", "owner"].includes(navGroupOf(b.key)) : b.key === "arrange" ? displayOn || allButtons || ownerToolsOn : ownerToolsOn ? navGroupOf(b.key) === "owner" : displayOn ? navGroupOf(b.key) === "display" : (allButtons || !isOwner) && !["display", "owner", "account"].includes(navGroupOf(b.key)));
    const board = useNavBoard({ buttons: toggleBtns, layout: navLayout, onLayout: saveNavToggleLayout, pageKey: accessPageKey, levels: accessLevels, globalLevels: (siteSettings?.access_levels || {})["*"] || {}, publicKeys: accessPublicKeys, isOwner, user, access, arrange: navArrange, force: isOwner ? navForce : null, hide: navHide, devices: siteSettings?.access_devices || {}, mobileStyle: siteSettings?.access_mobile_style || {} });
    const hasTeamBlock = (isPwhl && surfIds.length > 0) || (isNhl && nhlTeams.length > 0) || isIntl || isNcaa;
    useEffect(() => { publishAccess(board.mobileList); });
    const sep = <span className="self-stretch w-px bg-white/15 mx-1 shrink-0" aria-hidden="true" />;
    // Account on: my account buttons | owner tools buttons, split by the separator.
    // Display / Account take over the TABS box with full-name buttons.
    const boxTakeover = (displayOn || accountOn) && !pageOn;
    const slotEnd = accountOn
        ? board.renderSlot("end", { rows: 2, full: true, only: (b) => ["account", "owner"].includes(navGroupOf(b.key)) })
        : board.renderSlot("end", { rows: 2, only: endOnly, full: boxTakeover });
    const pageGrid = pageOn ? board.renderPage({ grid: true }) : null;
    pageHasBtns.current = toggleBtns.some((b) => isPageKey(b.key));
    // Page-specific access buttons live on the page bar (nav bar 3) — portalled into its slot.
    const [pageTarget, setPageTarget] = useState(null);
    useEffect(() => { const el = document.getElementById("page-access-slot"); if (el !== pageTarget) setPageTarget(el); });
    const pageSlotNode = null;
    const slotOrphans = hasTeamBlock ? null : <>{board.renderSlot("before", { rows: 2 })}{board.renderSlot("after", { rows: 2 })}</>;
    const boardEnd = (slotEnd || slotOrphans || pageGrid) ? (
        <div className={`flex items-stretch gap-1 p-2 rounded-xl border bg-[#0A0B10]/80 backdrop-blur transition-colors ${boxTakeover ? "flex-1 min-w-0 overflow-x-auto no-scrollbar" : "shrink-0"}`} style={{ borderColor: pageOn ? "#A3E63566" : accountOn ? `${ACCOUNT_COLOR}66` : ownerToolsOn ? `${OWNER_TOOLS_COLOR}66` : allButtons ? "#F6C45366" : displayOn ? "#2DD4BF66" : "rgba(255,255,255,0.15)" }} data-testid="access-zones" onContextMenu={(e) => e.preventDefault()}>
            {slotOrphans}{pageGrid}{pageGrid && slotEnd && sep}{slotEnd}
        </div>
    ) : null;
    const leagueBtn = (id, pre, w, full = false) => {
        const L = LEAGUE_GROUPS.flatMap(([, , l]) => l).find((x) => x.id === id) || { name: id.toUpperCase() };
        const c = L.color || "#9D4CDD";
        const on = league === id;
        if (L.off) return (
            <button key={id} type="button" disabled data-testid={`${pre}-league-${id}`} title={`${L.full || L.name} — coming soon`}
                className={`${w ? leadCls.replace("w-[74px]", w) : leadCls} border-white/8 bg-black/15 text-white/25 cursor-not-allowed`}>{L.name}</button>
        );
        return (
            <button key={id} type="button" data-testid={`${pre}-league-${id}`} title={`${L.full || L.name} · shift+click to favourite`}
                onClick={(e) => { if (e.shiftKey || favPickMode) { const n = toggleFavLeague(id); toast(n ? `${L.name} is your favourite league` : "Favourite league removed"); return; } onPickLeague(id); }}
                style={on ? { background: `${c}26`, borderColor: `${c}59`, color: "#fff" } : undefined}
                className={`relative ${w ? leadCls.replace("w-[74px]", w) : leadCls} ${on ? "" : "bg-black/25 border-white/15 text-white/70 hover:text-white hover:brightness-125"}`}>
                {L.name}
                {favLeague === id && (favPickMode || shiftHeld) && <Star className="absolute top-0.5 right-0.5 h-2.5 w-2.5 fill-[#F6C453] text-[#F6C453]" data-testid={`${pre}-league-fav-${id}`} />}
            </button>
        );
    };
    const leadCls = "w-[74px] rounded-lg border text-[10px] font-black uppercase tracking-wider flex items-center justify-center px-1 transition-colors";
    // --- ALTERNATE unified strip (opt-in: localStorage rosterly_nav_alt === "1") ---
    if (navAlt) {
        return (
            <div className="w-full" data-testid="pwhl-sections-bar">
                <div className="flex items-start justify-start gap-2 overflow-x-auto pb-1">
                    {isPwhl && surfIds.length > 0 ? (
                        <div className="grid grid-flow-col gap-1 shrink-0" style={stripStyle} data-testid="team-surf-block">
                            <button type="button" data-testid="team-surf-league" disabled title="League switching — coming soon (only the PWHL is available right now)"
                                className={`${leadCls} bg-black/25 border-white/10 text-[#5B6472] cursor-not-allowed opacity-60`}>League</button>
                            <button type="button" data-testid="team-surf-all" onClick={(e) => { if (notifyMode) { const ids = surfIds.filter(Boolean); notif.setMany("pwhl", ids, !notif.allOn("pwhl", ids)); return; } if (e.shiftKey) pinPageTeam("all", "All Teams"); setSurfTeam(null); if (onTeamSelect) onTeamSelect(null); }}
                                style={!activeSurf ? { background: `${ovColor}26`, borderColor: `${ovColor}59`, color: "#fff" } : undefined}
                                className={`${leadCls} ${!activeSurf ? "" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"}`}>All Teams</button>
                            {[0, 1, 2, 3, 4, 5].flatMap((i) => [teamBtn(surfIds[i], `top-${i}`), teamBtn(surfIds[i + 6], `bot-${i}`)])}
                        </div>
                    ) : (
                        <button type="button" onClick={() => { if (canSwitch && onChangeLeague) onChangeLeague(); else navigate(isNhl ? "/nhl/schedule" : bigTo); }} data-testid="nav-league-overview"
                        title={isOwner ? "Switch league (Men's / Women's)" : leagueLabel}
                            style={{ height: `${tileH}px`, borderColor: `${ovColor}66`, color: labelColor || ovColor }}
                            className="shrink-0 w-[74px] flex flex-col items-center justify-center gap-1 rounded-lg border transition-colors hover:brightness-125">
                            <OvIcon className="h-5 w-5" strokeWidth={2} />
                            <span className="text-[9px] font-black uppercase tracking-[0.08em]">{leagueLabel}</span>
                        </button>
                    )}
                    {pwhlNonRoadmap.map((sec) => renderSection(sec, teamColor || resolve(sec.color)))}
                    {roadmapSec && renderSection(roadmapSec, teamColor || resolve(roadmapSec.color))}
                    {accessSections.map((sec) => renderSection(sec, sec.color))}
                    <button type="button" data-testid="nav-search-tile"
                        onClick={() => { setSearchOpen((v) => !v); setSearchFocusToken((t) => t + 1); }}
                        title="Search"
                        style={{ height: `${tileH}px`, borderColor: "#94A3B866", color: "#94A3B8" }}
                        className="shrink-0 w-[52px] flex flex-col items-center justify-center gap-1 rounded-lg border transition-colors hover:brightness-125">
                        <Search className="h-4 w-4" strokeWidth={2} />
                        <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight">Search</span>
                    </button>
                    <AccountNavButton style={{ height: `${tileH}px`, borderColor: "#94A3B866", color: "#94A3B8" }}
                        className="shrink-0 w-[52px] flex flex-col items-center justify-center gap-1 rounded-lg border transition-colors hover:brightness-125 hover:text-white" />
                    <NavExtraTiles isOwner={isOwner} displayOn={displayOn} setDisplayOn={setDisplayOn} style={{ height: `${tileH}px` }} cls="w-[52px]" />
                    {sideControls}
                </div>
                {searchOpen && (
                    <div className="fixed left-0 right-0 top-full z-[60] px-4 pt-2 pointer-events-none" data-testid="pwhl-secondbar-search">
                        <div className="pointer-events-auto mx-auto max-w-[1100px] p-2 rounded-xl border border-white/10 bg-[#0A0B10]/95 backdrop-blur-xl shadow-2xl shadow-black/60 animate-slide-up">
                            <GlobalSearch testId="global-search" compact bar focusToken={searchFocusToken} resultsBar onQueryChange={setSearchHasText} onNavigate={() => { setSearchOpen(false); setSearchHasText(false); }} />
                        </div>
                    </div>
                )}
            </div>
        );
    }
    // --- DEFAULT nav: Row 1 = big group tiles; Row 2 = Team Logos | Team Tabs ---
    // Default-nav GROUP TABS (distinct from the view toggles above): "Access"
    // (admin pages) and, to its right, a gold owner-only "Owner Access" group.
    const accessAdminSec = access.admin ? {
        key: "access", title: "Access", color: "#FFFFFF", Icon: Shield,
        tabs: [...ADMIN_NAV.children, ...BUSINESS_NAV.children].map((c, i) => ({ id: `acc-${i}`, l: c.label, to: c.to, Icon: Shield })),
    } : null;
    const accessOwnerSec = access.owner ? {
        key: "owner-access", title: "Owner Access", color: "#F6C453", Icon: Crown,
        tabs: OWNER_NAV.children.map((c, i) => ({ id: `own-${i}`, l: c.label, to: c.to, Icon: Crown })),
    } : null;
    const accessTiles = arrangeSections([accessAdminSec, accessOwnerSec].filter((s) => s && (s.tabs || []).length > 0), navStruct);
    const openableSections = [...leagueSections, ...accessTiles];
    const onAccessPage = accessTiles.some((s) => (s.tabs || []).some((t) => isActive(t.to)));
    // Account tile on: the tab row shows your account sections (same chips, same place).
    const accountSec = {
        key: "account", color: "#E2E8F0", tabs: [
            { id: "acct-home", l: "Home", to: "/account", Icon: Home },
            { id: "acct-notifications", l: "Notifications", to: "/account?tab=notifications", Icon: Bell },
            { id: "acct-objectives", l: "Objectives", to: "/account?tab=objectives", Icon: Target },
            { id: "acct-preferences", l: "Preferences", to: "/account?tab=preferences", Icon: SlidersHorizontal },
            access.owner && { id: "acct-finances", l: "Finances", to: "/account?tab=finances", Icon: PoundSterling },
            access.owner && { id: "acct-reports", l: "Full Reports", to: "/account?tab=reports", Icon: BarChart3 },
            (access.owner || access.admin) && { id: "acct-accounts", l: "Accounts & Users", to: "/account?tab=accounts", Icon: Users },
            (access.owner || access.admin || access.business || access.creator) && { id: "acct-pucks", l: "Pucks", to: "/packs", Icon: Disc3 },
        ].filter(Boolean),
    };
    const extraProps = { isOwner, displayOn, setDisplayOn, cls: "h-full w-[64px]", offOthers: offPanels, ownerToolsOn, accountOn, setAccountOn, setOwnerToolsOn: (v) => { if (v) offPanels(); setOwnerToolsOn(v); } };
    const topSlots = [
        canSwitch && onPickLeague && { key: "__league", label: "League", node: (
            // League tile: hover = the leagues replace the tabs below (W | M); click = open your favourite league.
            <button type="button" onMouseEnter={() => { setHoverKey("__league"); setTeamHover(false); }} onClick={() => onPickLeague(favLeague || league || "pwhl")}
                title={`Leagues — hover to pick · click opens your favourite league${favLeague ? ` (${favLeague === "international" ? "WWHC" : favLeague.toUpperCase()})` : ""}`} className="shrink-0 h-full w-[64px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border transition-colors hover:brightness-125"
                style={hoverKey === "__league" || isIntl ? { borderColor: `${teamColor || "#94A3B8"}66`, background: `${teamColor || "#94A3B8"}14`, color: teamColor || "#94A3B8" } : { borderColor: "#94A3B866", background: "#94A3B814", color: "#94A3B8" }} data-testid="nav-league-tile">
                <Globe className="h-4 w-4" strokeWidth={2} />
                <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center">League</span>
            </button>
        ) },
        ...leagueSections.map((sec) => ({ key: sec.key, sec, color: teamColor || resolve(sec.color) })),
        roadmapSec && !leagueSections.some((x) => x.key === roadmapSec.key) && { key: roadmapSec.key, sec: roadmapSec, color: teamColor || resolve(roadmapSec.color) },
        ...accessTiles.map((sec) => ({ key: sec.key, sec, color: sec.color })),
        { key: "__search", label: "Search", node: (
            <div className="shrink-0 flex" data-testid="pwhl-group-search">
                <button type="button" data-testid="nav-search-tile"
                    onClick={() => { setSearchOpen((v) => !v); setSearchFocusToken((t) => t + 1); setHoverKey(null); }}
                    title="Search" style={{ borderColor: "#94A3B866", color: "#94A3B8" }}
                    className="h-full w-[64px] flex flex-col items-center justify-center gap-1 px-1 rounded-lg border transition-colors hover:brightness-125">
                    <Search className="h-4 w-4" strokeWidth={2} />
                    <span data-nav-label className="text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center">Search</span>
                </button>
            </div>
        ) },
        { key: "__display", label: "Display", node: <NavExtraTiles {...extraProps} only="display" /> },
        { key: "__account", label: "Account", node: <NavExtraTiles {...extraProps} only="account" /> },
    ].filter(Boolean).map((t, i) => ({ ...t, i })).sort((a, b) => topPos(navStruct?.top_order, a.key, a.i) - topPos(navStruct?.top_order, b.key, b.i));
    topKeysRef.current = topSlots.map((t) => t.key);
    const openSec = openableSections.find((s) => s.key === openKey && (s.tabs || []).length)
        || (onAccessPage ? accessTiles.find((s) => (s.tabs || []).some((t) => isActive(t.to))) : null)
        || openableSections.find((s) => s.key === "season")
        || openableSections[0]
        || { key: "none", color: "#94A3B8", tabs: [] };
    const tabsColor = (openSec.key === "access" || openSec.key === "owner-access") ? openSec.color : (teamColor || resolve(openSec.color));
    return (
        <div className="flex flex-col gap-2 w-full" data-testid="pwhl-sections-bar" onMouseLeave={() => { setHoverKey(null); if (!pick?.active && !searchHasText) setSearchOpen(false); }}>
            {arrOn && createPortal(
                <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[200] flex items-center gap-3 pl-4 pr-2 py-2 rounded-full border border-[#A3E635]/60 bg-[#0A0B10]/95 backdrop-blur shadow-[0_10px_40px_rgba(0,0,0,0.6)] fade-up" data-testid="arrange-guide">
                    <Move className="h-4 w-4 text-[#A3E635]" />
                    <span className="text-[11px] text-white/80"><b className="text-[#A3E635] uppercase tracking-wider text-[10px]">Arrange</b> · drag a group tile or tab to move it · drop a tab <b className="text-white">on a group tile</b> to move it there · <b className="text-white">double-click</b> to rename</span>
                    <button type="button" onClick={() => setNavArrange(false)} data-testid="arrange-done" className="h-7 px-3 rounded-full bg-[#A3E635] text-[#0A0B10] text-[10px] font-black uppercase tracking-wider hover:brightness-110">Done</button>
                </div>, document.body)}
            {renaming && createPortal(
                <div className="fixed inset-0 z-[210]" onMouseDown={() => setRenaming(null)}>
                    <form className="absolute -translate-x-1/2 w-60 rounded-xl border border-[#A3E635]/60 bg-[#0A0B10] p-2.5 shadow-2xl fade-up space-y-2" style={{ left: renaming.x, top: renaming.y }}
                        onMouseDown={(e) => e.stopPropagation()} onSubmit={(e) => { e.preventDefault(); commitRename(e.currentTarget.elements.nm.value); }} data-testid="arrange-rename">
                        <div className="text-[9px] font-black uppercase tracking-[0.14em] text-[#A3E635]">Rename {renaming.kind === "groups" ? "group tile" : "tab"}</div>
                        <input name="nm" autoFocus defaultValue={renaming.cur} onKeyDown={(e) => { if (e.key === "Escape") setRenaming(null); }} data-testid="arrange-rename-input"
                            className="w-full bg-black/40 border border-white/15 focus:border-[#A3E635] outline-none rounded-lg px-2.5 py-1.5 text-sm text-white" />
                        <div className="flex gap-1.5">
                            <button type="submit" data-testid="arrange-rename-save" className="flex-1 h-7 rounded-lg bg-[#A3E635] text-[#0A0B10] text-[10px] font-black uppercase tracking-wider">Save</button>
                            <button type="button" onClick={() => commitRename("")} data-testid="arrange-rename-reset" className="h-7 px-2.5 rounded-lg border border-white/15 text-[10px] font-black uppercase tracking-wider text-white/70 hover:text-white">Original</button>
                        </div>
                    </form>
                </div>, document.body)}
            {board.popup}
            {lgMenu && createPortal(
                <div className="fixed inset-0 z-[200]" onMouseDown={() => setLgMenu(null)}>
                    <div className="absolute w-48 rounded-xl border border-white/12 bg-[#0B0C13] p-1 shadow-2xl fade-up" style={{ left: lgMenu.x, top: lgMenu.y }} onMouseDown={(e) => e.stopPropagation()} data-testid="nav-league-tile-menu">
                        <button type="button" data-testid="nav-league-tile-international" title="WWHC · shift+click to favourite"
                            onClick={(e) => { setLgMenu(null); if (e.shiftKey || favPickMode) { const n = toggleFavLeague("international"); toast(n ? "WWHC is your favourite league" : "Favourite league removed"); return; } onPickLeague("international"); }}
                            style={isIntl ? { background: "#E11D4826", borderColor: "#E11D4859", color: "#fff" } : undefined}
                            className={`w-full h-9 px-2.5 rounded-lg border flex items-center gap-2 text-[11px] font-black uppercase tracking-wide transition-colors ${isIntl ? "" : "border-transparent text-white/75 hover:bg-white/10 hover:text-white"}`}>
                            <Globe className="h-3.5 w-3.5 shrink-0" style={{ color: "#E11D48" }} />Women's Worlds<span className="ml-auto text-[9px] text-white/40">WWHC</span>
                        </button>
                    </div>
                </div>, document.body)}
            {pageSlotNode}
            {/* MAIN — team block (left, teams in 4 rows) + group tiles over their tabs (right) */}
            <div className="flex items-stretch gap-3">
                {/* LEFT: team surf block — League/All-Teams stacked group + teams as columns of 4 */}
                <div className="relative flex items-stretch shrink-0 max-w-full order-2">
                <div className="flex items-stretch max-w-full">
                {isPwhl && surfIds.length > 0 && (
                    <div className="flex items-start gap-1 shrink-0 p-2 rounded-xl border bg-[#0A0B10]/80 backdrop-blur max-w-full overflow-x-auto"
                        style={{ borderColor: favPickMode ? "#F6C453" : (teamColor ? `${teamColor}40` : "rgba(255,255,255,0.12)") }} data-testid="team-surf-block">
                        {board.renderSlot("before", { sep: "right" })}
                        <div className="grid gap-1 shrink-0" style={rows4}>
                            <button type="button" data-testid="team-surf-all" onClick={(e) => { if (favPickMode) { toggleFavPick(null); return; } if (notifyMode) { const ids = surfIds.filter(Boolean); notif.setMany("pwhl", ids, !notif.allOn("pwhl", ids)); return; } if (e.shiftKey) pinPageTeam("all", "All Teams"); setSurfTeam(null); setPwhlSurfGroup(null); clearSurfMulti(); if (onTeamSelect) onTeamSelect(null); }}
                                style={(!activeSurf && !pwhlSurfGroup && !pwhlSurfMulti.length) ? { background: `${ovColor}26`, borderColor: `${ovColor}59`, color: "#fff" } : undefined}
                                className={`${leadCls} row-span-4 ${(!activeSurf && !pwhlSurfGroup && !pwhlSurfMulti.length) ? "" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"} ${shiftHeld && (activeSurf || pwhlSurfGroup) && pwhlPin !== "all" ? "opacity-50" : ""}`}>All Teams</button>
                        </div>
                        {pwhlConfed ? (
                            <div className="flex gap-1 shrink-0" data-testid="team-surf-logos">
                                {/* Each conference: its name on top, its 6 teams below in 2 columns. */}
                                {["Eastern", "Western"].map((conf) => {
                                    const confIds = surfIds.filter((id) => pwhlConfOf(id) === conf);
                                    const on = notifyMode ? notif.allOn("pwhl", confIds) : pwhlSurfGroup === conf;
                                    return (
                                        <div key={conf} className="grid gap-1 shrink-0" style={{ gridTemplateColumns: "repeat(2, 42px)", gridTemplateRows: `repeat(4, ${ROW_H}px)` }} data-testid={`pwhl-surf-confblock-${conf.toLowerCase()}`}>
                                            <button type="button" data-testid={`pwhl-div-${conf.toLowerCase()}`} title={notifyMode ? `${conf} — toggle notifications for every ${conf} team` : `Sort by ${conf} Conference · shift+click to pin as PWHL default · shift+right-click to pin for this page`}
                                                onClick={(e) => { if (favPickMode) { toggleFavPick("conf:" + conf, conf + " Conference"); return; } if (notifyMode) { notif.setMany("pwhl", confIds, !on); return; } if (e.shiftKey) pinPageTeam("conf:" + conf, conf + " Conference"); setSurfTeam(null); if (onTeamSelect) onTeamSelect(null); setPwhlSurfGroup(on ? null : conf); }}
                                                onContextMenu={(e) => { if (e.shiftKey) { e.preventDefault(); pinPageTeam("conf:" + conf, conf + " Conference"); } }}
                                                className={`col-span-2 rounded-lg border flex items-center justify-center text-[9px] font-black uppercase tracking-[0.12em] transition-colors ${on ? "bg-white/15 border-white/30 text-white" : "border-white/15 bg-black/25 text-white/70 hover:text-white"} ${shiftHeld && !on && pwhlPin !== "conf:" + conf ? "opacity-50" : ""}`}>{conf}</button>
                                            {confIds.map((id, i) => teamBtn(id, `t-${conf}-${i}`))}
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                        <div className="grid gap-1 shrink-0" style={{ gridTemplateColumns: `repeat(${Math.max(1, Math.ceil(surfIds.length / 4))}, 42px)`, gridAutoRows: `${ROW_H}px` }} data-testid="team-surf-logos">
                            {surfIds.map((id, i) => teamBtn(id, `t-${i}`))}
                        </div>
                        )}
                        {board.renderSlot("after", { sep: "left" })}
                    </div>
                )}
                {isNhl && nhlTeams.length > 0 && (
                    <div className="flex items-start gap-1 shrink-0 p-2 rounded-xl border bg-[#0A0B10]/80 backdrop-blur max-w-full overflow-x-auto"
                        style={{ borderColor: favPickMode ? "#F6C453" : (teamColor ? `${teamColor}40` : "rgba(255,255,255,0.12)") }} data-testid="nhl-team-surf-block">
                        {board.renderSlot("before", { sep: "right" })}
                        <div className="grid gap-1 shrink-0" style={rows4}>
                            {pickModeNhl ? (() => {
                                const allAbbrs = nhlTeams.map((t) => t.abbr.toUpperCase());
                                const on = pmAll(allAbbrs);
                                return (
                                    <button type="button" data-testid="nhl-spoiler-all" title={on ? "All teams Spoilers-Free — click to clear all" : "Make ALL teams Spoilers-Free"}
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); pmGroup(allAbbrs); }}
                                        style={on ? { background: "#8A94A626", borderColor: "#8A94A659", color: "#fff" } : undefined}
                                        className={`${leadCls} row-span-4 border ${on ? "" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"}`}>All Teams</button>
                                );
                            })() : (
                            <button type="button" data-testid="nhl-surf-all" onClick={(e) => { if (favPickMode) { toggleFavPick(null); return; } if (e.shiftKey) pinPageTeam("all", "All Teams"); setNhlSurfTeam(null); setNhlSurfGroup(null); clearSurfMulti(); }}
                                style={(!nhlActive && !nhlSurfGroup && !nhlSurfMulti.length) ? { background: "#8A94A626", borderColor: "#8A94A659", color: "#fff" } : undefined}
                                className={`${leadCls} row-span-4 ${(!nhlActive && !nhlSurfGroup && !nhlSurfMulti.length) ? "" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"} ${shiftHeld && (nhlActive || nhlSurfGroup) && nhlPin !== "all" ? "opacity-50" : ""}`}>All Teams</button>
                            )}
                        </div>
                        {/* Conference sort — slim vertical accent column (distinct from the League/All-Teams pills) */}
                        <div className="grid gap-1 shrink-0" style={rows4}>
                            {["Eastern", "Western"].map((conf) => {
                                if (pickModeNhl) {
                                    const confAbbrs = nhlTeams.filter((t) => (NHL_CONF_DIVS[conf] || []).includes(t.division)).map((t) => t.abbr.toUpperCase());
                                    const on = pmAll(confAbbrs);
                                    return (
                                        <button key={conf} type="button" data-testid={`nhl-spoiler-conf-${conf.toLowerCase()}`} title={on ? `${conf} Conference Spoilers-Free — click to clear` : `Make all ${conf} teams Spoilers-Free`}
                                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); pmGroup(confAbbrs); }}
                                            style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
                                            className={`row-span-2 w-[22px] rounded-lg border flex items-center justify-center text-[9px] font-black uppercase tracking-[0.12em] transition-colors ${on ? "bg-white/15 border-white/30 text-white" : "border-white/15 bg-black/25 text-white/70 hover:text-white"}`}>{conf}</button>
                                    );
                                }
                                const on = nhlSurfGroup === conf;
                                return (
                                    <button key={conf} type="button" data-testid={`nhl-surf-conf-${conf.toLowerCase()}`} title={`Sort by ${conf} Conference · shift+click to pin as NHL default · shift+right-click to pin for this page`}
                                        onClick={(e) => { if (favPickMode) { toggleFavPick("conf:" + conf, conf + " Conference"); return; } if (e.shiftKey) pinPageTeam("conf:" + conf, conf + " Conference"); setNhlSurfGroup(on ? null : conf); setNhlSurfTeam(null); }}
                                        onContextMenu={(e) => { if (e.shiftKey) { e.preventDefault(); pinPageTeam("conf:" + conf, conf + " Conference"); } }}
                                        style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
                                        className={`row-span-2 w-[22px] rounded-lg border flex items-center justify-center text-[9px] font-black uppercase tracking-[0.12em] transition-colors ${on ? "bg-white/15 border-white/30 text-white" : "border-white/15 bg-black/25 text-white/70 hover:text-white"} ${shiftHeld && !on && nhlPin !== "conf:" + conf ? "opacity-50" : ""}`}>{conf}</button>
                                );
                            })}
                        </div>
                        <div className="flex flex-col gap-1 shrink-0" data-testid="nhl-team-surf-logos">
                            {NHL_DIVISION_ORDER.map((div) => {
                                const teamsInDiv = nhlTeams.filter((t) => t.division === div);
                                if (!teamsInDiv.length) return null;
                                const divOn = nhlSurfGroup === div;
                                const divAbbrs = teamsInDiv.map((t) => t.abbr.toUpperCase());
                                const divSpoilerOn = pickModeNhl && pmAll(divAbbrs);
                                return (
                                    <div key={div} className="flex items-center gap-1" style={{ height: `${ROW_H}px` }} data-testid={`nhl-div-row-${div.toLowerCase()}`}>
                                        {pickModeNhl ? (
                                            <button type="button" data-testid={`nhl-spoiler-div-${div.toLowerCase()}`} title={divSpoilerOn ? `${div} Division Spoilers-Free — click to clear` : `Make all ${div} teams Spoilers-Free`}
                                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); pmGroup(divAbbrs); }}
                                                className={`w-[78px] shrink-0 h-full rounded-lg border text-[9px] font-black uppercase tracking-wider leading-none transition-colors ${divSpoilerOn ? "bg-white/15 border-white/30 text-white" : "border-white/15 bg-black/25 text-white/70 hover:text-white"}`}>{div}</button>
                                        ) : (
                                        <button type="button" data-testid={`nhl-surf-div-${div.toLowerCase()}`} title={`Sort by ${div} Division · shift+click to pin as NHL default · shift+right-click to pin for this page`}
                                            onClick={(e) => { if (favPickMode) { toggleFavPick("div:" + div, div + " Division"); return; } if (e.shiftKey) pinPageTeam("div:" + div, div + " Division"); setNhlSurfGroup(divOn ? null : div); setNhlSurfTeam(null); }}
                                            onContextMenu={(e) => { if (e.shiftKey) { e.preventDefault(); pinPageTeam("div:" + div, div + " Division"); } }}
                                            style={divOn ? { color: "#fff" } : undefined}
                                            className={`w-[78px] shrink-0 h-full rounded-lg border text-[9px] font-black uppercase tracking-wider leading-none transition-colors ${divOn ? "bg-white/15 border-white/30" : "border-white/15 bg-black/25 text-white/70 hover:text-white"} ${shiftHeld && !divOn && nhlPin !== "div:" + div ? "opacity-50" : ""}`}>{div}</button>
                                        )}
                                        {teamsInDiv.map((t) => {
                                            const on = nhlActive === t.abbr || nhlSurfMulti.includes(t.abbr) || (!!nhlSurfGroup && (t.division === nhlSurfGroup || t.conference === nhlSurfGroup)) || (favPickMode && isFavStar(t.abbr));
                                            const col = t.primary_color || "#8A94A6";
                                            if (pickModeNhl) {
                                                const isSF = pmHas(t.abbr); // selected = spoiler-free (hidden)
                                                return (
                                                    <button key={t.abbr} type="button" data-testid={`nhl-team-${t.abbr}`} title={notifyMode ? (isSF ? `${t.name} — notifications ON. Click to turn off` : `${t.name} — click to turn notifications on`) : (isSF ? `${t.name} — Spoilers-Free ON (scores hidden). Click to show` : `${t.name} — click to make Spoilers-Free (hide its scores)`)}
                                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); pmToggle(t.abbr); }}
                                                        style={isSF ? { "--sel-bg": `${col}26`, "--sel-bd": `${col}59`, background: `${col}26`, borderColor: `${col}59` } : undefined}
                                                        className={`relative inline-flex items-center justify-center w-[42px] h-full rounded-lg border transition-all ${isSF ? "" : "bg-black/25 border-white/15 opacity-30 grayscale hover:opacity-70"}`}>
                                                        <img src={t.logo_url} alt={t.abbr} className="h-6 w-6 object-contain" />
                                                    </button>
                                                );
                                            }
                                            return (
                                                <button key={t.abbr} type="button" data-testid={`nhl-team-${t.abbr}`} title={`${t.name} — click to sort · shift+click to add/remove more teams (pin on roster/lineup pages) · shift+right-click to pin for this page`}
                                                    onClick={(e) => { if (favPickMode) { toggleFavPick(t.abbr, t.abbr, e); return; } if (e.shiftKey && multiOk) { shiftMulti("nhl", t.abbr); return; } if (e.shiftKey) pinPageTeam(t.abbr, t.abbr); setNhlSurfTeam(nhlActive === t.abbr ? null : t.abbr); setNhlSurfGroup(null); }}
                                                    onContextMenu={(e) => { if (e.shiftKey) { e.preventDefault(); pinPageTeam(t.abbr, t.abbr); } }}
                                                    style={{ "--sel-bg": `${col}26`, "--sel-bd": `${col}59`, ...(on ? { background: `${col}26`, borderColor: `${col}59` } : {}) }}
                                                    className={`relative inline-flex items-center justify-center w-[42px] h-full rounded-lg border transition-all ${on ? "" : "bg-black/25 border-white/15 hover:brightness-125"} ${shiftHeld && !on && nhlPin !== t.abbr ? "opacity-50" : ""} ${shiftHeld ? "hover:opacity-100 hover:![background-color:var(--sel-bg)] hover:![border-color:var(--sel-bd)]" : ""}`}>
                                                    <img src={t.logo_url} alt={t.abbr} className="h-6 w-6 object-contain" />
                                                    {favPickMode && isFavStar(t.abbr) && <Star className="absolute -top-1 -right-1 h-3 w-3 text-[#F6C453] fill-[#F6C453]" data-testid={`nhl-fav-star-${t.abbr}`} />}
                                                </button>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                        {board.renderSlot("after", { sep: "left" })}
                    </div>
                )}
                {isIntl && (
                    <div className="flex items-start gap-1 shrink-0 p-2 rounded-xl border bg-[#0A0B10]/80 backdrop-blur max-w-full overflow-x-auto"
                        style={{ borderColor: favPickMode ? "#F6C453" : `${teamColor}40` }} data-testid="intl-team-surf-block">
                        {board.renderSlot("before", { sep: "right" })}
                        <div className="grid gap-1 shrink-0" style={rows4}>
                            <button type="button" data-testid="intl-surf-all" onClick={() => { if (favPickMode) { toggleFavPick(null); return; } setIntlCountry(null); setIntlGroup(null); }}
                                style={!intlCountry && !intlGroup ? { background: "#E11D4826", borderColor: "#E11D4859", color: "#fff" } : undefined}
                                className={`${leadCls} row-span-4 ${!intlCountry && !intlGroup ? "" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"}`}>All Teams</button>
                        </div>
                        {intlCountries.length > 0 ? (
                            <div className="flex flex-col gap-1 shrink-0" data-testid="intl-team-surf-logos">
                                {/* Each group = 2 rows (like a conference): Group A on rows 1-2, Group B on rows 3-4. */}
                                {[...new Set(intlCountries.map((c) => c.group || "—"))].map((grp) => {
                                    const list = intlCountries.filter((c) => (c.group || "—") === grp);
                                    const codes = list.map((c) => c.code || c.code3 || c.name);
                                    const grpOn = intlGroup === grp;
                                    return (
                                        <div key={grp} className="flex items-stretch gap-1" data-testid={`intl-surf-group-${grp}`}>
                                            <button type="button" data-testid={`intl-surf-group-btn-${grp}`} title={`Group ${grp}`}
                                                onClick={() => { if (favPickMode) { toggleFavPick(`group:${grp}`, `Group ${grp}`); return; } setIntlGroup(grpOn ? null : grp); setIntlCountry(null); }}
                                                style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
                                                className={`w-[22px] rounded-lg border flex items-center justify-center text-[9px] font-black uppercase tracking-[0.12em] transition-colors ${grpOn ? "bg-white/15 border-white/30 text-white" : "border-white/15 bg-black/25 text-white/70 hover:text-white"}`}>Group {grp}</button>
                                            <div className="grid grid-flow-col gap-1" style={{ gridTemplateRows: `repeat(2, ${ROW_H}px)` }}>
                                                {list.map((c, i) => {
                                                    const code = codes[i];
                                                    const col = INT_COL[code] || "#E11D48";
                                                    const on = intlCountry === code || grpOn || (favPickMode && isFavStar(code));
                                                    return (
                                                        <button key={c.id || c.name} type="button" data-testid={`intl-country-${c.iso || c.code3 || c.name}`} title={`${c.name} — click to sort · shift+click to add more`}
                                                            onClick={(e) => { if (favPickMode) { toggleFavPick(code, c.name, e); return; } setIntlCountry(intlCountry === code ? null : code); setIntlGroup(null); }}
                                                            style={on ? { background: `${col}26`, borderColor: `${col}59` } : undefined}
                                                            className={`relative inline-flex items-center justify-center w-[42px] h-full rounded-lg border transition-all ${on ? "" : "bg-black/25 border-white/15 hover:brightness-125"}`}>
                                                            <Flag nationality={c.name} size={18} />
                                                            {favPickMode && isFavStar(code) && <Star className="absolute -top-1 -right-1 h-3 w-3 text-[#F6C453] fill-[#F6C453]" />}
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        ) : (
                            <div className="flex items-center px-3 text-[10px] text-white/40">No countries yet.</div>
                        )}
                        {board.renderSlot("after", { sep: "left" })}
                    </div>
                )}
                {isNcaa && <NcaaSurfBlock leadCls={leadCls} ROW_H={ROW_H} before={board.renderSlot("before", { sep: "right" })} after={board.renderSlot("after", { sep: "left" })} />}
                </div>
                </div>

                {/* RIGHT: group tiles on top, the open group's tab chips + symbols below.
                    Width is anchored to the (always-present) group-tiles row so switching
                    groups on hover never reflows the teams block. */}
                {leftAccess.length > 0 && (
                    // Admin / Business / Owner views + Changelog: own full-height icon-only column, left of the R logo (still toggles).
                    <div className="self-stretch shrink-0 flex flex-col justify-between p-1.5 rounded-xl border bg-[#0A0B10]/80 backdrop-blur [&_button]:!h-8 [&_button]:!w-8 [&_button]:!p-0 [&_button]:!gap-0 [&_button]:!justify-center [&_.leading-none]:!hidden"
                        style={{ borderColor: teamColor ? `${teamColor}40` : "rgba(255,255,255,0.12)" }} data-testid="nav-left-access">
                        {leftAccess.map((b) => <React.Fragment key={b.key}>{b.render()}</React.Fragment>)}
                    </div>
                )}
                <div className="flex flex-col gap-2 min-w-0">
                    <div className="flex items-stretch gap-2 h-[68px] w-max shrink-0">
                        {topSlots.map((t) => (t.sec ? <CollapsedTile key={t.key} sec={t.sec} color={t.color} /> : (
                            <div key={t.key} className={`shrink-0 flex ${arrOn ? "arr-item" : ""}`} data-testid={`nav-top-slot-${t.key.slice(2)}`} {...arrProps("group", t.key, t.label)}>{t.node}</div>
                        )))}
                    </div>
                    <div className="flex items-stretch gap-2 w-full min-w-0" data-testid="nav-row2-wrap">
                    {!(boxTakeover && boardEnd) && (openSec.tabs.length > 0 || (canSwitch && onPickLeague)) && (
                        <div className="flex items-start gap-3 p-2 rounded-xl border bg-[#0A0B10]/80 backdrop-blur w-full min-w-0 flex-1 overflow-x-auto"
                            style={{ borderColor: teamColor ? `${teamColor}40` : "rgba(255,255,255,0.12)" }} data-testid="nav-row2">
                            {canSwitch && onPickLeague && hoverKey === "__league" ? (
                                <div className="flex items-stretch gap-3 shrink-0" data-testid="nav-row2-league-picker">
                                    {LEAGUE_GROUPS.map(([k, full, lgs]) => [k, full, lgs.map((l) => l.id)]).map(([k, full, ids]) => (
                                        <div key={k} className="flex items-stretch gap-1" data-testid={`nav-league-section-${k.toLowerCase()}`}>
                                            <span title={full} className="flex flex-col items-center gap-1 px-1" data-testid={`nav-league-sep-${k.toLowerCase()}`}>
                                                <span className="w-px flex-1 bg-white/20" />
                                                <span className="text-[10px] font-black text-white/70 leading-none">{k}</span>
                                                <span className="w-px flex-1 bg-white/20" />
                                            </span>
                                            <div className="grid grid-flow-col gap-1" style={stripStyle}>
                                                {ids.map((id) => leagueBtn(id, "row2", "w-full min-w-[56px] !px-2.5", true))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : openSec.tabs.length > 0 && (
                                <div className="grid grid-flow-col gap-1 shrink-0" style={stripStyle} data-testid={`team-tabs-${openSec.key}`}>
                                    {openSec.tabs.map((t) => <TabChip key={t.id} t={t} groupKey={openSec.key} color={tabsColor} unavailable={isNonPwhl && NCAA_UNAVAILABLE_TABS.has(t.id)} />)}
                                </div>
                            )}
                        </div>
                    )}
                    {(accessSections.length > 0 || (isOwner && (accessPageKey === "/nhl/schedule" || location.pathname === "/standings")) || accessPageKey === "/nhl/schedule" || canPredictHere || location.pathname === "/nhl/standings" || accessPublicKeys.length > 0 || !!viewModes.owner || !!user) && boardEnd && (
                        <div className={boxTakeover ? "flex-1 min-w-0 flex" : "ml-auto shrink-0 flex"} style={boxTakeover ? { contain: "inline-size" } : undefined} data-testid={boxTakeover ? "nav-box-takeover" : undefined}>{boardEnd}</div>
                    )}
                    </div>
                </div>
            </div>
            {searchOpen && (
                <div className="fixed left-0 right-0 top-full z-[60] px-4 pt-2 pointer-events-none" data-testid="pwhl-secondbar-search">
                    <div className="pointer-events-auto mx-auto max-w-[1100px] p-2 rounded-xl border border-white/10 bg-[#0A0B10]/95 backdrop-blur-xl shadow-2xl shadow-black/60 animate-slide-up">
                        <GlobalSearch testId="global-search" compact bar focusToken={searchFocusToken} resultsBar onQueryChange={setSearchHasText} onNavigate={() => { setSearchOpen(false); setSearchHasText(false); }} />
                    </div>
                </div>
            )}
            {isOwner && changelogView && (
                <ChangelogPanel route={location.pathname} onClose={() => setChangelogView(false)} />
            )}
        </div>
    );
}

// Right-side drawer (Changelog View): recent edits — who, when, action + the
// precise submitted change rendered in PLAIN ENGLISH (never raw JSON/code).
const _humanKey = (k) => String(k).replace(/_/g, " ").replace(/\bid\b/gi, "ID").replace(/\b\w/g, (c) => c.toUpperCase());
// Never emit "[object Object]" — recurse a level, then fall back to field names.
function _clV(v, d = 0) {
    if (v === true) return "on";
    if (v === false) return "off";
    if (v == null || v === "") return "—";
    if (typeof v === "number") return String(v);
    if (typeof v === "string") return v.length > 70 ? v.slice(0, 70) + "…" : v;
    if (Array.isArray(v)) {
        if (!v.length) return "none";
        const names = v.slice(0, 6).map((x) => (x && typeof x === "object") ? (x.name || x.player_name || x.title || x.label || x.id || "item") : String(x));
        return names.join(", ") + (v.length > 6 ? ` +${v.length - 6}` : "");
    }
    if (d >= 1) return Object.keys(v).map(_humanKey).slice(0, 6).join(", ") || "—";
    return Object.entries(v).slice(0, 6).map(([k, val]) => `${_humanKey(k)} ${_clV(val, d + 1)}`).join(", ");
}
function _clLines(payload) {
    if (!payload || typeof payload !== "object") return [];
    return Object.entries(payload).slice(0, 10).map(([k, v]) => ({ k: _humanKey(k), v: _clV(v) }));
}
// Access-button Changelog popup — same view as the /changelog page, opened on this page.
function ChangelogPanel({ route, onClose }) {
    const [page, setPage] = useState("");
    return createPortal((
        <div className="fixed inset-0 z-[9999] flex items-start justify-center p-4 sm:p-8 bg-black/75 backdrop-blur-lg overflow-y-auto" onClick={onClose} data-testid="changelog-overlay">
            <div className="w-full max-w-4xl my-auto max-h-[88vh] flex flex-col rounded-2xl border border-[#22D3EE]/40 bg-[#0A0B10]/95 shadow-2xl shadow-black/70 overflow-hidden" onClick={(e) => e.stopPropagation()} data-testid="changelog-panel">
                <div className="flex items-center gap-2 px-5 py-3 border-b border-white/10 bg-[#22D3EE]/10 shrink-0">
                    <ScrollText className="h-4 w-4 text-[#22D3EE]" />
                    <span className="text-sm font-black uppercase tracking-wider text-white">Changelog</span>
                    <button type="button" onClick={onClose} data-testid="changelog-panel-close" className="ml-auto text-white/50 hover:text-white transition-colors"><X className="h-5 w-5" /></button>
                </div>
                <div className="flex-1 min-h-0 overflow-y-auto p-5" data-testid="changelog-panel-list">
                    <ChangelogBody page={page} setPage={setPage} route={route} />
                </div>
            </div>
        </div>
    ), document.body);
}

const PAGE_LABELS = {
    "/leagues": "Leagues", "/news": "News", "/videos": "Videos", "/roadmap": "Roadmap",
    "/records": "Records", "/stories": "Stories", "/insights": "Insights", "/trends": "Trends",
    "/rankings": "Rankings", "/awards": "Awards", "/chemistry": "Chemistry", "/positions": "Positions",
    "/packs": "Pucks", "/socials/news": "Socials", "/socials": "Socials",
};
const pageLabelFor = (to = "") => {
    if (PWHL_TAB_LABELS[to]) return PWHL_TAB_LABELS[to];
    const base = to.split("?")[0];
    if (PAGE_LABELS[base]) return PAGE_LABELS[base];
    const seg = base.replace(/^\//, "").split("/")[0] || "Page";
    return seg.replace(/(^|-)([a-z])/g, (m, s, c) => (s ? " " : "") + c.toUpperCase());
};

// These four collapse into ONE "Leagues" cluster (Socials-style: a row of icons
// above a single label). Order = display order (All Leagues · PWHL · Teams · Insights).
const LEAGUE_CLUSTER = ["Leagues", "PWHL", "Teams"];

// Global admin sections — shown as a subnav when hovering / activating the
// top-nav "Admin" button (admins only). Deep-link into the central /admin page.
const ADMIN_NAV = {
    label: "Access",
    children: [],
};

// Banner shown while the owner is impersonating another account ("Log in as").
function ImpersonationBanner({ user }) {
    const ownerToken = typeof window !== "undefined" ? localStorage.getItem("rosterly_owner_token") : null;
    if (!ownerToken) return null;
    const restore = () => {
        localStorage.setItem("rosterly_token", ownerToken);
        localStorage.removeItem("rosterly_owner_token");
        window.location.href = "/owner?tab=accounts";
    };
    return (
        <div className="bg-[#F6C453] text-[#0A0B10] px-4 py-1.5 text-center text-[12px] font-bold flex items-center justify-center gap-3" data-testid="impersonation-banner">
            <span>Viewing as <span className="underline">{user?.email || "account"}</span> ({user?.role}) — owner impersonation.</span>
            <button onClick={restore} className="px-2.5 py-0.5 rounded bg-[#0A0B10] text-[#F6C453] text-[11px] uppercase tracking-wider font-black" data-testid="impersonation-exit">Return to owner</button>
        </div>
    );
}

// Compact hockey-puck glyph for the nav (mirrors the disc look used on Pucks).
const AZ_BTN = "h-full px-2 gap-1.5 rounded-lg border flex items-center justify-start whitespace-nowrap text-[9px] font-black uppercase tracking-wider transition-colors hover:brightness-125";
const azPill = (on, c) => on ? { borderColor: c, background: c, color: "#0A0B10" } : { borderColor: `${c}66`, background: `${c}14`, color: c };

// Nav tiles after Account: Display (shows the display buttons in the access box) and
// Admin Tools (shows the admin buttons). Only one is on at a time.
function NavExtraTiles({ isOwner, displayOn, setDisplayOn, style, cls, offOthers, ownerToolsOn, setOwnerToolsOn, accountOn, setAccountOn, pageOn, setPageOn, only }) {
    const { allButtons, toggleAllButtons } = useAdminMode();
    const tileCls = `shrink-0 ${cls} flex flex-col items-center justify-center gap-1 px-1 rounded-lg border transition-colors hover:brightness-125`;
    const lbl = "text-[8px] font-black uppercase tracking-[0.08em] leading-tight text-center";
    const tileSty = (on, c) => ({ ...style, borderColor: on ? c : "#94A3B866", color: on ? c : "#94A3B8", background: on ? `${c}14` : undefined });
    return (
        <>
            {setPageOn && (!only || only === "page") && <button type="button" data-testid="nav-page-tile" title={pageOn ? "Hide this page's toggles" : "Show this page's toggles"}
                onClick={() => { const n = !pageOn; if (n) offOthers?.(); setPageOn(n); }}
                style={tileSty(pageOn, "#A3E635")} className={tileCls}>
                <LayoutTemplate className="h-4 w-4" strokeWidth={2} /><span data-nav-label className={lbl}>Page Toggles</span>
            </button>}
            {(!only || only === "display") && <button type="button" data-testid="nav-display-tile" title={displayOn ? "Hide display buttons" : "Show display buttons"}
                onClick={() => { const n = !displayOn; if (n) { if (offOthers) offOthers(); else if (allButtons) toggleAllButtons(); } setDisplayOn(n); }}
                style={tileSty(displayOn, "#2DD4BF")} className={tileCls}>
                <MonitorCog className="h-4 w-4" strokeWidth={2} /><span data-nav-label className={lbl}>Display</span>
            </button>}
            {setAccountOn && (!only || only === "account") && <AccountNavButton on={accountOn} onToggle={() => { const n = !accountOn; if (n) { offOthers?.(); openAccountModal("account"); } else closeAccountModal(); setAccountOn(n); }}
                style={tileSty(accountOn, ACCOUNT_COLOR)} className={tileCls} />}
        </>
    );
}

// "Fav Toggles": easy button for the Shift+click favourite feature (tabs, teams, toggles).
function FavTogglesBtn() {
    const on = usePinMode();
    return (
        <button type="button" data-fav-toggles data-testid="access-fav-toggles" title={on ? "Fav Toggles ON — tap anything to favourite it" : "Fav Toggles — tap to favourite tabs, teams and toggles (same as Shift+click)"}
            onClick={() => setPinMode(!on)} className={AZ_BTN} style={azPill(on, "#F6C453")}>
            <Pin className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">Fav Toggles</span>
        </button>
    );
}

// Schedule + Standings "Delay": ONE account value (push_prefs.game_delay_sec), so both pages always match.
function DelayPop() {
    const qc = useQueryClient();
    const delay = useGameDelay();
    const { data: account } = useQuery({ queryKey: ["account"], queryFn: () => api.get("/account").then((r) => r.data), staleTime: 60 * 1000 });
    const prefs = account?.profile?.push_prefs || {};
    const mine = prefs.game_delay_sec;
    const set = (v) => {
        const next = { ...prefs };
        if (v === null) delete next.game_delay_sec; else next.game_delay_sec = v;
        qc.setQueryData(["account"], (a) => (a ? { ...a, profile: { ...(a.profile || {}), push_prefs: next } } : a));
        updateAccount({ push_prefs: next }).then(() => qc.invalidateQueries({ queryKey: ["account"] })).catch(() => { });
    };
    const chip = (on) => `h-7 px-2 rounded-md border text-[10px] font-bold uppercase transition-colors ${on ? "border-[#F59E0B] bg-[#F59E0B]/15 text-[#F59E0B]" : "border-white/10 bg-white/5 text-white/70 hover:text-white"}`;
    return (
        <DispPop k="delay" label={delay ? `Delay ${DELAY_LABEL(delay)}` : "Delay"} Icon={Clock} active={delay > 0} color="#F59E0B">
            <button type="button" data-testid="delay-default" onClick={() => set(null)} className={chip(mine === undefined || mine === null)}>Site default</button>
            {DELAY_STEPS.map((v) => (
                <button key={v} type="button" data-testid={`delay-${v}`} onClick={() => set(v)} className={chip(mine === v)}>{DELAY_LABEL(v)}</button>
            ))}
        </DispPop>
    );
}

// Access-box pill that opens a small popup (Page size, Nav bar, Device, Profiles).
function DispPop({ k, label, Icon, active = false, color = "#2DD4BF", children }) {
    const [pos, setPos] = useState(null);
    const ref = useRef(null);
    const popRef = useRef(null);
    const open = !!pos;
    const toggle = () => {
        if (open) { setPos(null); return; }
        const r = ref.current.getBoundingClientRect();
        setPos({ top: r.bottom + 6, right: Math.max(8, window.innerWidth - r.right) });
    };
    useEffect(() => {
        if (!open) return undefined;
        const close = (e) => { if (!ref.current?.contains(e.target) && !popRef.current?.contains(e.target)) setPos(null); };
        const off = () => setPos(null);
        document.addEventListener("mousedown", close);
        window.addEventListener("scroll", off, true);
        window.addEventListener("resize", off);
        return () => { document.removeEventListener("mousedown", close); window.removeEventListener("scroll", off, true); window.removeEventListener("resize", off); };
    }, [open]);
    return (
        <span ref={ref} className="relative inline-flex h-full">
            <button type="button" data-testid={`access-${k}`} onClick={toggle} className={AZ_BTN} style={azPill(open || active, color)}>
                <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /><span className="leading-none">{label}</span>
            </button>
            {open && createPortal(
                <div ref={popRef} style={{ position: "fixed", top: pos.top, right: pos.right }} className="z-[100050] flex items-center gap-1.5 flex-wrap rounded-lg border border-[#2DD4BF]/40 bg-[#0A0B10]/95 backdrop-blur-xl p-2 shadow-xl w-max max-w-[420px]" data-testid={`access-${k}-popup`}>
                    {children}
                </div>, document.body)}
        </span>
    );
}

const PuckGlyph = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden>
        <ellipse cx="12" cy="8.5" rx="8" ry="3.4" fill="currentColor" opacity="0.35" />
        <path d="M4 8.5v6.2c0 1.88 3.58 3.4 8 3.4s8-1.52 8-3.4V8.5" stroke="currentColor" strokeWidth="1.8" fill="currentColor" fillOpacity="0.12" />
        <ellipse cx="12" cy="8.5" rx="8" ry="3.4" stroke="currentColor" strokeWidth="1.8" />
    </svg>
);

const BUSINESS_NAV = {
    label: "Business",
    children: [],
};

// Owner-only "Owner" subnav (shown when hovering the crown button). Everything
// the owner configures now lives on the Owner page.
const OWNER_NAV = {
    label: "Owner Access",
    children: [],
};

// Owner-only "Switchboard" control hub (grey cog button, furthest right) — now
// a shortcut into the consolidated Owner page.
const CONTROL_NAV = {
    label: "Control",
    children: [
        { to: "/owner?tab=settings", label: "Settings" },
        { to: "/owner?tab=leagues", label: "All Leagues" },
    ],
};

// Access nav — a persistent TAB bar across all access routes (My Account · Admin ·
// Business · Creator · Owner). Clicking a tab swaps the page view (SPA) while the
// bar stays put; the active tab is derived from the route and its drawer auto-opens.
const ACCESS_ICONS = { admin: Shield, business: Briefcase, creator: Palette, owner: Crown };
// Authoritative league → country map (by abbr / short name). "Other" leagues fall to International.
const LEAGUE_COUNTRY = {
    "awihl": "Australia",
    "debl": "Austria", "debl2": "Austria", "debl3": "Austria",
    "belarus": "Belarus", "belarus (w)": "Belarus",
    "acac": "Canada", "cahs": "Canada", "cwhl": "Canada", "provincial whl": "Canada", "provincial whl (w)": "Canada", "qchl": "Canada", "qchl d2": "Canada", "qchl d2 (w)": "Canada", "usports": "Canada",
    "pwhl": "Canada / United States", "jwhl u19": "Canada / United States", "jwhl u19 (w)": "Canada / United States", "naprephl": "Canada / United States", "naprephl (w)": "Canada / United States",
    "1. liga žen": "Czechia", "extraliga žen": "Czechia",
    "denmark": "Denmark",
    "auroraliiga": "Finland", "mestis": "Finland", "suomi-sarja": "Finland",
    "france": "France",
    "dfel": "Germany", "germany2": "Germany", "germany3": "Germany", "germany4": "Germany",
    "iceland": "Iceland",
    "ihl women": "Italy",
    "baltic": "Multi-National", "baltic (w)": "Multi-National", "ewhl": "Multi-National",
    "norway": "Norway", "norway2": "Norway",
    "plhk": "Poland",
    "romania": "Romania",
    "russia": "Russia",
    "extraliga žien": "Slovakia",
    "wihl": "Slovenia",
    "spain": "Spain",
    "division 2": "Sweden", "division 3": "Sweden", "division 3 (w)": "Sweden", "ndhl": "Sweden", "sdhl": "Sweden", "tv-pucken": "Sweden", "tv-pucken (w)": "Sweden", "u18 region": "Sweden",
    "swhl a": "Switzerland", "swhl b": "Switzerland",
    "turkey": "Turkey",
    "wnihl 1": "United Kingdom", "wnihl 2": "United Kingdom", "wnihl elite": "United Kingdom", "wnihl u16": "United Kingdom",
    "mawhl": "United States", "ncaa": "United States", "ncaa iii": "United States", "ushs": "United States",
    "wc": "International", "women's hockey olympics": "International",
};

const COUNTRY_FLAGS = {
    "Australia": "🇦🇺", "Austria": "🇦🇹", "Belarus": "🇧🇾", "Canada": "🇨🇦", "Czechia": "🇨🇿",
    "Denmark": "🇩🇰", "Finland": "🇫🇮", "France": "🇫🇷", "Germany": "🇩🇪", "Great Britain": "🇬🇧",
    "United Kingdom": "🇬🇧", "Iceland": "🇮🇸", "Italy": "🇮🇹", "Netherlands": "🇳🇱", "Norway": "🇳🇴",
    "Poland": "🇵🇱", "Romania": "🇷🇴", "Russia": "🇷🇺", "Slovakia": "🇸🇰", "Slovenia": "🇸🇮",
    "Spain": "🇪🇸", "Sweden": "🇸🇪", "Switzerland": "🇨🇭", "Turkey": "🇹🇷", "United States": "🇺🇸",
    "International": "🌍", "Multi-National": "🌍", "Other": "🏳️",
};

// Continent grouping for the cascade (Main Leagues | Continents > Countries > Leagues > Teams).
const CONTINENTS = {
    "North America": ["Canada", "United States"],
    "Europe": ["Austria", "Belarus", "Czechia", "Denmark", "Finland", "France", "Germany", "Iceland", "Italy", "Netherlands", "Norway", "Poland", "Romania", "Russia", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland", "Turkey", "United Kingdom", "Great Britain"],
    "Oceania": ["Australia"],
    "International": ["International", "Multi-National"],
};
const CONTINENT_ORDER = ["North America", "Europe", "Oceania", "International"];
const CONTINENT_OF = {};
Object.entries(CONTINENTS).forEach(([cont, list]) => list.forEach((c) => { CONTINENT_OF[c] = cont; }));
const ncaaInitials = (s) => {
    const t = (s || "").trim(); if (!t) return "?";
    const parts = t.split(/\s+/).filter(Boolean);
    return (parts.length > 1 ? parts.map((w) => w[0]).join("") : t).slice(0, 3).toUpperCase();
};

// Cascading nav: Main Leagues | Continents > Countries > Leagues > Teams. Every
// level is CLICK-to-reveal. Picking a team selects that league AND opens the
// team's roster page (PWHL/other → /teams/:id?tab=players, NCAA → /ncaa players).
export function FindCascade({ onNavigate, onSelectLeague, isOwner = false, isAdmin = false }) {
    const navigate = useNavigate();
    const [continent, setContinent] = React.useState(null);
    const [country, setCountry] = React.useState(null);
    const [lg, setLg] = React.useState(null);
    const { data: leagues = [] } = useQuery({ queryKey: ["leagues-dir"], queryFn: getLeaguesDirectory, staleTime: 5 * 60 * 1000 });
    const { data: pwhlTeams = [] } = useQuery({ queryKey: ["teams", "pwhl"], queryFn: () => api.get("/teams", { params: { league: "pwhl" } }).then((r) => r.data), staleTime: 5 * 60 * 1000 });
    const { data: dirTeams = [] } = useQuery({ queryKey: ["league-teams", lg?.id], queryFn: () => getLeagueTeams(lg.id), enabled: !!lg && lg.id !== "pwhl" && lg.id !== "ncaa", staleTime: 5 * 60 * 1000 });
    const { data: overrides = {} } = useQuery({ queryKey: ["team-overrides"], queryFn: () => api.get("/team_overrides").then((r) => r.data), staleTime: 10 * 60 * 1000 });

    const norm = (c) => (c === "USA" ? "United States" : c);
    const countryMap = {};
    leagues.forEach((l) => {
        const key = (l.abbr || "").toLowerCase().trim();
        const nkey = (l.name || "").toLowerCase().trim();
        const mapped = LEAGUE_COUNTRY[key] || LEAGUE_COUNTRY[nkey] || "International";
        const cs = mapped.split(/\s*[/,]\s*/).map((s) => norm(s.trim())).filter(Boolean);
        cs.forEach((c) => { (countryMap[c] = countryMap[c] || []).push(l); });
    });
    const allCountries = Object.keys(countryMap);
    const continentsPresent = CONTINENT_ORDER.filter((cont) => allCountries.some((c) => (CONTINENT_OF[c] || "International") === cont));
    const countriesInContinent = continent ? allCountries.filter((c) => (CONTINENT_OF[c] || "International") === continent).sort() : [];
    const countryLeagues = country ? (countryMap[country] || []).slice().sort((a, b) => (a.name || "").localeCompare(b.name || "")) : [];
    const MAIN = [{ id: "pwhl", name: "PWHL" }];

    const pick = (id) => { if (onSelectLeague) onSelectLeague(id); };
    // Switch League: pressing a league just switches the active league (→ overview).
    const switchLeague = (id) => { pick(id); if (onNavigate) onNavigate(); navigate(id === "ncaa" ? "/ncaa" : leagueEquivalentRoute(id, legacyPath(), window.location.search)); };
    // Pressing a team opens that team's overview.
    const goPwhlTeam = (id) => { pick("pwhl"); if (onNavigate) onNavigate(); navigate(`/team-pages/${id}`); };
    const goNcaaSchool = (school) => { pick("ncaa"); if (onNavigate) onNavigate(); navigate(`/ncaa?tab=players&school=${encodeURIComponent(school)}`); };
    const goOtherTeam = (id) => { if (lg) pick(lg.id); if (onNavigate) onNavigate(); navigate(`/team-pages/${id}`); };

    // Standardised narrow nav-bar pill styling (matches mode-nav / team-pick pills).
    const Lbl = ({ children }) => <span className="px-1.5 self-center text-[10px] font-black uppercase tracking-[0.15em] text-white/45">{children}</span>;
    const pillCls = (on) => `px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider border transition-colors ${on ? "bg-[#9D4CDD]/25 border-[#9D4CDD]/60 text-white" : "bg-black/25 border-white/15 text-[#94A3B8] hover:text-white"}`;
    const Row = ({ testid, children, top }) => (
        <div className={`flex flex-wrap items-center justify-center gap-1.5 py-2 ${top ? "border-t border-white/10" : ""}`} data-testid={testid}>{children}</div>
    );
    const orderedPwhlIds = pwhlTeams.map((t) => t.id);

    return (
        <div data-testid="find-cascade" className="mx-auto w-full max-w-[1500px]">
            <Row testid="find-cascade-main">
                <Lbl>Switch League</Lbl>
                {MAIN.map((m) => (
                    <button key={m.id} type="button" data-testid={`find-main-${m.id}`}
                        onClick={() => switchLeague(m.id)}
                        className={pillCls(false)}>{m.name}</button>
                ))}
                {isOwner && (
                    <>
                        <span className="mx-2 h-5 w-px bg-white/15 self-center" aria-hidden="true" />
                        <Lbl>Find League/Team</Lbl>
                        {continentsPresent.map((cont) => (
                            <button key={cont} type="button" data-testid={`find-continent-${cont.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                onClick={() => { setContinent(cont); setCountry(null); setLg(null); }}
                                className={pillCls(continent === cont)}>{cont}</button>
                        ))}
                    </>
                )}
            </Row>
            {continent && (
                <Row testid="find-cascade-countries" top>
                    <Lbl>{continent}</Lbl>
                    {countriesInContinent.map((c) => (
                        <button key={c} type="button" data-testid={`find-country-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            onClick={() => { setCountry(c); setLg(null); }}
                            className={`inline-flex items-center gap-1.5 ${pillCls(country === c)}`}>
                            {COUNTRY_FLAGS[c] ? <span className="text-sm leading-none">{COUNTRY_FLAGS[c]}</span> : null}{c}
                        </button>
                    ))}
                    {countriesInContinent.length === 0 && <span className="text-xs text-white/40">No countries.</span>}
                </Row>
            )}
            {country && (
                <Row testid="find-cascade-leagues" top>
                    <Lbl>{country} Leagues</Lbl>
                    {countryLeagues.map((l) => (
                        <button key={l.id} type="button" data-testid={`find-league-${l.id}`}
                            onClick={() => setLg(l)} className={pillCls(lg?.id === l.id)}>{l.abbr || l.name}</button>
                    ))}
                    {countryLeagues.length === 0 && <span className="text-xs text-white/40">No leagues.</span>}
                </Row>
            )}
            {lg && lg.id === "pwhl" && (
                <div className="border-t border-white/10 py-2" data-testid="find-cascade-teams">
                    <PwhlTeamButtons teamIds={orderedPwhlIds} selected="" onSelect={(id) => id && goPwhlTeam(id)}
                        showAll={false} align="center" leagueLabel="PWHL" modeLabel="Team Pick" testId="find-pwhl-teams" />
                </div>
            )}
            {lg && lg.id === "ncaa" && (
                <div className="border-t border-white/10 py-2" data-testid="find-cascade-ncaa">
                    <div className="flex flex-wrap gap-2 justify-center items-start" data-testid="find-ncaa-teams">
                        <span className="inline-flex items-center gap-1.5 pr-1.5 mr-0.5 border-r border-white/10 self-center select-none">
                            <span className="font-heading text-sm font-black uppercase tracking-tight text-white leading-none">NCAA</span>
                            <span className="text-[9px] font-bold uppercase tracking-wider text-white/45 border border-white/15 rounded px-1.5 py-0.5 leading-none">Team Pick</span>
                        </span>
                        {NCAA_CONFERENCES.filter((d) => (NCAA_COLLEGES[d] || []).length).map((div) => (
                            <div key={div} className="flex items-start gap-1.5" data-testid={`find-ncaa-division-${div}`}>
                                <span className="self-stretch inline-flex items-center px-2.5 text-[11px] font-black uppercase tracking-wider rounded-lg border border-white/20 bg-white/5 text-white/90 cursor-default select-none">{div}</span>
                                <div className="grid grid-rows-4 grid-flow-col gap-1">
                                    {(NCAA_COLLEGES[div] || []).map((school) => {
                                        const ov = overrides?.[`ncaa-${div}-${school}`] || {};
                                        const abbr = ov.abbreviation || ncaaInitials(school);
                                        return (
                                            <button key={school} type="button" title={school} data-testid={`find-ncaa-team-${school}`}
                                                onClick={() => goNcaaSchool(school)}
                                                className="inline-flex items-center gap-1.5 pl-1.5 pr-2.5 py-1 text-[11px] font-bold uppercase tracking-wider rounded-lg border bg-black/25 border-white/15 text-[#94A3B8] hover:text-white transition-colors">
                                                <span className="w-5 h-5 rounded-full overflow-hidden flex items-center justify-center shrink-0" style={{ background: ov.logo_url ? "transparent" : "#000" }}>
                                                    {ov.logo_url ? <img src={assetUrl(ov.logo_url)} alt={school} className="w-full h-full object-contain" /> : <span className="text-[7px] font-black text-white leading-none">{abbr}</span>}
                                                </span>
                                                {abbr}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {lg && lg.id !== "pwhl" && lg.id !== "ncaa" && (
                <Row testid="find-cascade-teams" top>
                    <Lbl>{lg.abbr || lg.name} Teams</Lbl>
                    {dirTeams.map((t) => { const id = t.id || t.team_id; const nm = t.abbreviation || t.name || id; return (
                        <button key={id} type="button" data-testid={`find-team-${id}`} onClick={() => goOtherTeam(id)}
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider border bg-white/10 border-white/30 text-white hover:bg-white/20 transition-colors">
                            <TeamBadge teamId={id} size="xs" asLink={false} />{nm}
                        </button>
                    ); })}
                    {dirTeams.length === 0 && <span className="text-xs text-white/40">No teams yet — add teams on this league's page.</span>}
                </Row>
            )}
        </div>
    );
}


function AccessNavBar({ areas, pathname, onEnter, onLeave, onNavigate }) {
    const navigate = useNavigate();
    const activeKey = pathname.startsWith("/admin") ? "admin"
        : pathname.startsWith("/business") ? "business"
            : pathname.startsWith("/creator") || pathname.startsWith("/template-studio") || pathname.startsWith("/gallery") ? "creator"
                : pathname.startsWith("/owner") ? "owner"
                    : "account";
    const [hoverKey, setHoverKey] = React.useState(null);
    const openKey = hoverKey || activeKey;
    const openArea = areas.find((a) => a.key === openKey) || null;
    const go = (to) => { onNavigate && onNavigate(); navigate(to); };
    const Tab = ({ k, label, color, to }) => {
        const active = activeKey === k;
        const Icon = ACCESS_ICONS[k];
        return (
            <button type="button" data-testid={`nav-access-${k}-trigger`}
                onMouseEnter={() => setHoverKey(k)} onClick={() => go(to)}
                style={active ? { background: `${color}26`, borderColor: `${color}59`, color: "#fff" } : { borderColor: "rgba(255,255,255,0.15)", background: "rgba(0,0,0,0.25)", color }}
                className="inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wider transition-colors hover:text-white">
                {Icon ? <Icon className="h-3.5 w-3.5" style={{ color: active ? "#fff" : color }} /> : <User className="h-3.5 w-3.5" />}
                {label}
                {k !== "account" && <ChevronDown className={`h-3.5 w-3.5 transition-transform ${openKey === k ? "rotate-180" : ""}`} />}
            </button>
        );
    };
    return (
        <div className="hidden lg:block sticky top-[var(--hdr-h,104px)] z-40 bg-[#0A0B10]/92 backdrop-blur-xl border-b border-[#1E2233]"
            data-testid="desktop-subnav-account" onMouseEnter={onEnter} onMouseLeave={() => { setHoverKey(null); onLeave && onLeave(); }}>
            <div className="w-full px-4 md:px-8 lg:px-12">
                <div className="flex flex-col items-center gap-2 py-2.5">
                    <div className="flex flex-wrap items-center justify-center gap-2">
                        <Tab k="account" label="My Account" color="#94A3B8" to="/account" />
                        {areas.map((a) => <Tab key={a.key} k={a.key} label={a.label} color={a.color} to={(a.children[0] && a.children[0].to) || "/account"} />)}
                    </div>
                    {openArea && openArea.children.length > 0 && (
                        <div className="w-full flex flex-wrap items-center justify-center gap-1.5 border-t border-white/10 pt-2.5" data-testid="nav-access-drawer">
                            <span className="font-heading text-base uppercase tracking-tight leading-none font-black self-center mr-1" style={{ color: openArea.color }}>{openArea.label}</span>
                            {openArea.children.map((c) => {
                                const search = typeof window !== "undefined" ? window.location.search : "";
                                const cur = pathname + search;
                                // A no-query link (e.g. Revenue → /business) is active ONLY when there's
                                // no ?tab, so picking another tab doesn't leave Revenue highlighted.
                                const active = c.to.indexOf("?") === -1 ? (pathname === c.to && !search) : cur === c.to;
                                return (
                                    <Link key={c.to} to={c.to} onClick={onNavigate}
                                        data-testid={`nav-access-${openArea.key}-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        style={active ? { background: `${openArea.color}26`, borderColor: `${openArea.color}59`, color: "#fff" } : undefined}
                                        className={`px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider border transition-colors ${active ? "" : "bg-black/25 border-white/10 text-[#94A3B8] hover:text-white"}`}>
                                        {c.label}
                                    </Link>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}


// Public routes that expose an inline admin editor. In Admin Mode these nav
// items highlight white to signal "admin available here".
export const ADMIN_ROUTES = new Set([
    "/",
    "/teams?tab=standings", "/teams?tab=schedule", "/teams?tab=contracts", "/teams?tab=draft",
    "/teams?tab=transfers", "/teams?tab=trades",
    "/rankings", "/awards", "/starting-six",
    "/records", "/milestones",
    "/news", "/roadmap",
]);
// Does a given location (pathname + search) expose an inline admin editor?
export const routeHasAdmin = (pathname, search = "") => {
    const full = `${pathname}${search || ""}`;
    return ADMIN_ROUTES.has(full) || ADMIN_ROUTES.has(pathname);
};
const linkHasAdmin = (l) => l.children ? l.children.some((c) => ADMIN_ROUTES.has(c.to)) : ADMIN_ROUTES.has(l.to);

// Subtabs for an individual team page (rendered in the desktop subnav when the
// "Teams" section is hovered or a /teams/:id page is open).
export const TEAM_SUBTABS = [
    { k: "overview", l: "Overview" },
    { k: "roster", l: "Lineups" },
    { k: "players", l: "Rosters" },
    { k: "schedule", l: "Schedule" },
    { k: "leaderboards", l: "Leaderboards" },
    { k: "records", l: "Records" },
    { k: "transfers", l: "History" },
    { k: "injuries", l: "Injuries" },
    { k: "discipline", l: "Discipline" },
    { k: "staffmoves", l: "Staff Moves" },
    { k: "contracts", l: "Contracts" },
    { k: "staff", l: "Staff" },
    { k: "news", l: "News" },
    { k: "videos", l: "Videos" },
];

// Owner device-preview frame — renders the CURRENT route inside an iframe at a
// fixed device width (with ?__view=embed so the embedded copy renders normally
// and never re-wraps). Breakpoints/window width respond to the iframe size.
function DeviceFrame({ device, orientation, scale = 1 }) {
    const base = device === "tablet" ? { w: 834, h: 1112 } : { w: 390, h: 800 };
    const land = orientation === "landscape";
    const w = land ? base.h : base.w;
    const h = land ? base.w : base.h;
    const src = (() => {
        const u = new URL(window.location.href);
        u.searchParams.set("__view", "embed");
        if (scale && scale !== 1) u.searchParams.set("__scale", String(scale));
        else u.searchParams.delete("__scale");
        return u.pathname + u.search;
    })();
    return (
        <div className="flex justify-center py-6" data-testid="device-frame">
            <div className="rounded-[34px] border-[8px] border-[#1B2030] bg-black shadow-2xl shadow-black/60 overflow-hidden" style={{ width: w + 16, height: h + 16 }}>
                <iframe src={src} title={`${device} preview`} data-testid="device-frame-iframe"
                    style={{ width: w, height: h, border: "none", display: "block", background: "#0A0B10" }} />
            </div>
        </div>
    );
}

// A SECOND nav bar (below the main one) that appears on Game Centre pages. The
// game page publishes its controls via GameNavContext; the main nav is untouched.
// Team sorting no longer lives here — it's global on the header's Team Surf button.
function GameCentreSubNav({ widthClass = "max-w-none", wide = false }) {
    const { nav } = useGameNav();
    const location = useLocation();

    const hasNav = !!nav && (!nav.path || nav.path === location.pathname);
    // Standard dropdown behaviour on EVERY page: an open nav drawer closes once the pointer leaves the nav.
    const { setOpenGroup } = useSortByTeam();
    const closeT = useRef(null);
    const onNavEnter = () => clearTimeout(closeT.current);
    useEffect(() => {
        const h = () => setOpenGroup?.((g) => (g === TEAM_GROUP ? g : null));
        window.addEventListener("rosterly:navpop-open", h);
        return () => window.removeEventListener("rosterly:navpop-open", h);
    }, [setOpenGroup]);
    const onNavLeave = () => {
        clearTimeout(closeT.current);
        closeT.current = setTimeout(() => { if (!document.querySelector("[data-radix-popper-content-wrapper]")) setOpenGroup?.(null); }, 220);
    };

    // Always mounted so page-specific access buttons have a home; hidden when it has nothing to show.
    return (
        <div onMouseEnter={onNavEnter} onMouseLeave={onNavLeave} className={`${hasNav ? "hidden lg:block" : "hidden lg:[&:has([data-pa])]:block"} sticky top-[calc(var(--hdr-h,104px)+var(--sub-h,0px)+var(--teambar-h,0px))] z-40 bg-[#0A0B10]/95 backdrop-blur border-b border-[#1E2233] py-2.5`} data-testid="game-centre-subnav">
            <div className={`px-4 md:px-8 lg:px-12 overflow-x-hidden ${widthClass === "max-w-none" ? "w-full" : `mx-auto ${widthClass}`} flex justify-center`}>
                <div className={`w-full flex flex-wrap items-start justify-center gap-x-3 gap-y-2 ${wide ? "[&>*]:!w-auto [&>*]:!flex-none [&>*]:!max-w-full" : ""}`} data-wide={wide ? "1" : "0"}>
                    {hasNav && (nav.content ? nav.content : <GameCentreNavBar {...nav} />)}
                    <div id="page-access-slot" className="contents" data-testid="page-access-slot" />
                </div>
            </div>
        </div>
    );
}

// Mobile top-header quick actions (Search + Tour) shown beside the account
// button. Search opens the mobile search drawer; Tour opens the page tour.
function MobileHeaderActions() {
    const { openDrawer } = useMobileNav();
    const { isOwner } = useAuth();
    const tour = useTour();
    return (
        <>
            <button type="button" onClick={() => openDrawer("search")} data-testid="mobile-top-search" aria-label="Search"
                className="p-1.5 rounded-md bg-[#1E2233] text-white/80 hover:text-white">
                <Search className="h-4 w-4" />
            </button>
            {isOwner && (
            <button type="button" onClick={() => { if (tour?.hasTour) tour.openPrompt(); else toast("A guided tour for this page is coming soon."); }}
                data-testid="mobile-top-tour" aria-label="Page tour"
                className="p-1.5 rounded-md bg-[#1E2233] text-white/80 hover:text-white">
                <HelpCircle className="h-4 w-4" />
            </button>
            )}
        </>
    );
}

// Current switchboard pick for a league, in favourite-value form (groups as "g:<name>").
const normSurfVal = (lg, v) => (!v || v === "all" ? "" : /^(conf|div):/.test(v) ? `g:${v.replace(/^(conf|div):/, "")}` : v);
const curSurfVal = (sb, lg) => {
    const multi = lg === "nhl" ? sb.nhlSurfMulti : sb.pwhlSurfMulti;
    if (multi && multi.length > 1) return `multi:${multi.join(",")}`;
    const g = lg === "nhl" ? sb.nhlSurfGroup : sb.pwhlSurfGroup;
    if (g) return `g:${g}`;
    return (lg === "nhl" ? sb.nhlSurfTeam : sb.surfTeam) || "";
};

// Applies the signed-in user's favourite LEAGUE once per session, then keeps the
// team selector in sync on every navigation: a page's own pinned team wins, else
// the league's FAVOURITE (team_default), else All Teams.
function PrefsDefaulter() {
    const { user } = useAuth();
    const { setLeague, league } = useLeague();
    const navigate = useNavigate();
    const location = useLocation();
    const { getPref } = usePagePrefs();
    const { data: account } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: !!user });

    useEffect(() => {
        if (!account) return;
        try { if (sessionStorage.getItem("rosterly_league_applied")) return; } catch { /* noop */ }
        try { sessionStorage.setItem("rosterly_league_applied", "1"); } catch { /* noop */ }
        const fav = account.profile?.fav_league;
        let fromRoot = false;
        try { fromRoot = !!sessionStorage.getItem("rosterly_from_root"); sessionStorage.removeItem("rosterly_from_root"); } catch { /* noop */ }
        if (fav && fav !== league) {
            setLeague(fav);
            // App opened at "/": land on the favourite league's favourite group/tab.
            if (fromRoot) navigate(landingForLeague(fav), { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account]);

    // A picked team survives page changes on every device.
    const sb = useSortByTeam();
    const seenRef = useRef({ leagues: {}, key: null, route: null, target: {} });
    const lgNow = league === "nhl" ? "nhl" : "pwhl";
    const pageTeamNow = getPref("page_team", location.pathname) || "";
    // The league favourite only auto-applies on team pages (Standings, Rosters, Lineups); never on Schedule, Chemistry etc.
    const favNow = isFavPage(location.pathname) ? (getPref("team_default", lgNow) || "") : "";
    useEffect(() => {
        // Only re-apply when the PAGE/LEAGUE changes or the favourite/page-pin VALUE
        // changes — never on unrelated pref writes (that used to snap every team
        // pick straight back to the favourite).
        const route = location.pathname;
        const lg = lgNow;
        const st = seenRef.current;
        const key = `${lg}|${route}`;
        const target = pageTeamNow || favNow;
        const navChanged = st.key !== key;
        const targetChanged = st.target[key] !== undefined && st.target[key] !== target;
        const prevPin = st.route && st.route !== route ? getPref("page_team", st.route) : null;
        st.key = key;
        st.route = route;
        st.target[key] = target;
        const first = !st.leagues[lg];
        st.leagues[lg] = true;
        if (!navChanged && !targetChanged && !first) return;
        st.applied = st.applied || {};
        st.before = st.before || {};
        const cur = curSurfVal(sb, lg);
        const fromCur = (v) => (v && v.startsWith("g:") ? `conf:${v.slice(2)}` : v || null);
        const leftPin = !!(navChanged && prevPin && cur === normSurfVal(lg, prevPin));
        // THIS-PAGE favourite: always wins on its own page (Surf on or off) and never leaks to other pages.
        if (pageTeamNow) {
            if (navChanged && !leftPin) st.before[lg] = { val: cur, explore: !!cur && cur !== st.applied[lg] };
            st.applied[lg] = normSurfVal(lg, pageTeamNow);
            applySurf(sb, lg, pageTeamNow);
            return;
        }
        const before = leftPin ? st.before[lg] : null;
        // SURF on: the clicked team follows you everywhere — leaving a this-page favourite goes back to it.
        if (sb.surfMode && !first) {
            if (leftPin) applySurf(sb, lg, fromCur(before?.val));
            else st.before[lg] = { val: cur, explore: true };
            return;
        }
        // Surf off: leaving a this-page favourite resumes the team you were exploring with (if no league favourite).
        if (leftPin && before?.explore && !favNow) { applySurf(sb, lg, fromCur(before.val)); return; }
        // A league favourite applies and STOPS any explore pick. No favourite: a switchboard pick keeps
        // sorting pages while exploring (auto-surf, Surf button untouched); after a favourite took over → All Teams.
        // (First load: the remembered team is NOT an explore pick, so a page with no favourite opens on All Teams.)
        if (!first && !target && !leftPin && cur && cur !== st.applied[lg]) { st.before[lg] = { val: cur, explore: true }; return; }
        st.applied[lg] = normSurfVal(lg, target);
        st.before[lg] = { val: normSurfVal(lg, target), explore: false };
        applySurf(sb, lg, target);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, lgNow, pageTeamNow, favNow]);
    return null;
}


// Surfboard glyph (lucide has none).
export function SurfboardIcon({ className = "h-3.5 w-3.5" }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
            <path d="M19.5 4.5c-4-1.5-10 2-13.5 8.5-1.6 3-2 5.5-1.5 6.5 1 .5 3.5.1 6.5-1.5 6.5-3.5 10-9.5 8.5-13.5z" />
            <path d="M6.5 17.5 17 7" />
        </svg>
    );
}

export const Layout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const qc = useQueryClient();
    const [searchActive, setSearchActive] = useState(false);
    const [leagueBarOpen, setLeagueBarOpen] = useState(false);
    const searchWrapRef = useRef(null);
    const [navResort, setNavResort] = useState(false);
    const resortTimer = useRef(null);
    useEffect(() => {
        if (!searchActive) return;
        const onDown = (e) => { if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) setSearchActive(false); };
        const onKey = (e) => { if (e.key === "Escape") setSearchActive(false); };
        document.addEventListener("mousedown", onDown);
        document.addEventListener("keydown", onKey);
        return () => { document.removeEventListener("mousedown", onDown); document.removeEventListener("keydown", onKey); };
    }, [searchActive]);
    const dragId = useRef(null);
    const { user, logout, hasAdminAccess, isOwner, canBusiness, canCreate, canNhl } = useAuth();
    const { adminMode, toggle: toggleAdminMode, ownerView, toggleOwnerView } = useAdminMode();
    const { getPref: getPagePref, setPref: setPagePref } = usePagePrefs();
    const allSchedOn = getPagePref("page_toggle", "all_sched_on") === "on";
    const { mine: myFavourites = [], getTier, setTier, clearTier, isAuthed } = useFavourites();
    const tour = useTour();
    const { businessMode, toggle: toggleBusinessMode } = useBusinessMode();
    const { creatorMode, toggle: toggleCreatorMode } = useCreatorMode();
    const { device, setDevice, orientation, setOrientation, uiScale, bumpScale, pcRes, setPcRes, contentScaleFor, setContentScale, resetContentScale, navUiScale, setNavUiScale, bumpNavScale } = useDeviceView();
    const navZoom = device === "pc" && navUiScale ? navUiScale / (uiScale || 1) : 1;
    // Effective device bucket for owner-only per-page content scaling: use the
    // preview device when set, else the real viewport width.
    const [vw, setVw] = useState(() => (typeof window === "undefined" ? 1440 : window.innerWidth));
    useEffect(() => { const on = () => setVw(window.innerWidth); window.addEventListener("resize", on); return () => window.removeEventListener("resize", on); }, []);
    const effectiveDevice = device !== "pc" ? device : (vw < 768 ? "mobile" : vw < 1024 ? "tablet" : "pc");
    const embedParam = new URLSearchParams(location.search).get("__view") === "embed";
    // Sticky per-iframe flag: once loaded as an embed, this browsing context stays
    // "embedded" across client-side navigations (window.name is per-window and does
    // NOT leak to the parent), so the embedded copy never re-wraps in another frame.
    if (typeof window !== "undefined" && embedParam) { try { window.name = "rosterly-embed"; } catch (e) { /* noop */ } }
    const embedded = embedParam || (typeof window !== "undefined" && window.name === "rosterly-embed");
    const framePreview = !!user && isOwner && !embedded && device !== "pc";
    const [hoverNav, setHoverNav] = useState(null);
    const [acctOpen, setAcctOpen] = useState(false);
    const [keybinds, setKeybinds] = useState(() => {
        try { return JSON.parse(localStorage.getItem("rosterly_tab_keybinds") || "{}"); } catch { return {}; }
    });
    const [starMapOpen, setStarMapOpen] = useState(false);
    const [leaguePickerOpen, setLeaguePickerOpen] = useState(false);
    const { league: selectedLeague, setLeague: setSelectedLeague } = useLeague();
    // Owner quick-switch: "[" → NHL, "]" → PWHL. Opens the SAME page in the other
    // league when it exists there; otherwise falls back to that league's favourite/first tab.
    useEffect(() => {
        if (!isOwner) return;
        const NHL_ROUTE_FOR_TAB = { schedule: "/nhl/schedule", standings: "/nhl/standings", leaderboards: "/nhl/leaderboards", players: "/nhl/rosters", roster: "/nhl/lineups" };
        const TAB_FOR_NHL_ROUTE = { schedule: "schedule", standings: "standings", leaderboards: "leaderboards", rosters: "players", lineups: "roster" };
        const favRoute = (lg, group) => {
            try { return (JSON.parse(localStorage.getItem("rosterly_group_fav") || "{}"))[`${lg}:${group}`] || null; } catch { return null; }
        };
        const currentTabId = () => {
            const path = location.pathname;
            if (path.startsWith("/nhl/")) return TAB_FOR_NHL_ROUTE[path.split("/")[2]] || null;
            return tabFromLocation(location.pathname, location.search);
        };
        const goLeague = (target) => {
            const tabId = currentTabId();
            setSelectedLeague(target);
            let dest;
            if (target === "nhl") dest = (tabId && NHL_ROUTE_FOR_TAB[tabId]) || favRoute("nhl", "season") || "/nhl/schedule";
            else dest = (tabId && TAB_PATHS[tabId]) || favRoute("pwhl", "season") || pwhlLandingRoute();
            navigate(dest);
        };
        const onKey = (e) => {
            const t = e.target;
            if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.isContentEditable)) return;
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            if (e.key === "[") goLeague("pwhl");
            else if (e.key === "]") goLeague("nhl");
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [isOwner, setSelectedLeague, navigate, location.pathname, location.search]);
    const navStateRef = useRef({});
    const heldNumRef = useRef(null);
    const boundDuringHoldRef = useRef(false);
    const navRowRef = useRef(null);
    const headerRef = useRef(null);
    const subnavRef = useRef(null);
    const teamBarRef = useRef(null);
    const [navScale, setNavScale] = useState(1);
    // Access section-header double-click toggles the matching VIEW mode.
    const viewModes = { admin: adminMode, business: businessMode, creator: creatorMode, owner: ownerView };
    const rawToggleView = (k) => {
        if (k === "admin") toggleAdminMode();
        else if (k === "business") toggleBusinessMode();
        else if (k === "creator") toggleCreatorMode();
        else if (k === "owner") toggleOwnerView();
    };
    // Per-page locks (Shift+click on Display / Access buttons) — same idea as the border lock.
    const [pageLocks, setPageLocks] = useState(() => { try { return JSON.parse(localStorage.getItem("rosterly_page_locks") || "{}"); } catch { return {}; } });
    const pageLock = pageLocks[location.pathname] || {};
    const setPageLock = (k, v) => setPageLocks((prev) => {
        const cur = { ...(prev[location.pathname] || {}) };
        if (v === undefined) delete cur[k]; else cur[k] = v;
        const next = { ...prev, [location.pathname]: cur };
        if (!Object.keys(cur).length) delete next[location.pathname];
        try { localStorage.setItem("rosterly_page_locks", JSON.stringify(next)); } catch { /* noop */ }
        return next;
    });
    const viewSavedRef = useRef({});   // global value stashed while a locked page overrides it
    const onToggleView = (k, lock = false) => {
        const nextOn = !viewModes[k];
        if (lock) {
            if (viewSavedRef.current[k] === undefined) viewSavedRef.current[k] = !!viewModes[k];
            setPageLock(`view:${k}`, nextOn); toast(`This page locked: ${k} view ${nextOn ? "ON" : "OFF"}`);
        } else {
            delete viewSavedRef.current[k];
            if (`view:${k}` in pageLock) { setPageLock(`view:${k}`, undefined); toast("Page lock removed"); }
        }
        rawToggleView(k);
    };
    // Entering a locked page applies its locks; leaving restores the stashed global choice.
    useEffect(() => {
        ["admin", "business", "creator", "owner"].forEach((k) => {
            const lk = `view:${k}`;
            if (lk in pageLock) {
                if (viewSavedRef.current[k] === undefined) viewSavedRef.current[k] = !!viewModes[k];
                if (!!viewModes[k] !== !!pageLock[lk]) rawToggleView(k);
            } else if (viewSavedRef.current[k] !== undefined) {
                if (!!viewModes[k] !== viewSavedRef.current[k]) rawToggleView(k);
                delete viewSavedRef.current[k];
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    // Owner View acts as the nav edit mode: when on, nav re-ordering + favourite editing is live.
    useEffect(() => { setNavResort(!!ownerView); }, [ownerView]);
    const doSignOut = () => {
        setAcctOpen(false);
        if (window.confirm("Are you sure you want to sign out?")) { logout(); navigate("/"); }
    };
    const hoverTimer = useRef();
    const clearHoverTimer = () => clearTimeout(hoverTimer.current);
    const setHover = (v) => { clearHoverTimer(); setHoverNav(v); };
    const scheduleClearHover = () => { clearHoverTimer(); hoverTimer.current = setTimeout(() => setHoverNav(null), 160); };
    // Clear any sticky hover/section on route change so the page subnav (tab
    // buttons) always reflects the CURRENT page — e.g. going Admin → Business now
    // shows Business tabs, not the stale Admin tabs.
    useEffect(() => { clearHoverTimer(); setHoverNav(null); }, [location.pathname]);

    // Which top section (PWHL / Insights / Leagues) is active for the current route.
    // Individual team pages (/teams/:id) belong to the dedicated "Teams" section.
    const teamMatch = location.pathname.match(/^\/teams\/([^/?]+)/);
    const curTeamId = teamMatch ? teamMatch[1] : null;
    const curTeamTab = new URLSearchParams(location.search).get("tab") || "overview";
    const { data: navTeams = [] } = useQuery({ queryKey: ["teams"], queryFn: getTeams, staleTime: 5 * 60 * 1000 });
    const { data: navAccount } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: !!user });
    // Clock prefs (12h/24h + elapsed/left) follow the ACCOUNT onto every device.
    useEffect(() => { hydrateTimePrefs(navAccount?.profile); }, [navAccount]);
    const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings, staleTime: 5 * 60 * 1000 });
    // ── Owner per-page + per-device content scaling (applied to ALL viewers) ──
    // Saved map lives in settings.content_scales ({'path::device': scale}); the
    // owner edits a live DRAFT, then Saves (persists for everyone) or resets a
    // page/device to Default. Non-owners always render the saved scale.
    const savedScales = useMemo(() => settings?.content_scales || {}, [settings]);
    const [scaleDraft, setScaleDraft] = useState(null);
    useEffect(() => { if (settings) setScaleDraft((prev) => prev ?? { ...(settings.content_scales || {}) }); }, [settings]);
    const clampScaleV = (v) => Math.max(0.6, Math.min(1.6, Math.round(v * 100) / 100));
    const draftScales = scaleDraft || savedScales;
    const scaleKey = `${location.pathname}::${effectiveDevice}`;
    const scaleValFor = (map, key) => { const n = Number(map[key]); return Number.isFinite(n) && n > 0 ? n : 1; };
    const draftScaleVal = scaleValFor(draftScales, scaleKey);
    const setDraftScale = (val) => setScaleDraft((m) => ({ ...(m || savedScales), [scaleKey]: clampScaleV(val) }));
    const resetDraftScale = () => setScaleDraft((m) => { const n = { ...(m || savedScales) }; delete n[scaleKey]; return n; });
    const scaleDirty = useMemo(() => JSON.stringify(scaleDraft || {}) !== JSON.stringify(savedScales || {}), [scaleDraft, savedScales]);
    const saveScales = async () => {
        try { await saveContentScales(draftScales); await qc.invalidateQueries({ queryKey: ["settings"] }); toast.success("Page scaling saved for all viewers"); }
        catch { toast.error("Couldn't save page scaling"); }
    };
    // Owner previewing on Tablet/Mobile renders the page inside a device iframe;
    // the working scale is passed into that iframe via `__scale` (read below in
    // embed mode) so the CONTENT scales live — not the phone mock-up wrapper.
    const urlScale = embedParam ? parseFloat(new URLSearchParams(location.search).get("__scale")) : NaN;
    // Account monitor setting drives the desktop site zoom (phones/tablets always 100%).
    const acctMonitor = navAccount?.profile?.monitor || "auto";
    useEffect(() => {
        if (!navAccount || embedded) return;
        setPcRes(window.innerWidth >= 1024 ? "auto" : "1440");  // Automatic is now always on
    }, [acctMonitor, !!navAccount]); // eslint-disable-line react-hooks/exhaustive-deps
    // New accounts are sent to My Account → Setup until every step is done.
    useEffect(() => {
        const prof = navAccount?.profile;
        // Signed-in accounts are only FORCED to accept Terms (once). Everything else in Setup is optional.
        if (!prof || embedded || localStorage.getItem("rosterly_owner_token")) return;
        if (!termsPending(prof)) return;
        if (["/setup", "/login", "/terms", "/privacy", "/legal", "/reset-password"].includes(location.pathname)) return;
        navigate("/setup", { replace: true });
    }, [navAccount, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
    const pageScale = (embedded && Number.isFinite(urlScale) && urlScale > 0)
        ? urlScale
        : effectiveDevice === "mobile" ? 1 : (isOwner ? draftScaleVal : scaleValFor(savedScales, scaleKey));

    // PWHL sub-nav "Eye" mode (Open = full grid | Closed = collapsed groups that
    // reveal a 2nd horizontal bar on hover). Default Closed, saved per account.
    const [eyeMode, setEyeMode] = useState(() => { try { return localStorage.getItem("rosterly_nav_eye") || "open"; } catch { return "open"; } });
    useEffect(() => {
        const s = navAccount?.profile?.nav_eye_mode;
        if (s && (s === "open" || s === "closed") && s !== eyeMode) {
            setEyeMode(s);
            try { localStorage.setItem("rosterly_nav_eye", s); } catch { /* noop */ }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navAccount?.profile?.nav_eye_mode]);
    const cycleEye = () => {
        const nx = eyeMode === "open" ? "closed" : "open";
        setEyeMode(nx);
        try { localStorage.setItem("rosterly_nav_eye", nx); } catch { /* noop */ }
        if (user) updateAccount({ nav_eye_mode: nx }).then(() => qc.invalidateQueries({ queryKey: ["account"] })).catch(() => {});
    };
    // ↑↓ toggle (admin) — eliminate/show the SECONDARY nav bars (2nd/3rd/4th…).
    // The blue EYE handles the TOP sections bar separately.
    const [navsHidden, setNavsHidden] = useState(() => { try { return localStorage.getItem("rosterly_navs_hidden") === "1"; } catch { return false; } });
    const toggleNavsHidden = () => setNavsHidden((v) => { const nx = !v; try { localStorage.setItem("rosterly_navs_hidden", nx ? "1" : "0"); } catch { /* noop */ } if (user) updateAccount({ navs_hidden: nx }).catch(() => {}); return nx; });
    // <> toggle (admin) — "extended": merge page nav toggles inline (no dropdowns).
    const navExtended = useNavExtended();
    // ===== Eye circle: scale + device + colour + fullscreen controls =====
    const [eyeMenuOpen, setEyeMenuOpen] = useState(false);
    const [showHexInput, setShowHexInput] = useState(false);
    const eyeLongPress = useRef(false);
    const eyePressTimer = useRef(null);
    const eyeWrapRef = useRef(null);
    const eyeBtnRef = useRef(null);
    // Full-screen "view mode" — works site-wide. Default is STANDARD.
    const enterFullscreen = () => { const el = document.documentElement; if (!document.fullscreenElement) (el.requestFullscreen || el.webkitRequestFullscreen)?.call(el); };
    const exitFullscreen = () => { if (document.fullscreenElement) (document.exitFullscreen || document.webkitExitFullscreen)?.call(document); };
    const [, setFsTick] = useState(0);
    useEffect(() => { const f = () => setFsTick((t) => t + 1); document.addEventListener("fullscreenchange", f); return () => document.removeEventListener("fullscreenchange", f); }, []);
    // Nav colour: local optimistic state (instant apply) + localStorage + background save.
    const [navColour, setNavColourState] = useState(() => {
        try { return { style: localStorage.getItem("rosterly_nav_color_style") || "rosterly", hex: localStorage.getItem("rosterly_nav_color_hex") || "#6a3597", textHex: localStorage.getItem("rosterly_nav_text_hex") || "#ffffff" }; }
        catch { return { style: "rosterly", hex: "#6a3597", textHex: "#ffffff" }; }
    });
    useEffect(() => {
        const s = navAccount?.profile?.nav_color_style, h = navAccount?.profile?.nav_color_hex, tx = navAccount?.profile?.nav_text_hex;
        if (s) setNavColourState((c) => ({ style: s, hex: h || c.hex, textHex: tx || c.textHex }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navAccount?.profile?.nav_color_style, navAccount?.profile?.nav_color_hex]);
    const navColourStyle = navColour.style;
    // Border width: GLOBAL default for the whole account, with optional PER-PAGE
    // overrides (set via Shift+click on the Borders toggle).
    const [borderGlobal, setBorderGlobal] = useState(() => { try { return localStorage.getItem("rosterly_border_global") || "basic"; } catch { return "basic"; } });
    const [borderOverrides, setBorderOverrides] = useState(() => { try { return JSON.parse(localStorage.getItem("rosterly_border_overrides") || "{}"); } catch { return {}; } });
    // Hydrate display look from the account when signed in (backend wins), so a
    // cookie/cache clear no longer loses nav colour, border width or hidden navs.
    useEffect(() => {
        const bg = navAccount?.profile?.border_global;
        if (bg === "basic" || bg === "extended") {
            setBorderGlobal(bg);
            try { localStorage.setItem("rosterly_border_global", bg); } catch { /* noop */ }
            try { window.dispatchEvent(new Event("rosterly-borders")); } catch { /* noop */ }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navAccount?.profile?.border_global]);
    useEffect(() => {
        const nh = navAccount?.profile?.navs_hidden;
        if (typeof nh === "boolean") {
            setNavsHidden(nh);
            try { localStorage.setItem("rosterly_navs_hidden", nh ? "1" : "0"); } catch { /* noop */ }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navAccount?.profile?.navs_hidden]);
    useEffect(() => {
        const hu = navAccount?.profile?.height_unit;
        if (hu === "cm" || hu === "ft") {
            try {
                if (localStorage.getItem("rosterly_height_unit") !== hu) {
                    localStorage.setItem("rosterly_height_unit", hu);
                    window.dispatchEvent(new Event("rosterly-height-unit"));
                }
            } catch { /* noop */ }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navAccount?.profile?.height_unit]);
    // Standings always ignore the Extended width (mirrors the NHL fixed-width
    // table exactly) regardless of the account's global border setting.
    const forceBasicBorder = location.pathname === "/standings" || location.pathname === "/nhl/standings";
    const borderMode = forceBasicBorder ? "basic" : (borderOverrides[location.pathname] ?? borderGlobal);
    const setBorders = (m, perPage) => {
        if (perPage) {
            // Shift+click = LOCK this page to `m` (per-page override).
            setBorderOverrides((prev) => { const next = { ...prev, [location.pathname]: m }; try { localStorage.setItem("rosterly_border_overrides", JSON.stringify(next)); } catch { /* noop */ } return next; });
            toast(`This page locked to ${m === "extended" ? "Extended" : "Narrow"} borders`);
        } else {
            // Plain click = set the account default AND clear any lock on this page (unlock).
            setBorderGlobal(m); try { localStorage.setItem("rosterly_border_global", m); } catch { /* noop */ }
            if (user) updateAccount({ border_global: m }).catch(() => {});
            setBorderOverrides((prev) => {
                if (!(location.pathname in prev)) return prev;
                const next = { ...prev }; delete next[location.pathname];
                try { localStorage.setItem("rosterly_border_overrides", JSON.stringify(next)); } catch { /* noop */ }
                toast("Page border lock removed");
                return next;
            });
        }
        try { window.dispatchEvent(new Event("rosterly-borders")); } catch { /* noop */ }
    };
    const setNavColour = (style, hex, textHex) => {
        const next = { style, hex: hex || navColour.hex, textHex: textHex || navColour.textHex };
        setNavColourState(next);
        try { localStorage.setItem("rosterly_nav_color_style", next.style); localStorage.setItem("rosterly_nav_color_hex", next.hex); localStorage.setItem("rosterly_nav_text_hex", next.textHex); } catch { /* noop */ }
        if (user) updateAccount({ nav_color_style: next.style, nav_color_hex: next.hex, nav_text_hex: next.textHex }).then(() => qc.invalidateQueries({ queryKey: ["account"] })).catch(() => {});
    };
    // ===== Saved display profiles (per-account snapshots of display settings) =====
    // A "profile" bundles favourite league/teams, height unit, nav colour, border
    // mode & eye mode so a user can flip an entire look on any device in one tap
    // (e.g. "Home PC" vs "Work PC") instead of re-setting everything by hand.
    const displayProfiles = navAccount?.profile?.display_profiles || [];
    // Every device-side view key a profile snapshots (per-page borders, page/access toggles, surf, scales…).
    const PROFILE_LS_KEYS = ["rosterly_height_unit", "rosterly_time_format", "rosterly_border_global", "rosterly_border_overrides",
        "rosterly_page_prefs", "rosterly_nav_color_style", "rosterly_nav_color_hex", "rosterly_nav_text_hex", "rosterly_nav_eye",
        "rosterly_navs_hidden", "rosterly_content_scale", "rosterly_pc_res", "rosterly_admin_mode", "rosterly_owner_view"];
    const PROFILE_LS_PREFIXES = ["rosterly_surf_", "rosterly_nhl_surf_", "rosterly_pwhl_surf_"];
    const isProfileKey = (k) => PROFILE_LS_KEYS.includes(k) || PROFILE_LS_PREFIXES.some((pre) => k.startsWith(pre));
    const captureDisplayPrefs = () => {
        const ls = {};
        try {
            for (let i = 0; i < localStorage.length; i++) { const k = localStorage.key(i); if (k && isProfileKey(k)) ls[k] = localStorage.getItem(k); }
        } catch { /* noop */ }
        const pf = navAccount?.profile || {};
        return {
            v: 2, ls,
            fav_league: pf.fav_league || "", main_team_id: pf.main_team_id || "", main_nhl_team_id: pf.main_nhl_team_id || "",
            height_unit: ls.rosterly_height_unit === "ft" ? "ft" : "cm", time_format: pf.time_format || "12h", monitor: pf.monitor || "",
            nav_color_style: navColour.style, nav_color_hex: navColour.hex, nav_text_hex: navColour.textHex,
            border_mode: borderGlobal, eye_mode: eyeMode, navs_hidden: navsHidden,
        };
    };
    const persistProfiles = (list) => updateAccount({ display_profiles: list }).then(() => qc.invalidateQueries({ queryKey: ["account"] }));
    const saveDisplayProfile = () => {
        const name = (window.prompt("Name this display profile (e.g. Max — Home PC)") || "").trim();
        if (!name) return;
        const existing = displayProfiles.find((p) => (p.name || "").toLowerCase() === name.toLowerCase());
        if (existing && !window.confirm(`“${existing.name}” already exists. Overwrite it with your current settings?`)) return;
        const rest = displayProfiles.filter((p) => p !== existing);
        const list = [...rest, { id: existing?.id || `dp_${Date.now().toString(36)}`, name, prefs: captureDisplayPrefs() }].slice(-12);
        persistProfiles(list).then(() => toast.success(`Saved “${name}”`)).catch(() => toast.error("Could not save profile"));
    };
    const resaveDisplayProfile = (id) => {
        const p = displayProfiles.find((x) => x.id === id); if (!p) return;
        if (!window.confirm(`Re-save “${p.name}” with your current settings?`)) return;
        persistProfiles(displayProfiles.map((x) => (x.id === id ? { ...x, prefs: captureDisplayPrefs() } : x)))
            .then(() => toast.success(`Re-saved “${p.name}”`)).catch(() => toast.error("Could not save profile"));
    };
    const deleteDisplayProfile = (id) => { persistProfiles(displayProfiles.filter((p) => p.id !== id)).then(() => toast("Profile removed")).catch(() => {}); };
    const applyDisplayProfile = (id) => {
        const p = displayProfiles.find((x) => x.id === id); if (!p) return;
        const pr = p.prefs || {};
        let pagePrefs = null;
        try {
            if (pr.ls) {
                // Exact restore: clear every managed key, then write the snapshot back.
                const cur = []; for (let i = 0; i < localStorage.length; i++) { const k = localStorage.key(i); if (k && isProfileKey(k)) cur.push(k); }
                cur.forEach((k) => localStorage.removeItem(k));
                Object.entries(pr.ls).forEach(([k, v]) => { if (isProfileKey(k) && v != null) localStorage.setItem(k, v); });
                try { pagePrefs = JSON.parse(pr.ls.rosterly_page_prefs || "null"); } catch { pagePrefs = null; }
            } else {
                localStorage.setItem("rosterly_height_unit", pr.height_unit === "ft" ? "ft" : "cm");
                localStorage.setItem("rosterly_border_global", pr.border_mode || "basic");
                localStorage.setItem("rosterly_nav_color_style", pr.nav_color_style || "rosterly");
                localStorage.setItem("rosterly_nav_color_hex", pr.nav_color_hex || "#6a3597");
                localStorage.setItem("rosterly_nav_text_hex", pr.nav_text_hex || "#ffffff");
                localStorage.setItem("rosterly_nav_eye", pr.eye_mode === "closed" ? "closed" : "open");
                if (pr.main_team_id) localStorage.setItem("rosterly_surf_team", JSON.stringify(pr.main_team_id)); else localStorage.removeItem("rosterly_surf_team");
                if (pr.main_nhl_team_id) localStorage.setItem("rosterly_nhl_surf_team", JSON.stringify(pr.main_nhl_team_id)); else localStorage.removeItem("rosterly_nhl_surf_team");
            }
            sessionStorage.removeItem("rosterly_prefs_applied");
        } catch { /* noop */ }
        // Account-synced copies too, so the account hydration on reload doesn't undo the profile.
        const body = {
            fav_league: pr.fav_league || "", main_team_id: pr.main_team_id || "", main_nhl_team_id: pr.main_nhl_team_id || "",
            nav_eye_mode: pr.eye_mode === "closed" ? "closed" : "open", height_unit: pr.height_unit === "ft" ? "ft" : "cm",
        };
        if (pr.v === 2) {
            body.time_format = pr.time_format || "12h";
            body.navs_hidden = !!pr.navs_hidden;
            if (pr.monitor) body.monitor = pr.monitor;
            if (pagePrefs && typeof pagePrefs === "object") { const { page_toggle: _pt, ...synced } = pagePrefs; body.page_prefs = synced; }
        }
        updateAccount(body).finally(() => window.location.reload());
    };

    const onEyeClick = () => setEyeMenuOpen((v) => !v);
    const onEyeDown = () => { eyeLongPress.current = false; eyePressTimer.current = setTimeout(() => { eyeLongPress.current = true; setEyeMenuOpen(true); }, 450); };
    const onEyeUp = () => { if (eyePressTimer.current) { clearTimeout(eyePressTimer.current); eyePressTimer.current = null; } };
    // Close the Eye options bar when clicking outside the bar AND the Eye button (like Search).
    useEffect(() => {
        if (!eyeMenuOpen) return;
        const onDoc = (e) => {
            const inBar = eyeWrapRef.current && eyeWrapRef.current.contains(e.target);
            const inBtn = eyeBtnRef.current && eyeBtnRef.current.contains(e.target);
            if (!inBar && !inBtn) setEyeMenuOpen(false);
        };
        const onKey = (e) => { if (e.key === "Escape") setEyeMenuOpen(false); };
        document.addEventListener("mousedown", onDoc);
        document.addEventListener("keydown", onKey);
        return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
    }, [eyeMenuOpen]);
    // Resolve the "Teams" nav target — the viewer's EXPLICIT favourite/main team
    // (profile.main_team_id), else a starred team favourite, else Boston ('bos').
    // Opens that team's own leaderboards page (/teams/{id}?tab=leaderboards).
    const teamsNavTeamId = useMemo(() => {
        const main = navAccount?.profile?.main_team_id;
        if (main) return main;
        const f = (myFavourites || []).find((x) => x.target_type === "team");
        return f ? f.target_id : "bos";
    }, [navAccount, myFavourites]);
    // Only an EXPLICITLY chosen favourite/main team (not the 'bos' fallback)
    // drives the big league button's favourite-team landing.
    const favTeamIdExplicit = useMemo(() => {
        const main = navAccount?.profile?.main_team_id;
        if (main) return main;
        const f = (myFavourites || []).find((x) => x.target_type === "team");
        return f ? f.target_id : null;
    }, [navAccount, myFavourites]);
    const { data: navCfg } = useQuery({ queryKey: ["nav-config"], queryFn: getNavConfig, staleTime: 5 * 60 * 1000 });
    const topOrder = useMemo(() => navCfg?.top_order || [], [navCfg]);
    const searchMode = navCfg?.search_mode || "full";
    const persistLayout = (order, mode) => {
        qc.setQueryData(["nav-config"], (old) => ({ ...(old || {}), top_order: order, search_mode: mode }));
        saveNavLayout({ top_order: order, search_mode: mode }).catch(() => {});
    };
    const pwhlTabOrder = navCfg?.pwhl_tab_order || [];
    const persistPwhlOrder = (order) => {
        qc.setQueryData(["nav-config"], (old) => ({ ...(old || {}), pwhl_tab_order: order }));
        savePwhlTabOrder(order).catch(() => {});
    };
    // Live, owner-editable nav (falls back to the hard-coded defaults).
    const pwhlJump = user?.account?.pwhl_jump || null;
    const navLinks = useMemo(() => {
        const cfg = navCfg?.links;
        const teamsTo = `/teams/${teamsNavTeamId}?tab=overview`;
        const withJump = (l) => (l.label === "PWHL" && pwhlJump ? { ...l, to: pwhlJump } : l);
        if (!cfg) return NAV_LINKS.map((l) => withJump(l.isTeams ? { ...l, to: teamsTo } : l));
        return cfg.filter((l) => !l.hidden).map((l) => {
            const kids = (l.children || []).filter((c) => !c.hidden).map((c) => ({ label: c.label, to: c.to }));
            const base = { id: l.id || (l.label || "").toLowerCase(), label: l.label, to: l.isTeams ? `/teams/${teamsNavTeamId}?tab=overview` : l.to, iconOnly: l.iconOnly, isTeams: l.isTeams };
            return withJump(kids.length ? { ...base, children: kids } : base);
        });
    }, [navCfg, teamsNavTeamId, pwhlJump]);
    const navById = useMemo(() => Object.fromEntries(navLinks.map((l) => [(l.label || "").toLowerCase(), l])), [navLinks]);
    const favPages = useMemo(() => {
        const pf = (myFavourites || []).filter((f) => f.target_type === "page").map((f) => ({ to: f.target_id, label: pageLabelFor(f.target_id) }));
        if (pf.length) return pf.slice(0, 6);
        // Auto-set a sensible default set of favourite tabs when the user has none.
        return [
            { to: "/standings", label: "Standings" },
            { to: "/team-leaderboards", label: "Leaderboards" },
            { to: "/chemistry", label: "Chemistry" },
            { to: "/records", label: "Records" },
            { to: "/team-news", label: "News" },
            { to: "/team-videos", label: "Videos" },
        ];
    }, [myFavourites]);

    // Positional shortcut order MIRRORS Nav Bar 1: key 1 = Home (logo), then the
    // nav items in their (reorderable) order — PWHL, favourites, Roadmap, Socials.
    // Reordering Nav Bar 1 (Alt+1) automatically re-numbers the shortcuts.
    const navShortcutOrder = useMemo(() => {
        const items = [];
        const pwhlL = navById["pwhl"];
        if (pwhlL) items.push({ id: "pwhl", to: pwhlL.to, label: pwhlL.label });
        favPages.forEach((f, i) => items.push({ id: `fav-${i}`, to: f.to, label: f.label }));
        const roadmapL = navById["roadmap"];
        if (roadmapL) items.push({ id: "roadmap", to: roadmapL.to, label: roadmapL.label });
        items.push({ id: "socials", to: "/socials/news", label: "Socials" });
        if (topOrder.length) items.sort((a, b) => { const ia = topOrder.indexOf(a.id), ib = topOrder.indexOf(b.id); return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib); });
        return [{ id: "home", to: "/", label: "Home" }, ...items];
    }, [navById, favPages, topOrder]);

    // KEYBOARD model: NUMBER ROW 1-0 selects the Nth nav GROUP tile (1 = Rosterly
    // logo). NUMPAD 1-9 selects the Nth sub-tab within the CURRENT group. Alt+1
    // toggles nav edit (admin). Inputs are ignored.
    const currentGroupTabs = useMemo(() => {
        const path = location.pathname;
        const secs = selectedLeague === "nhl" ? NHL_SECTIONS : PWHL_SECTIONS;
        for (const sec of secs) {
            for (const tb of (sec.tabs || [])) {
                const base = (tb.to || "").split("?")[0];
                if (base && (path === base || path.startsWith(base + "/"))) return sec.tabs;
            }
        }
        return null;
    }, [location.pathname, selectedLeague]);
    const currentGroupTabsRef = useRef(null);
    currentGroupTabsRef.current = currentGroupTabs;
    useEffect(() => {
        const onKey = (e) => {
            const t = e.target;
            if (t && (/(INPUT|TEXTAREA|SELECT)/.test(t.tagName) || t.isContentEditable)) return;
            if (legacyPath().startsWith("/creator")) return;
            const nhl = selectedLeague === "nhl";
            // NUMPAD 1-9 → current group's Nth sub-tab.
            if (e.code && /^Numpad[1-9]$/.test(e.code) && !e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey) {
                const idx = parseInt(e.code.slice(6), 10) - 1;
                const tabs = currentGroupTabsRef.current;
                if (tabs && tabs[idx] && tabs[idx].to) { e.preventDefault(); navigate(tabs[idx].to); }
                return;
            }
            const k = e.key;
            // Alt+1 → toggle Nav Bar reorganisation (admin/owner only).
            if (e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey && k === "1") {
                if (isOwner || hasAdminAccess) { e.preventDefault(); toggleOwnerView(); }
                return;
            }
            if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return;
            // WASD / arrow keys → move left/right/up/down across the team switchboard (never while typing).
            const DIRS = { ArrowLeft: "l", a: "l", A: "l", ArrowRight: "r", d: "r", D: "r", ArrowUp: "u", w: "u", W: "u", ArrowDown: "dn", s: "dn", S: "dn" };
            if (DIRS[k] && !document.querySelector('[role="dialog"]')) {
                const box = [...document.querySelectorAll('[data-testid="team-surf-logos"], [data-testid="nhl-team-surf-logos"], [data-testid="intl-team-surf-logos"], [data-testid="ncaa-team-surf-logos"]')].find((el) => el.offsetParent);
                const btns = box ? [...box.querySelectorAll("button")].filter((b) => b.offsetParent && !b.disabled && !/^nhl-div-|^pwhl-div-|^ncaa-surf-conf-btn-/.test(b.dataset.testid || "")) : [];
                if (btns.length) {
                    e.preventDefault();
                    const rect = (b) => b.getBoundingClientRect();
                    const cur = btns.find((b) => b.dataset.kbdCursor === "1") || btns.find((b) => b.style.background) || null;
                    let next = btns[0];
                    if (cur) {
                        const c = rect(cur); const dir = DIRS[k];
                        const cands = btns.filter((b) => b !== cur).map((b) => ({ b, r: rect(b) })).filter(({ r }) => (dir === "r" ? r.left > c.left + 2 && Math.abs(r.top - c.top) < 6
                            : dir === "l" ? r.left < c.left - 2 && Math.abs(r.top - c.top) < 6
                                : dir === "dn" ? r.top > c.top + 2 : r.top < c.top - 2));
                        cands.sort((x, y) => (Math.abs(x.r.top - c.top) + Math.abs(x.r.left - c.left)) - (Math.abs(y.r.top - c.top) + Math.abs(y.r.left - c.left)));
                        next = cands[0]?.b || cur;
                    }
                    btns.forEach((b) => { delete b.dataset.kbdCursor; });
                    next.dataset.kbdCursor = "1";
                    if (next !== cur) next.click();
                    return;
                }
            }
            if (!/^[0-9]$/.test(k)) return;
            // NUMBER ROW digit → jump to the Nth nav GROUP tile (0 = 10th).
            const n = k === "0" ? 9 : (parseInt(k, 10) - 1);
            // Use the group tiles exactly as shown (arranged order + league-correct landing).
            const shown = [...document.querySelectorAll('[data-testid^="pwhl-group-"]')].filter((el) => el.offsetParent && /^pwhl-group-(?!title-|search)/.test(el.dataset.testid || "") && !el.parentElement.closest('[data-testid^="pwhl-group-"]'));
            if (shown.length) { const link = shown[n]?.querySelector("a[href]"); if (link) { e.preventDefault(); link.click(); } return; }
            const groups = (nhl ? NHL_SECTIONS : PWHL_SECTIONS).filter((s) => (s.tabs || []).length);
            const g = groups[n];
            if (!g) return;
            let favTo = null;
            try { favTo = JSON.parse(localStorage.getItem("rosterly_group_fav") || "{}")[`${selectedLeague}:${g.key}`]; } catch { /* noop */ }
            const first = (g.tabs || [])[0];
            const dest = g.isLogo ? (nhl ? "/nhl/schedule" : selectedLeague === "international" ? "/nat/schedule" : selectedLeague === "ncaa" ? "/ncaa/schedule" : "/schedule") : (favTo || g.to || (first && first.to));
            if (dest) { e.preventDefault(); navigate(dest); }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [navigate, hasAdminAccess, isOwner, toggleOwnerView, selectedLeague]);

    // Per-page Star/Help button (all users). Star favourites the current page (feeds
    // Nav Bar 1 slots 3-8); Help is a per-page placeholder we'll build out page by page.
    const [helpOpen, setHelpOpen] = useState(false);
    const curTabParam = new URLSearchParams(location.search).get("tab");
    const currentPageTo = location.pathname === "/teams"
        ? `/teams?tab=${curTabParam || "standings"}`
        : (location.pathname === "/" ? null : location.pathname);
    const pageStarred = currentPageTo ? !!getTier("page", currentPageTo) : false;
    const pageFavCount = (myFavourites || []).filter((f) => f.target_type === "page").length;
    const toggleStar = () => {
        if (!isAuthed) { navigate("/login"); return; }
        if (!currentPageTo) return;
        if (pageStarred) { clearTier("page", currentPageTo); return; }
        if (pageFavCount >= 6) { toast.error("You can star up to 6 pages. Unstar one first."); return; }
        setTier("page", currentPageTo, "gold");
        toast.success(`Starred ${pageLabelFor(currentPageTo)} — added to your nav bar`);
    };
    // Keep a live ref for the global keydown handler (F + number keybinds).
    const forcedBinds = settings?.forced_keybinds || DEFAULT_KEYBINDS;
    // Owner-set (forced) shortcuts can only be changed/removed when the owner has
    // their owner-view toggle ON. Otherwise they behave as locked, even for the owner.
    const ownerEditMode = isOwner && adminMode;
    navStateRef.current = { currentPageTo, keybinds, forced: forcedBinds };
    const openStarMap = () => { setStarMapOpen(true); };
    const assignKeybind = (num) => {
        const key = String(num);
        const isForced = forcedBinds[key] !== undefined;
        if (isForced && !ownerEditMode) { toast("This key is locked by the owner."); return; }
        if (ownerEditMode) {
            // Owner sets a forced preset applied to everyone.
            const nf = { ...forcedBinds }; delete nf[key];
            Object.keys(nf).forEach((kk) => { if (nf[kk] === currentPageTo) delete nf[kk]; });
            nf[key] = currentPageTo;
            saveForcedKeybinds(nf).then((d) => qc.setQueryData(["settings"], (o) => o ? { ...o, forced_keybinds: d.forced_keybinds } : o)).catch(() => {});
            setStarMapOpen(false);
            toast.success(`Locked ${pageLabelFor(currentPageTo)} to key ${num} for everyone`);
            return;
        }
        const next = { ...keybinds };
        Object.keys(next).forEach((kk) => { if (next[kk] === currentPageTo) delete next[kk]; });
        next[key] = currentPageTo;
        setKeybinds(next);
        try { localStorage.setItem("rosterly_tab_keybinds", JSON.stringify(next)); } catch (e) { /* noop */ }
        if (isAuthed && !pageStarred && pageFavCount < 6) setTier("page", currentPageTo, "gold");
        setStarMapOpen(false);
        toast.success(`Pinned ${pageLabelFor(currentPageTo)} to key ${num}`);
    };
    const unforceKeybind = (num) => {
        const nf = { ...forcedBinds }; delete nf[String(num)];
        saveForcedKeybinds(nf).then((d) => qc.setQueryData(["settings"], (o) => o ? { ...o, forced_keybinds: d.forced_keybinds } : o)).catch(() => {});
    };
    const clearKeybind = (num) => {
        const next = { ...keybinds }; delete next[String(num)];
        setKeybinds(next);
        try { localStorage.setItem("rosterly_tab_keybinds", JSON.stringify(next)); } catch (e) { /* noop */ }
    };
    // Bind a number key directly to an explicit path (used by the "# + click a tab" gesture).
    const bindKeyToPath = (num, path, label) => {
        const key = String(num);
        if (forcedBinds[key] !== undefined && !ownerEditMode) { toast("This key is locked by the owner."); return; }
        const next = { ...keybinds };
        Object.keys(next).forEach((kk) => { if (next[kk] === path) delete next[kk]; });
        next[key] = path;
        setKeybinds(next);
        try { localStorage.setItem("rosterly_tab_keybinds", JSON.stringify(next)); } catch (e) { /* noop */ }
        toast.success(`Key ${num} → ${label || path}`);
    };
    navStateRef.current.bindKeyToPath = bindKeyToPath;
    const roleMeta = isOwner ? { color: "#F6C453", Icon: Crown, label: "Owner" }
        : canCreate ? { color: "#EC4899", Icon: Palette, label: "Creator" }
        : hasAdminAccess ? { color: "#9D4CDD", Icon: Shield, label: "Admin" }
        : canBusiness ? { color: "#22C55E", Icon: Briefcase, label: "Business" }
        : { color: "#94A3B8", Icon: User, label: "Account" };
    // Access areas the account can reach — each becomes a coloured trigger with a
    // dropdown of its pages inside the AccessNavBar (revealed on My Account hover).
    // Access areas moved to nav bar 1 (Admin/Business/Creator/Owner section
    // titles). The My Account dropdown no longer lists them.
    const accessAreas = useMemo(() => [], []);
    // Measure the real header + subnav heights and expose them as CSS vars so every
    // sticky layer (subnavs, team-sort bar) hugs the nav exactly — no phantom gaps.
    useEffect(() => {
        let raf;
        const recompute = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                const h = headerRef.current?.offsetHeight;
                const tabsH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--app-tabs-h")) || 0;
                if (h) document.documentElement.style.setProperty("--hdr-h", `${Math.round(h + tabsH)}px`);
                const s = subnavRef.current?.offsetHeight;
                document.documentElement.style.setProperty("--sub-h", s ? `${Math.round(s)}px` : "0px");
                const tb = teamBarRef.current?.offsetHeight;
                document.documentElement.style.setProperty("--teambar-h", tb ? `${Math.round(tb)}px` : "0px");
            });
        };
        recompute();
        const ro = new ResizeObserver(recompute);
        if (headerRef.current) ro.observe(headerRef.current);
        if (subnavRef.current) ro.observe(subnavRef.current);
        if (teamBarRef.current) ro.observe(teamBarRef.current);
        window.addEventListener("resize", recompute);
        return () => { ro.disconnect(); window.removeEventListener("resize", recompute); cancelAnimationFrame(raf); };
    }, [selectedLeague, user, hasAdminAccess, canBusiness, canCreate, isOwner, searchActive, currentPageTo, settings?.logo_mode, navAccount, hoverNav, teamMatch, location.pathname, location.search]);
    // Collapse nav labels to icons-only when the row would overflow the viewport,
    // so elements never overlap on smaller screens (labels still show on hover via title).
    useEffect(() => {
        const row = navRowRef.current;
        if (!row) return;
        const parent = row.parentElement;
        let raf;
        const recompute = () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
                row.classList.remove("nav-compact");
                if (row.scrollWidth > row.clientWidth + 1) row.classList.add("nav-compact");
            });
        };
        recompute();
        const ro = new ResizeObserver(recompute);
        if (parent) ro.observe(parent);
        window.addEventListener("resize", recompute);
        return () => { ro.disconnect(); window.removeEventListener("resize", recompute); cancelAnimationFrame(raf); };
    }, [selectedLeague, user, hasAdminAccess, canBusiness, canCreate, isOwner, searchActive, currentPageTo, settings?.logo_mode, navAccount, adminMode, businessMode, location.pathname]);



    const teamSubtabs = useMemo(() => {
        const t = navCfg?.team_subtabs;
        let list = (!t) ? TEAM_SUBTABS : t.filter((x) => !x.hidden).map((x) => ({ k: x.k, l: x.l }));
        if (!list.some((x) => x.k === "overview")) list = [{ k: "overview", l: "Overview" }, ...list];
        return list;
    }, [navCfg]);
    const orderedNavTeams = orderTeams(navTeams);
    const defaultTeamId = navAccount?.profile?.main_team_id || "bos";
    const teamTarget = curTeamId || defaultTeamId;

    const childMatch = (l) => (l.children || []).some((c) => {
        if (!c.to) return false;
        const base = c.to.split("?")[0];
        if (location.pathname === base) return true;
        const tk = PATH_TABS[base];
        return tk && TEAM_SCOPED.has(tk) && location.pathname.startsWith(base + "/");
    });
    const isSectionActive = (l) => !teamMatch && l.children && (location.pathname === l.to || location.pathname.startsWith(l.to) || childMatch(l));
    // Media & Socials are flattened into individual top-nav buttons, so their old
    // parent subnav (e.g. the NEWS | VIDEOS bar) must NOT appear on child routes.
    const activeSection = navLinks.find((l) => l.label !== "Media" && l.label !== "Socials" && isSectionActive(l));
    // Persistent "mode" nav layer(s) removed — Business / Admin now use their own
    // header toggle buttons, so we no longer render a secondary mode nav bar.
    const modeNavs = [];

    const onAccessRoute = /^\/(account|admin|business|creator|owner)(\/|$|\?|#)/.test(location.pathname) || ["/account", "/admin", "/business", "/creator", "/owner"].includes(location.pathname);
    let subnavLink;
    if (hoverNav === "Account") subnavLink = null;
    else if (hoverNav === "Admin") subnavLink = ADMIN_NAV;
    else if (hoverNav === "Business") subnavLink = BUSINESS_NAV;
    else if (hoverNav === "Owner") subnavLink = OWNER_NAV;
    else if (hoverNav === "Control") subnavLink = CONTROL_NAV;
    else if (hoverNav === "Socials") subnavLink = SOCIALS_NAV;
    else if (hoverNav) subnavLink = navLinks.find((l) => l.label === hoverNav);
    else if (onAccessRoute) subnavLink = null;   // PwhlSectionsBar renders the inline access tabs — no duplicate bar
    else if (location.pathname.startsWith("/admin") && !(adminMode && hasAdminAccess)) subnavLink = ADMIN_NAV;
    else if (location.pathname.startsWith("/owner")) subnavLink = OWNER_NAV;
    else if (location.pathname.startsWith("/switchboard")) subnavLink = CONTROL_NAV;
    else if (location.pathname.startsWith("/socials") || location.pathname === "/contact") subnavLink = SOCIALS_NAV;
    else if (location.pathname.startsWith("/business") && !businessMode) subnavLink = BUSINESS_NAV;
    else if (teamMatch) subnavLink = null;
    else if (PWHL_OWNED_PATHS.has(location.pathname)) subnavLink = navLinks.find((l) => l.label === "PWHL");
    else subnavLink = activeSection;
    // Don't double-render a mode nav as a hover/route row — the persistent layer covers it.
    if ((subnavLink === ADMIN_NAV && adminMode && hasAdminAccess) || (subnavLink === BUSINESS_NAV && businessMode)) subnavLink = null;
    // The two-row Teams subnav (subtabs + team logo strip) shows when hovering the
    // Teams nav item, or when an individual team page is open (and nothing else hovered).
    const showTeamsSubnav = hoverNav === "Teams" || (!!teamMatch && !hoverNav);
    const genericSubnavShown = !!(subnavLink && subnavLink.children && subnavLink.label !== "PWHL" && subnavLink.label !== "Insights");
    const accessSubnavShown = (hoverNav === "Account" || (onAccessRoute && !hoverNav)) && accessAreas.length > 0;
    const anySubnavShown = modeNavs.length > 0 || genericSubnavShown || accessSubnavShown || showTeamsSubnav;
    const teamBarStickyTop = anySubnavShown
        ? "top-[calc(var(--hdr-h,104px)+var(--sub-h,0px))]"
        : "top-[var(--hdr-h,104px)]";

    // ----- Time-on-page analytics: report the time spent on the previous path
    // whenever the route changes (and on unload). Powers My Account + admin. -----
    // Count the view on arrival; add the visible (tab-in-focus) time when leaving or hiding the tab.
    const pagePath = location.pathname + (new URLSearchParams(location.search).get("tab") ? `?tab=${new URLSearchParams(location.search).get("tab")}` : "");
    const pageRef = useRef({ path: null, t: Date.now(), acc: 0 });
    const flushPage = (countView = false) => {
        const p = pageRef.current;
        if (!p.path) return;
        const secs = p.acc + (document.hidden ? 0 : (Date.now() - p.t) / 1000);
        if (secs > 0.5 || countView) trackPageView(p.path, secs, countView);
        p.acc = 0; p.t = Date.now();
    };
    useEffect(() => {
        flushPage();
        pageRef.current = { path: pagePath, t: Date.now(), acc: 0 };
        trackPageView(pagePath, 0, true);
    }, [pagePath]); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        const onVis = () => { if (document.hidden) flushPage(); else pageRef.current.t = Date.now(); };
        document.addEventListener("visibilitychange", onVis);
        return () => document.removeEventListener("visibilitychange", onVis);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Scroll to top of the page on any navigation (tab/route change) so users
    // aren't left stranded halfway down the previous page.
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname, location.search]);
    useEffect(() => {
        const onHide = () => flushPage();
        window.addEventListener("beforeunload", onHide);
        return () => window.removeEventListener("beforeunload", onHide);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const onKey = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
                e.preventDefault();
                document.querySelector('[data-testid="global-search-input"]')?.focus();
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    // "T" shortcut → open the guided-tour prompt for the current page (when it
    // has a tour). Ignored while typing in an input / with modifiers held.
    useEffect(() => {
        const onKey = (e) => {
            if (e.metaKey || e.ctrlKey || e.altKey) return;
            const el = document.activeElement;
            const tag = (el?.tagName || "").toLowerCase();
            if (tag === "input" || tag === "textarea" || el?.isContentEditable) return;
            if (e.key === "t" || e.key === "T") {
                if (tour?.hasTour) { e.preventDefault(); tour.openPrompt(); }
                else toast("A guided tour for this page is coming soon.");
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [tour?.openPrompt, tour?.hasTour]);

    const socialsChildren = useMemo(() => {
        const links = (settings?.social_links || []).filter((l) => l && l.url);
        const byPlat = (p) => links.filter((l) => (l.platform || "instagram") === p);
        const out = [{ label: "News", Icon: Newspaper, color: "#94A3B8", disabled: true, key: "news" }];
        const addPlat = (plat, label, Icon, color) => {
            const ls = byPlat(plat);
            if (ls.length) ls.forEach((l, i) => out.push({ label: ls.length > 1 ? (l.name || l.handle || label) : label, href: l.url, Icon, color, key: `${plat}-${i}` }));
            else out.push({ label, Icon, color, disabled: true, key: plat });
        };
        addPlat("instagram", "Instagram", Instagram, "#E1306C");
        addPlat("youtube", "YouTube", Youtube, "#FF0000");
        addPlat("x", "X", XIcon, "#E7E9EA");
        addPlat("discord", "Discord", DiscordIcon, "#5865F2");
        addPlat("tiktok", "TikTok", TikTokIcon, "#25F4EE");
        out.push({ label: "Contact Us", to: "/contact", Icon: Mail, color: "#9D4CDD", key: "contact" });
        out.push({ label: "Chat", to: "/socials", Icon: MessageSquare, color: "#5BD1B7", key: "chat" });
        return out;
    }, [settings]);
    useEffect(() => {
        const s = Number(settings?.logo_global_scale);
        document.documentElement.style.setProperty("--logo-scale", String(Number.isFinite(s) && s > 0 ? s / 100 : 1));
    }, [settings?.logo_global_scale]);
    // Remember the owner's logo so it shows instantly next load (no flash to the default).
    useEffect(() => {
        if (!settings) return;
        try {
            if (settings.site_logo_url) localStorage.setItem("rosterly_site_logo", settings.site_logo_url);
            else localStorage.removeItem("rosterly_site_logo");
        } catch {}
    }, [settings]);
    const _cachedLogo = (() => { try { return localStorage.getItem("rosterly_site_logo"); } catch { return null; } })();
    const theme = useTheme();
    const logoUrl = siteLogoUrl(settings, _cachedLogo ? assetUrl(_cachedLogo) : "/rosterly-logo.png?v=4");
    const siteName = settings?.site_name || "Rosterly";
    const siteTagline = settings?.site_tagline ?? "Women's Hockey";
    const logoX = settings?.logo_x ?? 50;
    const logoY = settings?.logo_y ?? 50;
    const logoZoom = settings?.logo_zoom ?? 1;
    const logoW = settings?.logo_w ?? 96;
    const logoH = settings?.logo_h ?? 96;
    const betaOn = settings?.beta_mode !== false;
    const betaMsg = (settings?.beta_message || "").trim() ||
        "Rosterly is currently in Beta. This Beta covers the 2026–27 PWHL season.";

    // Owner-only Display (Eye) tile — a big tile like the group tiles (no more
    // circles). Search is now its own public tile inside the sections bar, and
    // the page Tour lives INSIDE the Eye popover. Both Eye + Tour are OWNER-ONLY.
    const [wideGlobal, setWideSubNavRaw] = useState(() => { try { return localStorage.getItem("rosterly_wide_subnav") === "1"; } catch { return false; } });
    const wideSubNav = "wide" in pageLock ? !!pageLock.wide : wideGlobal;
    const setWideSubNav = (v, lock = false) => {
        if (lock) { setPageLock("wide", v); toast(`This page locked to ${v ? "Wide" : "Narrow"} nav`); return; }
        setWideSubNavRaw(v); try { localStorage.setItem("rosterly_wide_subnav", v ? "1" : "0"); } catch { /* noop */ }
        if ("wide" in pageLock) { setPageLock("wide", undefined); toast("Page nav lock removed"); }
    };
    const sBtn = "h-7 min-w-[28px] px-2 rounded-md border border-white/10 text-white/80 hover:bg-white/10 text-[10px] font-bold uppercase flex items-center justify-center gap-1";
    const onSty = (on) => (on ? { background: "#2DD4BF26", borderColor: "#2DD4BF59", color: "#fff" } : undefined);
    const displayBtns = [
        { key: "acc_theme", render: () => (
            <button type="button" data-testid="access-disp-theme" data-keep-colors={theme === "light" ? "" : undefined} title={theme === "light" ? "Light mode ON — switch to dark" : "Dark mode — switch to light"} onClick={() => setTheme(theme === "light" ? "dark" : "light")} className={AZ_BTN} style={azPill(theme === "light", "#FDE047")}>
                {theme === "light" ? <Sun className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <Moon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">{theme === "light" ? "Light" : "Dark"}</span>
            </button>) },
        { key: "disp_wide", render: () => (
            <button type="button" data-testid="access-disp-wide" title={`${wideSubNav ? "Wide nav bar ON — page toggle bar spans the full width" : "Wide nav bar — stretch the page toggle bar to the full width"} · Shift+click = lock this page${"wide" in pageLock ? " (locked)" : ""}`} onClick={(e) => setWideSubNav(!wideSubNav, e.shiftKey)} className={AZ_BTN} style={azPill(wideSubNav, "#FACC15")}>
                {wideSubNav ? <MoveHorizontal className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <RectangleHorizontal className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">Wide Nav</span>
            </button>) },
        { key: "disp_full", render: () => (
            <button type="button" data-testid="access-disp-full" title="Full Screen" onClick={() => (document.fullscreenElement ? exitFullscreen() : enterFullscreen())} className={AZ_BTN} style={azPill(!!document.fullscreenElement, "#F87171")}>
                {document.fullscreenElement ? <Minimize2 className="h-3.5 w-3.5 shrink-0" strokeWidth={2} /> : <Maximize2 className="h-3.5 w-3.5 shrink-0" strokeWidth={2} />}<span className="leading-none">Full Screen</span>
            </button>) },
        { key: "disp_page", render: () => (
            <DispPop k="disp-page" label={`Page ${Math.round(uiScale * 100)}%`} Icon={uiScale < 1 ? ZoomOut : ZoomIn} active={uiScale !== 1} color="#A78BFA">
                <button type="button" data-testid="eye-scale-down" onClick={() => bumpScale(-0.1)} className={sBtn}>−</button>
                <span className="text-[11px] font-mono-stat text-white/80 w-10 text-center">{Math.round(uiScale * 100)}%</span>
                <button type="button" data-testid="eye-scale-up" onClick={() => bumpScale(0.1)} className={sBtn}>+</button>
            </DispPop>) },
        { key: "disp_nav", render: () => (
            <DispPop k="disp-nav" label={`Nav ${Math.round((navUiScale ?? uiScale) * 100)}%`} Icon={PanelTop} color="#FB923C">
                <button type="button" data-testid="nav-scale-down" onClick={() => bumpNavScale(-0.1)} className={sBtn}>−</button>
                <button type="button" data-testid="nav-scale-reset" onClick={() => setNavUiScale(null)} title="Follow page size" className="text-[11px] font-mono-stat text-white/80 w-10 text-center hover:text-white">{Math.round((navUiScale ?? uiScale) * 100)}%</button>
                <button type="button" data-testid="nav-scale-up" onClick={() => bumpNavScale(0.1)} className={sBtn}>+</button>
            </DispPop>) },
        { key: "disp_profiles", render: () => (
            <DispPop k="disp-profiles" label="Profiles" Icon={Bookmark} color="#E879F9">
                {displayProfiles.map((p) => (
                    <span key={p.id} className="inline-flex items-center h-7 rounded-md border border-white/10 bg-white/5 overflow-hidden" data-testid={`eye-profile-${p.id}`}>
                        <button type="button" data-testid={`eye-profile-load-${p.id}`} onClick={() => applyDisplayProfile(p.id)} title={`Load ${p.name}`} className="pl-2 pr-1.5 h-full text-[10px] font-bold uppercase text-white/80 hover:text-white hover:bg-[#2DD4BF]/15 max-w-[120px] truncate">{p.name}</button>
                        <button type="button" data-testid={`eye-profile-resave-${p.id}`} onClick={() => resaveDisplayProfile(p.id)} title={`Re-save ${p.name}`} className="px-1 h-full text-white/40 hover:text-[#2DD4BF] border-l border-white/10"><RotateCw className="h-3 w-3" /></button>
                        <button type="button" data-testid={`eye-profile-del-${p.id}`} onClick={() => deleteDisplayProfile(p.id)} title="Delete profile" className="px-1 h-full text-white/40 hover:text-[#F87171] border-l border-white/10"><X className="h-3 w-3" /></button>
                    </span>
                ))}
                <button type="button" data-testid="eye-profile-save" onClick={saveDisplayProfile} title="Save current display settings as a profile" className={`${sBtn} border-[#2DD4BF]/40 text-[#2DD4BF]`}><Plus className="h-3 w-3" />Save</button>
            </DispPop>) },
    ];

    return (
        <MobileNavProvider>
        <SortByTeamProvider>
        <GameNavProvider>
        <PrefsDefaulter />
        <SharedTeamApplier />
        <StudioPopupHost />
        <div className="min-h-screen flex flex-col bg-[#0A0B10] text-white">
            <ImpersonationBanner user={user} />
            <RoadmapAlerts />
            <RoadmapPageOverlay />
            <header ref={headerRef} className="hidden lg:block backdrop-blur-xl bg-[#0A0B10]/85 border-b border-[#1E2233] sticky top-0 z-50" style={{ top: "var(--app-tabs-h, 0px)", ...(navZoom !== 1 ? { zoom: navZoom } : {}) }} data-testid="desktop-header">
                <div className="w-full px-4 md:px-8 lg:px-12 overflow-x-clip overflow-y-visible">
                    <div ref={navRowRef} className="flex items-center gap-3 min-h-[96px] py-2 flex-nowrap">
                        <div
                            className="flex-1 flex items-center justify-start group min-w-0 self-center cursor-default select-none"
                            data-testid="brand-link"
                        >
                            {settings?.logo_mode === "wordmark" ? (
                                <div className="font-heading text-5xl md:text-6xl font-black uppercase tracking-tight text-white leading-none group-hover:opacity-90 transition-opacity" data-testid="brand-wordmark">
                                    {siteName}
                                </div>
                            ) : settings?.logo_mode === "brand_logo" ? (
                                <img
                                    src={ROSTERLY_BRAND_LOGO}
                                    alt={siteName}
                                    className="h-14 md:h-16 w-auto object-contain group-hover:opacity-90 transition-opacity shrink-0"
                                    data-testid="brand-logo-image"
                                />
                            ) : (
                                <span className="rounded-lg overflow-hidden inline-flex items-center justify-center shrink-0" style={{ width: `${logoW}px`, height: `${logoH}px` }}>
                                    <img
                                        src={logoUrl}
                                        alt={siteName}
                                        className="w-full h-full object-contain group-hover:opacity-90 transition-opacity"
                                        style={{ objectPosition: `${logoX}% ${logoY}%`, transform: `scale(${logoZoom})` }}
                                        data-testid="brand-logo"
                                    />
                                </span>
                            )}
                            {betaOn && (
                                <span className="ml-1.5 inline-flex items-center px-1.5 py-0.5 rounded-md bg-[#9D4CDD]/20 border border-[#9D4CDD]/40 text-[#C4A5F4] text-[9px] font-black uppercase tracking-[0.15em]" data-testid="brand-beta-badge">
                                    Beta
                                </span>
                            )}
                        </div>

                        <div className="hidden lg:flex shrink-0 items-center justify-center gap-3" data-testid="nav-spread">

                        <div
                            style={{ display: "contents" }}
                            onMouseLeave={scheduleClearHover}
                            data-testid="desktop-nav"
                        >
                            {/* Main sections bar stays on ALL routes (incl. Admin/Business/Creator/Owner/Account); the Access bar renders below it. */}
                            <PwhlSectionsBar league={selectedLeague} isOwner={isOwner} access={{ admin: hasAdminAccess, business: canBusiness, creator: canCreate, owner: isOwner }} favTeamId={favTeamIdExplicit} onChangeLeague={() => setLeaguePickerOpen(true)} onPickLeague={(id) => { setSelectedLeague(id); navigate(["nhl", "pwhl", "international", "ncaa"].includes(id) ? leagueEquivalentRoute(id, legacyPath(), window.location.search) : pwhlLandingRoute()); }} colorStyle="rosterly" eyeMode={eyeMode} leagueBarOpen={leagueBarOpen} onToggleLeagueBar={() => setLeagueBarOpen((v) => !v)} viewModes={viewModes} onToggleView={onToggleView} navsHidden={navsHidden} onToggleNavsHidden={toggleNavsHidden} borderMode={borderMode} onToggleBorders={(lock) => setBorders(borderMode === "extended" ? "basic" : "extended", lock)} displayBtns={displayBtns} />
                            {false && (() => {
                                const socialLinks = (settings?.social_links || []).filter((l) => l && l.url);
                                const byPlat = (p) => socialLinks.filter((l) => (l.platform || "instagram") === p);
                                // Nav Bar 1: [logo=Home] · PWHL · favourites (3-8) · Roadmap · Socials.
                                const items = [];
                                const pwhlL = navById["pwhl"];
                                if (pwhlL) items.push({ id: "pwhl", label: pwhlL.label, Icon: NAV_ICONS[pwhlL.label] || Globe, to: pwhlL.to, children: pwhlL.children, hoverKey: pwhlL.label });
                                favPages.forEach((f, i) => items.push({ id: `fav-${i}`, label: f.label, Icon: NAV_ICONS[f.label] || iconForTo(f.to), to: f.to }));
                                const roadmapL = navById["roadmap"];
                                if (roadmapL) items.push({ id: "roadmap", label: roadmapL.label, Icon: NAV_ICONS[roadmapL.label] || Globe, to: roadmapL.to, children: roadmapL.children, hoverKey: roadmapL.label });
                                items.push(
                                    { id: "socials", label: "Socials", Icon: Share2, to: "/socials/news", children: SOCIALS_NAV.children, hoverKey: "Socials" },
                                );
                                if (topOrder.length) {
                                    items.sort((a, b) => {
                                        const ia = topOrder.indexOf(a.id), ib = topOrder.indexOf(b.id);
                                        return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
                                    });
                                }
                                const orderedIds = items.map((i) => i.id);
                                const canReorder = navResort && hasAdminAccess;
                                const dropOn = (targetId) => {
                                    const src = dragId.current; dragId.current = null;
                                    if (!src || src === targetId) return;
                                    const arr = [...orderedIds];
                                    const from = arr.indexOf(src), to = arr.indexOf(targetId);
                                    if (from < 0 || to < 0) return;
                                    arr.splice(to, 0, arr.splice(from, 1)[0]);
                                    persistLayout(arr, searchMode);
                                };
                                return items.map((it) => {
                                    const dcls = (extra) => `group relative flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-colors ${extra} ${canReorder ? "cursor-move ring-1 ring-[#9D4CDD]/30" : ""}`;
                                    const dragProps = canReorder ? {
                                        draggable: true,
                                        onDragStart: () => { dragId.current = it.id; },
                                        onDragOver: (e) => e.preventDefault(),
                                        onDrop: (e) => { e.preventDefault(); dropOn(it.id); },
                                    } : {};

                                    // Social platform button — Connect-driven main link + optional hover dropdown.
                                    if (it.plat) {
                                        const pl = byPlat(it.plat);
                                        const main = pl[0]?.url || null;
                                        const label = (
                                            <>
                                                <it.Icon className="h-4 w-4" strokeWidth={2} />
                                                <span className="text-[8px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">{it.label}</span>
                                            </>
                                        );
                                        return (
                                            <div key={it.id} className="group relative flex" data-testid={`nav-${it.id}`} {...dragProps}>
                                                {main ? (
                                                    <a href={main} target={main.startsWith("mailto:") ? undefined : "_blank"} rel="noreferrer"
                                                        className={dcls("text-[#94A3B8] hover:text-white")} title={it.label} aria-label={it.label}
                                                        onClick={canReorder ? (e) => e.preventDefault() : undefined}>{label}</a>
                                                ) : (
                                                    <span className={dcls("text-white/25 cursor-default")} title={`${it.label} — no link set`} aria-label={it.label}>{label}</span>
                                                )}
                                                {pl.length > 1 && !canReorder && (
                                                    <div className="absolute left-1/2 -translate-x-1/2 top-full pt-1 hidden group-hover:block z-[60]" data-testid={`nav-${it.id}-dropdown`}>
                                                        <div className="min-w-[170px] rounded-lg border border-white/10 bg-[#0E0F16] shadow-xl py-1">
                                                            {pl.map((l, i) => (
                                                                <a key={i} href={l.url} target={l.url.startsWith("mailto:") ? undefined : "_blank"} rel="noreferrer"
                                                                    data-testid={`nav-${it.id}-link-${i}`}
                                                                    className="flex items-center gap-2 px-3 py-1.5 text-xs text-white/80 hover:bg-white/5 hover:text-white">
                                                                    <it.Icon className="h-3.5 w-3.5 shrink-0" style={{ color: l.color || "#9D4CDD" }} />
                                                                    <span className="truncate">{l.name || l.handle || l.url}</span>
                                                                    {i === 0 && <span className="ml-auto text-[8px] uppercase tracking-wider text-[#9D4CDD] font-black">Main</span>}
                                                                </a>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }

                                    // Structural / route items.
                                    const base = (it.to || "").split("?")[0];
                                    const active = it.isTeams
                                        ? (!!teamMatch || hoverNav === "Teams")
                                        : it.children
                                        ? (isSectionActive({ label: it.label, to: base, children: it.children }) || hoverNav === it.hoverKey)
                                        : (base && (location.pathname === base || (base !== "/" && location.pathname.startsWith(base))));
                                    const inner = (
                                        <>
                                            <it.Icon className="h-4 w-4" strokeWidth={2} />
                                            <span className="text-[8px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">{it.label}</span>
                                            <span className={`absolute -bottom-0.5 h-0.5 w-5 rounded-full bg-[#9D4CDD] transition-opacity ${active ? "opacity-100" : "opacity-0"}`} />
                                        </>
                                    );
                                    const isFav = it.id.startsWith("fav-");
                                    return (
                                        <Link key={it.id} to={it.to || "/"} onMouseEnter={() => setHover((it.children && it.children.length) || it.isTeams ? it.hoverKey : null)}
                                            data-testid={`nav-${it.id}`} title={it.label} className={dcls(`${active ? "text-white" : "text-[#94A3B8] hover:text-white"} ${isFav ? "bg-[#9D4CDD]/[0.08]" : ""}`)}
                                            {...(canReorder ? { ...dragProps, onClick: (e) => e.preventDefault() } : {})}>
                                            {inner}
                                        </Link>
                                    );
                                });
                            })()}
                        </div>

                        </div>

                        {/* RIGHT ZONE: My Account only (Search/Eye/Tour circles now live next to Roadmap) */}
                        <div className="hidden lg:flex flex-1 items-center justify-end gap-2.5 min-w-0" data-testid="nav-right-tools">
                            {/* Far side of the bar — visible signed in or out. Installed app: Back / Refresh / Forward live in the tabs bar. */}
                            {(window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: window-controls-overlay)").matches || window.navigator.standalone === true) ? null : (
                                <button type="button" onClick={() => addBrowserApp(toast)} data-testid="nav-add-browser-app"
                                    className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-white/15 bg-black/25 text-[10px] font-black uppercase tracking-wider text-white/70 hover:text-white hover:border-white/30 transition-colors">
                                    <MonitorDown className="h-3.5 w-3.5" /> Add Browser App
                                </button>
                            )}
                        </div>


                        <div className="lg:hidden flex items-center gap-1.5">
                            {settings?.instagram_url && (
                                <a
                                    href={settings.instagram_url}
                                    target="_blank"
                                    rel="noreferrer"
                                    aria-label="Rosterly on Instagram"
                                    data-testid="mobile-nav-instagram"
                                    className="inline-flex items-center justify-center h-8 w-8 rounded-md text-[#94A3B8] hover:text-white"
                                >
                                    <Instagram className="h-4 w-4" />
                                </a>
                            )}
                            <MobileHeaderActions />
                            {user ? (
                                <>
                                    <button type="button" onClick={openAccountModal} className="p-1.5 rounded-md bg-[#1E2233] text-white" data-testid="mobile-top-account" aria-label="My account">
                                        <User className="h-4 w-4" />
                                    </button>
                                </>
                            ) : (
                                <Link to="/login" className="inline-flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white bg-[#9D4CDD] rounded-md" data-testid="mobile-top-signin">
                                    <LogIn className="h-3.5 w-3.5" /> Sign in
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </header>

            {/* NAV BAR 2 — the "Change League" cascade renders full-width directly
                under the main nav; while open, all other sub-navs are hidden. */}
            {!navsHidden && !searchActive && leagueBarOpen && (
                <div className="hidden lg:block sticky top-[var(--hdr-h,104px)] z-40 bg-[#0A0B10]/95 backdrop-blur-xl border-b border-[#1E2233]" data-testid="league-cascade-bar">
                    <div className="w-full px-4 md:px-8 lg:px-12 py-2.5">
                        <FindCascade onNavigate={() => setLeagueBarOpen(false)} onSelectLeague={setSelectedLeague} isOwner={isOwner} isAdmin={hasAdminAccess} />
                    </div>
                </div>
            )}
            {leaguePickerOpen && (
                <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4" data-testid="league-picker-modal" onClick={() => setLeaguePickerOpen(false)}>
                    <div className="w-full max-w-md rounded-2xl border border-[#1E2233] bg-[#0E0F16] shadow-2xl p-6" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center gap-2.5 mb-1">
                            <ArrowLeftRight className="h-5 w-5 text-[#9D4CDD]" />
                            <h3 className="text-lg font-black uppercase tracking-wide text-white">Change League</h3>
                        </div>
                        <p className="text-sm text-[#94A3B8] mb-5">Pick the league you want to browse.</p>
                        {[
                            { group: "Men's", show: canNhl, leagues: [
                                { id: "nhl", name: "NHL", full: "National Hockey League", color: "#8A94A6", to: "/nhl/schedule" },
                            ] },
                            { group: "Women's", show: true, leagues: [
                                { id: "pwhl", name: "PWHL", full: "Professional Women's Hockey League", color: "#9D4CDD", to: "/overview" },
                            ] },
                        ].filter((s) => s.show).map((section) => (
                            <div key={section.group} className="mb-4 last:mb-0" data-testid={`league-group-${section.group.replace(/[^a-z]/gi, "").toLowerCase()}`}>
                                <span className="block text-[10px] font-black uppercase tracking-[0.18em] text-white/40 mb-2">{section.group}</span>
                                <div className="space-y-2">
                                    {section.leagues.map((lg) => (
                                        <button key={lg.id} type="button" data-testid={`league-pick-${lg.id}`}
                                            onClick={() => { setSelectedLeague(lg.id); setLeaguePickerOpen(false); navigate(lg.to); }}
                                            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border transition-colors text-left ${selectedLeague === lg.id ? "border-white/40 bg-white/10" : "border-[#2A2F45] bg-white/5 hover:bg-white/10"}`}>
                                            <span className="h-10 w-10 rounded-lg flex items-center justify-center shrink-0" style={{ background: `${lg.color}22`, color: lg.color }}>
                                                <Trophy className="h-5 w-5" />
                                            </span>
                                            <span className="flex-1">
                                                <span className="block text-sm font-black uppercase tracking-wide text-white">{lg.name}</span>
                                                <span className="block text-[11px] text-[#94A3B8]">{lg.full}</span>
                                            </span>
                                            {selectedLeague === lg.id && <span className="text-[10px] font-bold uppercase tracking-wider text-[#22C55E]">Selected</span>}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                        <div className="mt-5 flex items-center justify-end">
                            <button type="button" data-testid="league-picker-close" onClick={() => setLeaguePickerOpen(false)} className="px-4 py-2 rounded-md bg-[#1E2233] hover:bg-[#2A2F45] text-white text-xs font-bold uppercase tracking-wider">Close</button>
                        </div>
                    </div>
                </div>
            )}
            {starMapOpen && (
                <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4" data-testid="star-map-modal" onClick={() => setStarMapOpen(false)}>
                    <div className="w-full max-w-md rounded-2xl border border-[#1E2233] bg-[#0E0F16] shadow-2xl p-6" onClick={(e) => e.stopPropagation()}>
                        <div className="flex items-center gap-2.5 mb-1">
                            <img src={ROSTERLY_WORDMARK} alt="Rosterly" className="h-6 w-auto object-contain" data-testid="star-map-logo" />
                            <Settings className="h-5 w-5 text-[#F5B301]" />
                            <h3 className="text-lg font-black uppercase tracking-wide text-white">Shortcuts</h3>
                        </div>
                        <p className="text-sm text-[#94A3B8] mb-4">
                            Every keyboard shortcut on the site. Press a key anywhere to jump — favourite pages with the <span className="text-[#F5B301] font-bold">★</span> star or Shift-click.
                        </p>

                        {/* Number-key jumps — every 1–0 binding + favourites without a key. */}
                        <div className="mb-5" data-testid="shortcuts-numbers">
                            <div className="text-[10px] uppercase tracking-wider text-white/45 font-bold mb-2">Number keys · 1–0</div>
                            <p className="text-[10px] text-white/35 mb-2 -mt-1">Hold a number, then click a tab in the nav to pin it. Press the number anywhere to jump.</p>
                            {(() => {
                                const eff = { ...keybinds, ...forcedBinds };
                                const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].filter((k) => eff[k]);
                                const unbound = (favPages || []).filter((f) => !Object.values(eff).includes(f.to));
                                if (!keys.length && !unbound.length) return <p className="text-xs text-white/40">No number shortcuts yet. Favourite a page, then hold a number and click it in the nav to pin it.</p>;
                                return (
                                    <div className="space-y-1.5 max-h-56 overflow-y-auto pr-1">
                                        {keys.map((k) => {
                                            const to = eff[k];
                                            const isForced = forcedBinds[k] !== undefined;
                                            const locked = isForced && !ownerEditMode;
                                            return (
                                                <div key={k} data-testid={`shortcut-key-${k}`} className="flex items-center gap-2 rounded-lg border border-[#2A2F45] bg-white/5 px-2.5 py-2">
                                                    <kbd className="h-6 w-6 inline-flex items-center justify-center rounded bg-[#0A0B10] border border-white/15 text-[11px] font-black text-white shrink-0">{k}</kbd>
                                                    {isForced && <Lock className="h-3 w-3 text-[#F6C453] shrink-0" />}
                                                    <span className="flex-1 text-xs font-bold uppercase tracking-wide text-white truncate">{pageLabelFor(to)}</span>
                                                    {!locked && <button type="button" data-testid={`shortcut-key-remove-${k}`} title="Clear this key"
                                                        onClick={() => { if (isForced && ownerEditMode) { unforceKeybind(k); } else { clearKeybind(k); } }}
                                                        className="shrink-0 h-6 w-6 flex items-center justify-center rounded-md text-[#F87171] hover:bg-[#F87171]/15"><X className="h-3.5 w-3.5" /></button>}
                                                </div>
                                            );
                                        })}
                                        {unbound.map((f) => (
                                            <div key={f.to} data-testid={`shortcut-fav-${f.to}`} className="flex items-center gap-2 rounded-lg border border-[#2A2F45] bg-white/5 px-2.5 py-2">
                                                <Star className="h-3.5 w-3.5 text-[#F5B301] shrink-0" />
                                                <span className="flex-1 text-xs font-bold uppercase tracking-wide text-white/80 truncate">{f.label}</span>
                                                <span className="text-[9px] uppercase tracking-wider text-white/35 shrink-0">no key</span>
                                                <button type="button" data-testid={`shortcut-fav-remove-${f.to}`} title="Remove favourite"
                                                    onClick={() => { if (Object.values(forcedBinds).includes(f.to) && !ownerEditMode) { toast("This favourite is locked by the owner."); return; } clearTier("page", f.to); }}
                                                    className="shrink-0 h-6 w-6 flex items-center justify-center rounded-md text-[#F87171] hover:bg-[#F87171]/15"><X className="h-3.5 w-3.5" /></button>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })()}
                        </div>

                        {/* Power shortcuts — every combo the account can use. */}
                        <div className="mb-1" data-testid="shortcuts-power">
                            <div className="text-[10px] uppercase tracking-wider text-white/45 font-bold mb-2">Power shortcuts</div>
                            {(() => {
                                const comboOk = { "/admin": hasAdminAccess, "/business": canBusiness, "/creator": canCreate, "/account": !!user, "/owner": isOwner, "/portal": canBusiness, "toggle-admin": hasAdminAccess, "toggle-business": canBusiness };
                                const cLabel = { "/admin": "Admin Panel", "/business": "Business", "/creator": "Studio", "/account": "My Account", "/owner": "Owner Center", "/portal": "Business Portal", "toggle-admin": "Toggle Admin View", "toggle-business": "Toggle Business View" };
                                const combos = settings?.kbd_config?.combos || {};
                                const rows = [["F", "", "Open this Shortcuts panel"], ["Home", "", "Landing page"], ["Ctrl", "Shift", "Search"]];
                                if (isOwner || hasAdminAccess) rows.push(["Alt", "1", "Reorganise Nav Bar 1"]);
                                Object.entries(combos.ctrl || {}).forEach(([k, v]) => { if (comboOk[v] !== false && v) rows.push(["Ctrl", k, cLabel[v] || v]); });
                                Object.entries(combos.shift || {}).forEach(([k, v]) => { if (comboOk[v] !== false && v) rows.push(["Shift", k, cLabel[v] || v]); });
                                return (
                                    <div className="space-y-1.5">
                                        {rows.map(([mod, k, label], i) => (
                                            <div key={i} data-testid={`shortcut-power-${i}`} className="flex items-center gap-2 text-xs rounded-lg border border-[#2A2F45] bg-white/5 px-2.5 py-2">
                                                <kbd className="px-1.5 h-6 inline-flex items-center rounded bg-[#0A0B10] border border-white/15 text-[10px] text-white/80">{mod}</kbd>
                                                {k && <><span className="text-white/25">+</span><kbd className="h-6 w-6 inline-flex items-center justify-center rounded bg-[#0A0B10] border border-white/15 text-[10px] text-white/80">{k}</kbd></>}
                                                <span className="ml-1 text-white/80 font-semibold">{label}</span>
                                            </div>
                                        ))}
                                    </div>
                                );
                            })()}
                        </div>

                        <div className="mt-5 flex items-center justify-end">
                            <button type="button" data-testid="star-map-close" onClick={() => setStarMapOpen(false)} className="px-4 py-2 rounded-md bg-[#1E2233] hover:bg-[#2A2F45] text-white text-xs font-bold uppercase tracking-wider">Done</button>
                        </div>
                    </div>
                </div>
            )}


            {/* Desktop subtab bar — shows the hovered/active section's subtabs
                (PWHL / Insights / Leagues). Replaces the old hover dropdowns. */}
            {!navsHidden && !searchActive && !leagueBarOpen && modeNavs.length > 0 && (
                <div ref={subnavRef} className="hidden lg:block sticky top-[var(--hdr-h,104px)] z-40 bg-[#0A0B10]/92 backdrop-blur-xl border-b border-[#1E2233]" data-testid="mode-nav-layer">
                    <div className="w-full px-4 md:px-8 lg:px-12">
                        <div className="flex flex-wrap items-center justify-center gap-1.5 py-2">
                            {modeNavs.map((nav, gi) => (
                                <React.Fragment key={nav.label}>
                                    {gi > 0 && <span className="w-px h-5 bg-white/15 mx-2" aria-hidden="true" />}
                                    <span className="px-1.5 text-[10px] font-black uppercase tracking-[0.15em]" style={{ color: nav._accent }} data-testid={`mode-nav-label-${nav.label.toLowerCase()}`}>{nav.label}</span>
                                    {nav.children.filter((c) => !c.heading).map((c) => {
                                        const hasQuery = c.to.includes("?");
                                        const baseTo = c.to.split("?")[0];
                                        const isActiveSub = hasQuery ? (location.pathname + location.search === c.to) : (location.pathname === baseTo && !location.search);
                                        return (
                                            <Link key={`${nav.label}-${c.to}`} to={c.to}
                                                data-testid={`mode-nav-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                                                style={isActiveSub ? { background: nav._accent, color: nav._dark ? "#0A0B10" : "#fff" } : undefined}
                                                className={`px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider transition-colors ${isActiveSub ? "" : "bg-white/10 border border-white/30 text-white hover:bg-white/20"}`}>
                                                {c.label}
                                            </Link>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {false && subnavLink && subnavLink.label === "PWHL" && (() => {
                const curTab = new URLSearchParams(location.search).get("tab") || (location.pathname.startsWith("/teams") ? "standings" : null);
                const isActive = (to) => {
                    if (to.includes("?tab=")) {
                        const base = to.split("?")[0];
                        const t = new URLSearchParams(to.split("?")[1]).get("tab");
                        return location.pathname === base && curTab === t;
                    }
                    const base = to.split("?")[0];
                    return location.pathname === base;
                };
                const ovActive = isActive(PWHL_OVERVIEW_TAB.to);
                const OvIcon = iconForTo(PWHL_OVERVIEW_TAB.to);
                const _tm = /^\/teams\/([^/?]+)/.exec(location.pathname);
                const _tq = new URLSearchParams(location.search).get("team");
                const ctxTeamId = _tq || (_tm ? _tm[1] : null);
                const bigTo = ctxTeamId ? `/teams?tab=overview&team=${ctxTeamId}` : PWHL_OVERVIEW_TAB.to;
                const bigActive = ovActive || (!!ctxTeamId && curTab === "overview");
                const TabChip = ({ t, color }) => {
                    const Icon = iconForTo(t.to);
                    const active = isActive(t.to);
                    // Selected = low-opacity fill in the section colour (team-strip style).
                    // Only the ACTIVE chip is coloured — others stay muted so a single tab
                    // reads as selected (not the whole section).
                    return (
                        <Link to={t.to} data-testid={`nav-sub-${t.id}`} title={t.l}
                            style={active ? { background: `${color}26`, borderColor: `${color}59` } : undefined}
                            className={`group flex items-center gap-1.5 px-2.5 py-1 rounded-md transition-colors border ${active ? "text-white" : "border-white/10 text-[#94A3B8] hover:text-white hover:border-white/25"}`}>
                            <Icon className="h-3.5 w-3.5 shrink-0" strokeWidth={2} style={active ? { color } : undefined} />
                            <span className="text-[9px] font-bold uppercase tracking-wider leading-none whitespace-nowrap">{t.l}</span>
                        </Link>
                    );
                };
                // Section title — styled exactly like the Overview button (non-clickable).
                const TitleChip = ({ sec }) => (
                    <div className="row-span-3 self-stretch shrink-0 w-[96px] flex flex-col items-center justify-center gap-1.5 px-2 rounded-lg border select-none"
                        style={{ borderColor: `${sec.color}66`, background: `${sec.color}14`, color: sec.color }} data-testid={`pwhl-group-title-${sec.key}`}>
                        {sec.isLogo ? (
                            <BrandImg alt="Rosterly" className="h-9 w-auto max-w-[80px] object-contain" />
                        ) : (<>
                            <sec.Icon className="h-6 w-6" strokeWidth={2} />
                            <span className="text-[11px] font-black uppercase tracking-[0.12em] leading-none text-center">{sec.title}</span>
                        </>)}
                    </div>
                );
                return (
                    <div className="hidden lg:block sticky top-16 z-40 bg-[#0A0B10]/92 backdrop-blur-xl border-b border-[#1E2233]"
                        data-testid="desktop-subnav-pwhl" onMouseEnter={() => setHover("PWHL")} onMouseLeave={scheduleClearHover}>
                        <div className="w-full px-4 md:px-6 lg:px-8">
                            <div className="flex items-stretch justify-between gap-3 py-2 overflow-x-auto">
                                {/* Overview (PWHL) — 2 columns wide × 3 rows tall single cell. */}
                                <Link to={bigTo} data-testid="nav-sub-overview" title={ctxTeamId ? "PWHL — Team Overview" : "PWHL — League Overview"}
                                    style={bigActive ? { background: "#2DD4BF26", borderColor: "#2DD4BF59", color: "#fff" } : undefined}
                                    className={`shrink-0 w-[132px] self-stretch flex flex-col items-center justify-center gap-1.5 px-4 rounded-lg border transition-colors ${bigActive ? "" : "border-[#2DD4BF]/40 text-[#2DD4BF] hover:bg-[#2DD4BF]/10"}`}>
                                    <OvIcon className="h-7 w-7" strokeWidth={2} />{/* PWHL keeps its own icon during team sort */}
                                    <span className="text-[12px] font-black uppercase tracking-[0.14em] leading-none">PWHL</span>
                                </Link>
                                {/* Each section: title button (3-row tall, like Overview) + its tabs in a 3-row grid. */}
                                {PWHL_SECTIONS.map((sec) => (
                                    <div key={sec.key} className="grid grid-flow-col gap-1 shrink-0" style={{ gridTemplateRows: "repeat(3, minmax(0, 1fr))" }} data-testid={`pwhl-group-${sec.key}`}>
                                        <TitleChip sec={sec} />
                                        {sec.tabs.filter((t) => (!t.owner || isOwner) && (!t.admin || ["admin", "owner"].includes(user?.role))).map((t) => <TabChip key={t.id} t={t} color={sec.color} />)}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* Access areas (Admin/Business/Creator/Owner) now live as inline tiles in the
                main PwhlSectionsBar — the old AccessNavBar row is removed to avoid a duplicate nav. */}


            {!navsHidden && !searchActive && !leagueBarOpen && subnavLink && subnavLink.children && subnavLink.label !== "PWHL" && subnavLink.label !== "Insights" && (
                <div
                    ref={subnavRef}
                    className="hidden lg:block sticky top-[var(--hdr-h,104px)] z-40 bg-[#0A0B10]/92 backdrop-blur-xl border-b border-[#1E2233]"
                    data-testid={`desktop-subnav-${subnavLink.label.toLowerCase()}`}
                    onMouseEnter={() => setHover(subnavLink.label)}
                    onMouseLeave={scheduleClearHover}
                >
                    <div className="w-full px-4 md:px-8 lg:px-12">
                        <div className="flex flex-wrap items-center justify-center gap-1.5 py-2">
                            {(subnavLink.socials ? socialsChildren : subnavLink.children).map((c) => {
                                if (c.heading) return <span key={`h-${c.heading}`} className="pl-2 pr-1 text-[10px] font-bold uppercase tracking-wider text-[#F5C518]/80">{c.heading}</span>;
                                if (subnavLink.socials) {
                                    const Icon = c.Icon;
                                    const tid = `nav-sub-${(c.key || c.label).toLowerCase().replace(/\s+/g, "-")}`;
                                    const base = "px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider inline-flex items-center gap-1.5 border transition-colors";
                                    const inner = <>{Icon ? <Icon className="w-3.5 h-3.5" /> : null} {c.label}</>;
                                    if (c.disabled) return <span key={tid} data-testid={tid} title={`${c.label} — coming soon`} className={`${base} bg-black/25 border-white/10 text-white/25 cursor-default`}>{inner}</span>;
                                    if (c.to) return <Link key={tid} to={c.to} data-testid={tid} className={`${base} border-white/12 text-[#94A3B8] hover:text-white`} style={{ borderColor: `${c.color}55` }}>{inner}</Link>;
                                    return <a key={tid} href={c.href} target="_blank" rel="noreferrer" data-testid={tid} className={`${base} hover:brightness-125`} style={{ color: c.color, background: `${c.color}1A`, borderColor: `${c.color}55` }}>{inner}</a>;
                                }
                                const hasQuery = c.to.includes("?");
                                const baseTo = c.to.split("?")[0];
                                const childTab = hasQuery ? new URLSearchParams(c.to.split("?")[1]).get("tab") : null;
                                // Section landing links sometimes drop the ?tab=… query (e.g. PWHL → /teams).
                                // The page then falls back to its own default tab, so mirror that here so the
                                // matching sub-pill still highlights.
                                const DEFAULT_TAB = { "/teams": "standings" };
                                const curTab = new URLSearchParams(location.search).get("tab") || DEFAULT_TAB[baseTo] || null;
                                const isActiveSub = hasQuery
                                    ? (location.pathname === baseTo && curTab === childTab)
                                    : ((location.pathname === baseTo) && !location.search);
                                const childAdmin = subnavLink.label === "Admin" || (adminMode && hasAdminAccess && ADMIN_ROUTES.has(c.to));
                                const subAccent = subnavLink.label === "Owner" ? "#F6C453" : subnavLink.label === "Business" ? "#22C55E" : subnavLink.label === "Control" ? "#94A3B8" : "#9D4CDD";
                                const darkText = subnavLink.label === "Owner" || subnavLink.label === "Business" || subnavLink.label === "Control";
                                return (
                                    <Link
                                        key={c.to}
                                        to={c.to}
                                        data-testid={`nav-sub-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        data-admin-aware={childAdmin ? "true" : "false"}
                                        style={isActiveSub ? { background: subAccent, color: darkText ? "#0A0B10" : "#fff" } : undefined}
                                        className={`px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider transition-colors ${
                                            isActiveSub
                                                ? ""
                                                : childAdmin
                                                ? "bg-white/10 border border-white/50 text-white hover:bg-white/20"
                                                : "bg-black/25 border border-white/10 text-[#94A3B8] hover:text-white"
                                        }`}
                                    >
                                        {c.label}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* Teams subnav — two rows: individual-team subtabs + the team logo
                strip (acts as its own selector bar). Shows on Teams hover or any
                /teams/:id page. */}
            {!navsHidden && !searchActive && !leagueBarOpen && showTeamsSubnav && (
                <div
                    ref={subnavRef}
                    className="hidden lg:block sticky top-[var(--hdr-h,104px)] z-40 bg-[#0A0B10]/92 backdrop-blur-xl border-b border-[#1E2233]"
                    data-testid="desktop-subnav-teams"
                    onMouseEnter={() => setHover("Teams")}
                    onMouseLeave={scheduleClearHover}
                >
                    <div className="flex flex-col w-full px-4 md:px-8 lg:px-12">
                        <div className="order-2 flex flex-wrap items-center justify-center gap-1.5 pb-2 pt-1.5 border-t border-[#1E2233]/70">
                            {teamSubtabs.map((t) => {
                                const isActiveSub = !!teamMatch && curTeamTab === t.k;
                                return (
                                    <Link
                                        key={t.k}
                                        to={`/teams/${teamTarget}?tab=${t.k}`}
                                        data-testid={`nav-team-sub-${t.k}`}
                                        className={`px-3 py-1.5 rounded-md text-xs font-bold uppercase tracking-wider transition-colors ${
                                            isActiveSub ? "bg-[#9D4CDD] text-white" : "bg-black/25 border border-white/10 text-[#94A3B8] hover:text-white"
                                        }`}
                                    >
                                        {t.l}
                                    </Link>
                                );
                            })}
                        </div>
                        <div className="order-1 flex flex-wrap items-center justify-center gap-1.5 py-2.5" data-testid="teams-logo-strip">
                            {orderedNavTeams.map((t) => {
                                const isCur = curTeamId === t.id;
                                const col = t.primary_color || TEAM_INFO[t.id]?.color || "#9D4CDD";
                                return (
                                    <Link
                                        key={t.id}
                                        to={`/teams/${t.id}?tab=${curTeamTab}`}
                                        data-testid={`teams-logo-${t.id}`}
                                        title={t.name}
                                        style={isCur ? { background: `${col}26`, borderColor: `${col}59` } : undefined}
                                        className={`inline-flex items-center gap-1.5 pl-1.5 pr-3 py-1.5 text-[11px] font-bold uppercase tracking-wider rounded-lg border transition-colors ${
                                            isCur ? "text-white"
                                                : adminMode && hasAdminAccess ? "bg-white/10 text-white border-white"
                                                : "bg-black/25 border-white/10 text-[#94A3B8] hover:text-white"
                                        }`}
                                    >
                                        <TeamBadge teamId={t.id} size="xs" asLink={false} />
                                        {TEAM_INFO[t.id]?.abbr || t.abbreviation || t.id.toUpperCase()}
                                    </Link>
                                );
                            })}
                        </div>

                    </div>
                </div>
            )}

            {/* The team sort/pick now lives INSIDE the tab nav bar (below), not
                as its own standalone bar. Keep the ref so --teambar-h → 0. */}
            <div ref={teamBarRef} />

            {/* Tab nav bar — team sort/pick + the page's own toggles.
                Hidden when the Eye toggle is CLOSED (no page toggles / nav bar 3). */}
            {!searchActive && !leagueBarOpen && !navsHidden && <GameCentreSubNav widthClass={borderMode === "extended" || wideSubNav ? "max-w-none" : "max-w-[1500px]"} wide={wideSubNav} />}

            <main data-testid="page-content" style={(!framePreview && pageScale !== 1) ? { zoom: pageScale } : undefined} className={`w-full flex-1 px-4 md:px-8 lg:px-12 py-6 md:py-10 pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-10 overflow-x-clip min-w-0 ${borderMode === "extended" ? "max-w-none" : "mx-auto max-w-[1500px]"}`}>
                {framePreview
                    ? <DeviceFrame device={device} orientation={orientation} scale={draftScaleVal} />
                    : children}
            </main>

            <footer className={`hidden lg:block border-t border-[#1E2233] mt-16 bg-[#08090D] ${framePreview ? "!hidden" : ""}`} data-testid="site-footer">
                {betaOn && (
                    <div className="bg-[#9D4CDD]/10 border-b border-[#9D4CDD]/25" data-testid="beta-info-bar">
                        <div className="w-full px-4 md:px-8 lg:px-12 py-3 flex items-center gap-2.5">
                            <span className="inline-flex items-center px-1.5 py-0.5 rounded bg-[#9D4CDD] text-white text-[9px] font-black uppercase tracking-[0.15em] shrink-0">Beta</span>
                            <p className="text-xs text-[#C4A5F4] leading-relaxed">{betaMsg}</p>
                        </div>
                    </div>
                )}
                <div className="w-full px-4 md:px-8 lg:px-12 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                        {/* Brand */}
                        <div className="md:col-span-5 lg:col-span-6">
                            <BrandImg alt={siteName} className="h-10 w-auto object-contain" data-testid="footer-brand-logo" />
                            <p className="text-xs text-[#64748B] mt-5 max-w-md leading-relaxed">
                                © 2026 {siteName}.
                            </p>
                        </div>
                        {/* Explore links */}
                        <div className="md:col-span-4 lg:col-span-3">
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[#475569] font-black mb-3">Explore</div>
                            <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-[12px] uppercase tracking-wider text-[#94A3B8] font-bold" data-testid="footer-links">
                                <Link to="/teams?tab=leaderboards" className="hover:text-[#9D4CDD] transition-colors">Leaderboards</Link>
                                <Link to="/records" className="hover:text-[#9D4CDD] transition-colors" data-testid="footer-records-link">Records &amp; Milestones</Link>
                                <Link to="/draft" className="hover:text-[#9D4CDD] transition-colors">Draft</Link>
                                <Link to="/transfers" className="hover:text-[#9D4CDD] transition-colors">History</Link>
                                <Link to="/news" className="hover:text-[#9D4CDD] transition-colors">News</Link>
                                <Link to="/videos" className="hover:text-[#9D4CDD] transition-colors">Videos</Link>
                                <Link to="/roadmap" className="hover:text-[#9D4CDD] transition-colors">Roadmap</Link>
                                <Link to="/rules" className="hover:text-[#9D4CDD] transition-colors" data-testid="footer-rules-link">Rules &amp; Penalties</Link>
                                <Link to="/overview" className="hover:text-[#9D4CDD] transition-colors">Overview</Link>
                            </div>
                        </div>
                        {/* Legal */}
                        <div className="md:col-span-3 lg:col-span-2">
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[#475569] font-black mb-3">Legal</div>
                            <div className="flex flex-col gap-2 text-[12px] uppercase tracking-wider text-[#94A3B8] font-bold" data-testid="footer-legal-links">
                                <Link to="/terms" className="hover:text-[#9D4CDD] transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
                                <Link to="/privacy" className="hover:text-[#9D4CDD] transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
                                <Link to="/contact" className="hover:text-[#9D4CDD] transition-colors">Contact Us</Link>
                            </div>
                        </div>
                        {/* Disclaimer */}
                        <div className="md:col-span-3 lg:col-span-1">
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[#475569] font-black mb-3">Disclaimer</div>
                            <p className="text-[11px] text-[#64748B] leading-relaxed" data-testid="footer-disclaimer">
                                {siteName} is an independent women&apos;s hockey resource and is not affiliated with or endorsed by any league, team, university, or governing body featured on this website.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
            {!framePreview && <MobileBottomNav />}
            <ScheduleDeepLinks />
            <MyAccountModal />
            <OwnerToolModal />
            {!framePreview && <CookieNotice />}
            {!framePreview && <LegalGate />}
        </div>
        </GameNavProvider>
        </SortByTeamProvider>
        </MobileNavProvider>
    );
};

export default Layout;
